// This file is auto-generated by @hey-api/openapi-ts

export const $AIChatRelatedData = {
    type: 'object',
    title: 'AIChatRelatedData',
    properties: {
        ai_chat_session_uuid: {
            type: 'string',
            nullable: true
        },
        ai_chat_session_message_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $AIChatSession = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        messages: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSessionMessage'
            },
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        session_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SessionStateEnum'
                }
            ],
            readOnly: true
        },
        started_by_user: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_explanation: {
            type: 'string',
            readOnly: true
        },
        system_rating_improvement_suggestions: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'messages', 'session_state', 'started_by_user', 'system_rating', 'system_rating_explanation', 'system_rating_improvement_suggestions', 'uuid']
} as const;

export const $AIChatSessionMessage = {
    type: 'object',
    title: 'AIChatSessionMessage',
    properties: {
        content: {
            type: 'string'
        },
        role: {
            '$ref': '#/components/schemas/AIChatSessionMessageRoleEnum'
        },
        created_at: {
            type: 'string',
            nullable: true
        },
        uuid: {
            type: 'string',
            nullable: true
        },
        user_uuid: {
            type: 'string',
            nullable: true
        },
        context: {
            '$ref': '#/components/schemas/CaseAiContext',
            nullable: true
        },
        organization_context: {
            '$ref': '#/components/schemas/OrganizationAiContext',
            nullable: true
        }
    },
    required: ['content', 'role']
} as const;

export const $AIChatSessionMessageRoleEnum = {
    type: 'string',
    enum: ['system', 'user', 'assistant']
} as const;

export const $AIChatSessionRequest = {
    type: 'object',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        }
    },
    required: ['case_uuid']
} as const;

export const $AIChatSessionSendMessageRequestRequest = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            minLength: 1,
            description: 'The message to send to the AI chat session.'
        }
    },
    required: ['content']
} as const;

export const $AIChatSessionSendMessageResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string'
        }
    },
    required: ['message']
} as const;

export const $ActaportDataRequest = {
    type: 'object',
    properties: {
        clerk: {
            type: 'string',
            minLength: 1
        },
        assistant: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['assistant', 'clerk', 'entities_with_relationships', 'title']
} as const;

export const $AdvoluxDataRequest = {
    type: 'object',
    properties: {
        label: {
            type: 'string',
            minLength: 1
        },
        caseGroup: {
            type: 'integer',
            nullable: true
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships', 'label']
} as const;

export const $AdvowareDataRequest = {
    type: 'object',
    properties: {
        rubrum: {
            type: 'string',
            minLength: 1
        },
        lawField: {
            type: 'string',
            minLength: 1
        },
        clerk: {
            type: 'string',
            minLength: 1
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['clerk', 'entities_with_relationships', 'lawField', 'rubrum']
} as const;

export const $AiAnalysisRelatedData = {
    type: 'object',
    title: 'AiAnalysisRelatedData',
    properties: {
        ai_augmentation_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $AiAugmentedByMapperKeysEnum = {
    enum: ['entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip', 'law.criminal_law_amount_of_daily_rates', 'law.criminal_law_applicable_laws', 'law.criminal_law_charge_description', 'law.criminal_law_complaint', 'law.criminal_law_criminal_warrant', 'law.criminal_law_damage_description', 'law.criminal_law_damage_value', 'law.criminal_law_date_of_offense', 'law.criminal_law_duration_of_prison_sentence', 'law.criminal_law_evidence_location', 'law.criminal_law_evidence', 'law.criminal_law_incident_description', 'law.criminal_law_indictment_date', 'law.criminal_law_indictment_delivery_date', 'law.criminal_law_indictment', 'law.criminal_law_legal_classification_of_offense', 'law.criminal_law_means_of_evidence', 'law.criminal_law_number_of_daily_rates', 'law.criminal_law_offense_type', 'law.criminal_law_penalty_infromation', 'law.criminal_law_physical_evidence', 'law.criminal_law_place_of_offense', 'law.criminal_law_police_file_number', 'law.criminal_law_preliminary_proceedings_date', 'law.criminal_law_prison_sentence', 'law.criminal_law_probation', 'law.criminal_law_prosecution_file_number', 'law.criminal_law_report_date', 'law.criminal_law_report_time', 'law.criminal_law_time_of_offense', 'law.debt_collection_law_invoice_amount', 'law.debt_collection_law_invoice_date', 'law.debt_collection_law_invoice_ground', 'law.debt_collection_law_invoice', 'law.debt_collection_law_invoice_number', 'law.debt_collection_law_invoice_recipient', 'law.debt_collection_law_invoice_tax_number', 'law.external_case_id', 'law.family_law_average_net_income', 'law.family_law_birth_certificate', 'law.family_law_birth_register_number', 'law.family_law_birth_register_office_location', 'law.family_law_children', 'law.family_law_date_of_marriage', 'law.family_law_divorce_application', 'law.family_law_divorce_settlement_agreement', 'law.family_law_marriage_certificate', 'law.family_law_marriage_contract_date', 'law.family_law_marriage_contract', 'law.family_law_marriage_register_number', 'law.family_law_registry_office_location', 'law.family_law_separation_date', 'law.field', 'law.generic_document', 'law.inheritance_law_certificate_of_inheritance_applicable_law', 'law.inheritance_law_certificate_of_inheritance_date_death', 'law.inheritance_law_certificate_of_inheritance_date', 'law.inheritance_law_certificate_of_inheritance', 'law.inheritance_law_certificate_of_inheritance_number', 'law.inheritance_law_certificate_of_inheritance_place_of_death', 'law.inheritance_law_death_certificate_date_death', 'law.inheritance_law_death_certificate_date', 'law.inheritance_law_death_certificate', 'law.inheritance_law_death_certificate_number', 'law.inheritance_law_death_certificate_place_death', 'law.inheritance_law_death_certificate_place', 'law.inheritance_law_death_certificate_time_death', 'law.inheritance_law_estate_inventory_amount', 'law.inheritance_law_estate_inventory_date', 'law.inheritance_law_estate_inventory_status', 'law.inheritance_law_inheritance_contract_date', 'law.inheritance_law_inheritance_contract', 'law.inheritance_law_lasting_power_of_attorney_date', 'law.inheritance_law_lasting_power_of_attorney', 'law.inheritance_law_list_of_estate', 'law.inheritance_law_living_will', 'law.inheritance_law_patient_enrollment_date', 'law.inheritance_law_testament_date', 'law.inheritance_law_will', 'law.labor_law_beginning_of_employment', 'law.labor_law_child_allowances', 'law.labor_law_collective_agreement', 'law.labor_law_company_agreement', 'law.labor_law_different_place_of_work', 'law.labor_law_employee_probation_period_end_date', 'law.labor_law_fixed_term_contract_duration', 'law.labor_law_fixed_term_contract', 'law.labor_law_is_employee_in_probation_period', 'law.labor_law_job_title', 'law.labor_law_married', 'law.labor_law_monthly_gross_salary', 'law.labor_law_monthly_working_days', 'law.labor_law_notice_period', 'law.labor_law_payslip', 'law.labor_law_place_of_work', 'law.labor_law_settlement_agreement_date', 'law.labor_law_settlement_agreement', 'law.labor_law_signature_of_employer', 'law.labor_law_special_payments_amount', 'law.labor_law_special_payments', 'law.labor_law_special_protection_against_dismissal', 'law.labor_law_termination_access_to_termination_to_employee', 'law.labor_law_termination_agreement_date', 'law.labor_law_termination_agreement', 'law.labor_law_termination_agreement_severance_pay_amount', 'law.labor_law_termination_agreement_termination_date', 'law.labor_law_termination_date_effective', 'law.labor_law_termination_date', 'law.labor_law_termination_employer_more_than_10_employees', 'law.labor_law_termination_is_agreement_severance_pay', 'law.labor_law_termination', 'law.labor_law_vacation_days', 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee', 'law.labor_law_warning_letter_date', 'law.labor_law_warning_letter_incident_date', 'law.labor_law_warning_letter_incident_location', 'law.labor_law_warning_letter_incident_time', 'law.labor_law_warning_letter', 'law.labor_law_warning_letter_reason', 'law.labor_law_work_contract', 'law.labor_law_work_council', 'law.labor_law_work_hours_per_week', 'law.labor_law_yearly_gross_salary', 'law.residential_property_law_co_ownership_shares', 'law.residential_property_law_contract_date', 'law.residential_property_law_contract', 'law.residential_property_law_inventory', 'law.residential_property_law_land_register_address', 'law.residential_property_law_land_register_city', 'law.residential_property_law_land_register_number', 'law.residential_property_law_land_register_plot_of_land', 'law.social_law_application_arrival_date', 'law.social_law_application_date', 'law.social_law_notice_date', 'law.social_law_notice_of_objection_date', 'law.social_law_notice_of_objection', 'law.social_law_summary_grounds_opposition', 'law.tenancy_law_adress_rental_property', 'law.tenancy_law_advance_payment_service_charges', 'law.tenancy_law_description_of_rental_property', 'law.tenancy_law_duration_of_lease', 'law.tenancy_law_fixed_term_tenancy', 'law.tenancy_law_gross_rent', 'law.tenancy_law_lease_agreement', 'law.tenancy_law_location_in_rental_property', 'law.tenancy_law_net_rent', 'law.tenancy_law_rental_agreement_date', 'law.tenancy_law_rental_agreement', 'law.tenancy_law_rental_agreement_validity_end', 'law.tenancy_law_rental_agreement_validity_start', 'law.tenancy_law_staggered_rental_agreement', 'law.tenancy_law_start_of_lease', 'law.tenancy_law_total_rent', 'law.tenancy_law_unlimited_term_tenancy', 'law.topic', 'law.traffic_law_accident_date', 'law.traffic_law_accident_report', 'law.traffic_law_amount_of_fine', 'law.traffic_law_appeal_instruction', 'law.traffic_law_at_fault_driver_drivers_license_issued_by', 'law.traffic_law_at_fault_driver_drivers_license_valid_until', 'law.traffic_law_at_fault_driver_green_card_number', 'law.traffic_law_at_fault_driver_insurance_expiry_date', 'law.traffic_law_at_fault_driver_insurance_number', 'law.traffic_law_at_fault_driver_insurer', 'law.traffic_law_blood_alcohol_concentration', 'law.traffic_law_calculated_total_damage_costs', 'law.traffic_law_calculated_total_days', 'law.traffic_law_charges', 'law.traffic_law_daily_rate', 'law.traffic_law_damage_scope', 'law.traffic_law_date_of_accident', 'law.traffic_law_date_of_crime', 'law.traffic_law_date_of_fine', 'law.traffic_law_date_of_infraction', 'law.traffic_law_date_of_inspection', 'law.traffic_law_date_of_issue', 'law.traffic_law_date_of_offense', 'law.traffic_law_differencial_tax', 'law.traffic_law_driver_logbook_required', 'law.traffic_law_driving_ban_duration', 'law.traffic_law_driving_ban', 'law.traffic_law_evidence_infraction', 'law.traffic_law_expert_date', 'law.traffic_law_expert_report', 'law.traffic_law_expert_report_number', 'law.traffic_law_file_number', 'law.traffic_law_fine', 'law.traffic_law_fine_notice', 'law.traffic_law_gross_gross_replacement_value', 'law.traffic_law_gross_replacement_value', 'law.traffic_law_injured', 'law.traffic_law_insurance_holder', 'law.traffic_law_insurance', 'law.traffic_law_legal_basis_infraction', 'law.traffic_law_legal_basis', 'law.traffic_law_licenseplate_at_fault_driver', 'law.traffic_law_licenseplate', 'law.traffic_law_licenseplate_victim_driver', 'law.traffic_law_loss_of_use_per_day', 'law.traffic_law_mark_and_type_of_at_fault_driver', 'law.traffic_law_mark_and_type_of_victim_driver', 'law.traffic_law_merantile_value_loss', 'law.traffic_law_net_gross_replacement_value', 'law.traffic_law_net_replacement_value', 'law.traffic_law_number_of_daily_rates', 'law.traffic_law_offense_infraction_description', 'law.traffic_law_other_damages', 'law.traffic_law_payment_deadline', 'law.traffic_law_penalty_order', 'law.traffic_law_place_of_accident', 'law.traffic_law_place_of_crime', 'law.traffic_law_place_of_infraction', 'law.traffic_law_place_of_inspection', 'law.traffic_law_place_of_issue', 'law.traffic_law_place_of_offense', 'law.traffic_law_points_for_offense', 'law.traffic_law_police_case_number', 'law.traffic_law_procedure_costs', 'law.traffic_law_prosecution_number', 'law.traffic_law_regular_tax', 'law.traffic_law_repair_costs_with_vat', 'law.traffic_law_repair_costs_without_vat', 'law.traffic_law_repair_duration', 'law.traffic_law_replacement_value', 'law.traffic_law_reregistration_cost', 'law.traffic_law_residual_value', 'law.traffic_law_speed_allowed', 'law.traffic_law_speed_driven', 'law.traffic_law_speed_too_high', 'law.traffic_law_time_of_accident', 'law.traffic_law_time_of_crime', 'law.traffic_law_time_of_infraction', 'law.traffic_law_time_of_inspection', 'law.traffic_law_time_of_issue', 'law.traffic_law_time_of_offense', 'law.traffic_law_vehicle_age_months', 'law.traffic_law_vehicle_mileage', 'law.traffic_law_vehicle_type_and_brand', 'law.traffic_law_victim_driver_drivers_license_issued_by', 'law.traffic_law_victim_driver_green_card_number', 'law.traffic_law_victim_driver_insurance_expiry_date', 'law.traffic_law_victim_driver_insurance_number', 'law.traffic_law_victim_driver_insurer', 'law.traffic_law_victim_driver_license_valid_until', 'law.traffic_law_violated_section', 'law.traffic_law_violation_type', 'law.traffic_law_warning_fee_infraction', 'law.traffic_law_warning_notice'],
    type: 'string',
    description: `* \`entities.field.bank_name\` - entities.field.bank_name
* \`entities.field.bic\` - entities.field.bic
* \`entities.field.city\` - entities.field.city
* \`entities.field.company_legal_form\` - entities.field.company_legal_form
* \`entities.field.company_name\` - entities.field.company_name
* \`entities.field.company_register_court\` - entities.field.company_register_court
* \`entities.field.company_register_number\` - entities.field.company_register_number
* \`entities.field.company_tax_id\` - entities.field.company_tax_id
* \`entities.field.company_vat_id\` - entities.field.company_vat_id
* \`entities.field.date_of_birth\` - entities.field.date_of_birth
* \`entities.field.date_of_death\` - entities.field.date_of_death
* \`entities.field.email\` - entities.field.email
* \`entities.field.entity_type\` - entities.field.entity_type
* \`entities.field.fax\` - entities.field.fax
* \`entities.field.first_name\` - entities.field.first_name
* \`entities.field.iban\` - entities.field.iban
* \`entities.field.institution_name\` - entities.field.institution_name
* \`entities.field.is_entitled_to_deduct_vat\` - entities.field.is_entitled_to_deduct_vat
* \`entities.field.last_name\` - entities.field.last_name
* \`entities.field.legal_insurance_deductible_amount\` - entities.field.legal_insurance_deductible_amount
* \`entities.field.legal_insurance\` - entities.field.legal_insurance
* \`entities.field.legal_insurance_name\` - entities.field.legal_insurance_name
* \`entities.field.legal_insurance_number\` - entities.field.legal_insurance_number
* \`entities.field.marital_status\` - entities.field.marital_status
* \`entities.field.phone\` - entities.field.phone
* \`entities.field.specific_title\` - entities.field.specific_title
* \`entities.field.street\` - entities.field.street
* \`entities.field.street_number\` - entities.field.street_number
* \`entities.field.title\` - entities.field.title
* \`entities.field.website\` - entities.field.website
* \`entities.field.zip\` - entities.field.zip
* \`law.criminal_law_amount_of_daily_rates\` - law.criminal_law_amount_of_daily_rates
* \`law.criminal_law_applicable_laws\` - law.criminal_law_applicable_laws
* \`law.criminal_law_charge_description\` - law.criminal_law_charge_description
* \`law.criminal_law_complaint\` - law.criminal_law_complaint
* \`law.criminal_law_criminal_warrant\` - law.criminal_law_criminal_warrant
* \`law.criminal_law_damage_description\` - law.criminal_law_damage_description
* \`law.criminal_law_damage_value\` - law.criminal_law_damage_value
* \`law.criminal_law_date_of_offense\` - law.criminal_law_date_of_offense
* \`law.criminal_law_duration_of_prison_sentence\` - law.criminal_law_duration_of_prison_sentence
* \`law.criminal_law_evidence_location\` - law.criminal_law_evidence_location
* \`law.criminal_law_evidence\` - law.criminal_law_evidence
* \`law.criminal_law_incident_description\` - law.criminal_law_incident_description
* \`law.criminal_law_indictment_date\` - law.criminal_law_indictment_date
* \`law.criminal_law_indictment_delivery_date\` - law.criminal_law_indictment_delivery_date
* \`law.criminal_law_indictment\` - law.criminal_law_indictment
* \`law.criminal_law_legal_classification_of_offense\` - law.criminal_law_legal_classification_of_offense
* \`law.criminal_law_means_of_evidence\` - law.criminal_law_means_of_evidence
* \`law.criminal_law_number_of_daily_rates\` - law.criminal_law_number_of_daily_rates
* \`law.criminal_law_offense_type\` - law.criminal_law_offense_type
* \`law.criminal_law_penalty_infromation\` - law.criminal_law_penalty_infromation
* \`law.criminal_law_physical_evidence\` - law.criminal_law_physical_evidence
* \`law.criminal_law_place_of_offense\` - law.criminal_law_place_of_offense
* \`law.criminal_law_police_file_number\` - law.criminal_law_police_file_number
* \`law.criminal_law_preliminary_proceedings_date\` - law.criminal_law_preliminary_proceedings_date
* \`law.criminal_law_prison_sentence\` - law.criminal_law_prison_sentence
* \`law.criminal_law_probation\` - law.criminal_law_probation
* \`law.criminal_law_prosecution_file_number\` - law.criminal_law_prosecution_file_number
* \`law.criminal_law_report_date\` - law.criminal_law_report_date
* \`law.criminal_law_report_time\` - law.criminal_law_report_time
* \`law.criminal_law_time_of_offense\` - law.criminal_law_time_of_offense
* \`law.debt_collection_law_invoice_amount\` - law.debt_collection_law_invoice_amount
* \`law.debt_collection_law_invoice_date\` - law.debt_collection_law_invoice_date
* \`law.debt_collection_law_invoice_ground\` - law.debt_collection_law_invoice_ground
* \`law.debt_collection_law_invoice\` - law.debt_collection_law_invoice
* \`law.debt_collection_law_invoice_number\` - law.debt_collection_law_invoice_number
* \`law.debt_collection_law_invoice_recipient\` - law.debt_collection_law_invoice_recipient
* \`law.debt_collection_law_invoice_tax_number\` - law.debt_collection_law_invoice_tax_number
* \`law.external_case_id\` - law.external_case_id
* \`law.family_law_average_net_income\` - law.family_law_average_net_income
* \`law.family_law_birth_certificate\` - law.family_law_birth_certificate
* \`law.family_law_birth_register_number\` - law.family_law_birth_register_number
* \`law.family_law_birth_register_office_location\` - law.family_law_birth_register_office_location
* \`law.family_law_children\` - law.family_law_children
* \`law.family_law_date_of_marriage\` - law.family_law_date_of_marriage
* \`law.family_law_divorce_application\` - law.family_law_divorce_application
* \`law.family_law_divorce_settlement_agreement\` - law.family_law_divorce_settlement_agreement
* \`law.family_law_marriage_certificate\` - law.family_law_marriage_certificate
* \`law.family_law_marriage_contract_date\` - law.family_law_marriage_contract_date
* \`law.family_law_marriage_contract\` - law.family_law_marriage_contract
* \`law.family_law_marriage_register_number\` - law.family_law_marriage_register_number
* \`law.family_law_registry_office_location\` - law.family_law_registry_office_location
* \`law.family_law_separation_date\` - law.family_law_separation_date
* \`law.field\` - law.field
* \`law.generic_document\` - law.generic_document
* \`law.inheritance_law_certificate_of_inheritance_applicable_law\` - law.inheritance_law_certificate_of_inheritance_applicable_law
* \`law.inheritance_law_certificate_of_inheritance_date_death\` - law.inheritance_law_certificate_of_inheritance_date_death
* \`law.inheritance_law_certificate_of_inheritance_date\` - law.inheritance_law_certificate_of_inheritance_date
* \`law.inheritance_law_certificate_of_inheritance\` - law.inheritance_law_certificate_of_inheritance
* \`law.inheritance_law_certificate_of_inheritance_number\` - law.inheritance_law_certificate_of_inheritance_number
* \`law.inheritance_law_certificate_of_inheritance_place_of_death\` - law.inheritance_law_certificate_of_inheritance_place_of_death
* \`law.inheritance_law_death_certificate_date_death\` - law.inheritance_law_death_certificate_date_death
* \`law.inheritance_law_death_certificate_date\` - law.inheritance_law_death_certificate_date
* \`law.inheritance_law_death_certificate\` - law.inheritance_law_death_certificate
* \`law.inheritance_law_death_certificate_number\` - law.inheritance_law_death_certificate_number
* \`law.inheritance_law_death_certificate_place_death\` - law.inheritance_law_death_certificate_place_death
* \`law.inheritance_law_death_certificate_place\` - law.inheritance_law_death_certificate_place
* \`law.inheritance_law_death_certificate_time_death\` - law.inheritance_law_death_certificate_time_death
* \`law.inheritance_law_estate_inventory_amount\` - law.inheritance_law_estate_inventory_amount
* \`law.inheritance_law_estate_inventory_date\` - law.inheritance_law_estate_inventory_date
* \`law.inheritance_law_estate_inventory_status\` - law.inheritance_law_estate_inventory_status
* \`law.inheritance_law_inheritance_contract_date\` - law.inheritance_law_inheritance_contract_date
* \`law.inheritance_law_inheritance_contract\` - law.inheritance_law_inheritance_contract
* \`law.inheritance_law_lasting_power_of_attorney_date\` - law.inheritance_law_lasting_power_of_attorney_date
* \`law.inheritance_law_lasting_power_of_attorney\` - law.inheritance_law_lasting_power_of_attorney
* \`law.inheritance_law_list_of_estate\` - law.inheritance_law_list_of_estate
* \`law.inheritance_law_living_will\` - law.inheritance_law_living_will
* \`law.inheritance_law_patient_enrollment_date\` - law.inheritance_law_patient_enrollment_date
* \`law.inheritance_law_testament_date\` - law.inheritance_law_testament_date
* \`law.inheritance_law_will\` - law.inheritance_law_will
* \`law.labor_law_beginning_of_employment\` - law.labor_law_beginning_of_employment
* \`law.labor_law_child_allowances\` - law.labor_law_child_allowances
* \`law.labor_law_collective_agreement\` - law.labor_law_collective_agreement
* \`law.labor_law_company_agreement\` - law.labor_law_company_agreement
* \`law.labor_law_different_place_of_work\` - law.labor_law_different_place_of_work
* \`law.labor_law_employee_probation_period_end_date\` - law.labor_law_employee_probation_period_end_date
* \`law.labor_law_fixed_term_contract_duration\` - law.labor_law_fixed_term_contract_duration
* \`law.labor_law_fixed_term_contract\` - law.labor_law_fixed_term_contract
* \`law.labor_law_is_employee_in_probation_period\` - law.labor_law_is_employee_in_probation_period
* \`law.labor_law_job_title\` - law.labor_law_job_title
* \`law.labor_law_married\` - law.labor_law_married
* \`law.labor_law_monthly_gross_salary\` - law.labor_law_monthly_gross_salary
* \`law.labor_law_monthly_working_days\` - law.labor_law_monthly_working_days
* \`law.labor_law_notice_period\` - law.labor_law_notice_period
* \`law.labor_law_payslip\` - law.labor_law_payslip
* \`law.labor_law_place_of_work\` - law.labor_law_place_of_work
* \`law.labor_law_settlement_agreement_date\` - law.labor_law_settlement_agreement_date
* \`law.labor_law_settlement_agreement\` - law.labor_law_settlement_agreement
* \`law.labor_law_signature_of_employer\` - law.labor_law_signature_of_employer
* \`law.labor_law_special_payments_amount\` - law.labor_law_special_payments_amount
* \`law.labor_law_special_payments\` - law.labor_law_special_payments
* \`law.labor_law_special_protection_against_dismissal\` - law.labor_law_special_protection_against_dismissal
* \`law.labor_law_termination_access_to_termination_to_employee\` - law.labor_law_termination_access_to_termination_to_employee
* \`law.labor_law_termination_agreement_date\` - law.labor_law_termination_agreement_date
* \`law.labor_law_termination_agreement\` - law.labor_law_termination_agreement
* \`law.labor_law_termination_agreement_severance_pay_amount\` - law.labor_law_termination_agreement_severance_pay_amount
* \`law.labor_law_termination_agreement_termination_date\` - law.labor_law_termination_agreement_termination_date
* \`law.labor_law_termination_date_effective\` - law.labor_law_termination_date_effective
* \`law.labor_law_termination_date\` - law.labor_law_termination_date
* \`law.labor_law_termination_employer_more_than_10_employees\` - law.labor_law_termination_employer_more_than_10_employees
* \`law.labor_law_termination_is_agreement_severance_pay\` - law.labor_law_termination_is_agreement_severance_pay
* \`law.labor_law_termination\` - law.labor_law_termination
* \`law.labor_law_vacation_days\` - law.labor_law_vacation_days
* \`law.labor_law_wanring_letter_access_to_warning_letter_to_employee\` - law.labor_law_wanring_letter_access_to_warning_letter_to_employee
* \`law.labor_law_warning_letter_date\` - law.labor_law_warning_letter_date
* \`law.labor_law_warning_letter_incident_date\` - law.labor_law_warning_letter_incident_date
* \`law.labor_law_warning_letter_incident_location\` - law.labor_law_warning_letter_incident_location
* \`law.labor_law_warning_letter_incident_time\` - law.labor_law_warning_letter_incident_time
* \`law.labor_law_warning_letter\` - law.labor_law_warning_letter
* \`law.labor_law_warning_letter_reason\` - law.labor_law_warning_letter_reason
* \`law.labor_law_work_contract\` - law.labor_law_work_contract
* \`law.labor_law_work_council\` - law.labor_law_work_council
* \`law.labor_law_work_hours_per_week\` - law.labor_law_work_hours_per_week
* \`law.labor_law_yearly_gross_salary\` - law.labor_law_yearly_gross_salary
* \`law.residential_property_law_co_ownership_shares\` - law.residential_property_law_co_ownership_shares
* \`law.residential_property_law_contract_date\` - law.residential_property_law_contract_date
* \`law.residential_property_law_contract\` - law.residential_property_law_contract
* \`law.residential_property_law_inventory\` - law.residential_property_law_inventory
* \`law.residential_property_law_land_register_address\` - law.residential_property_law_land_register_address
* \`law.residential_property_law_land_register_city\` - law.residential_property_law_land_register_city
* \`law.residential_property_law_land_register_number\` - law.residential_property_law_land_register_number
* \`law.residential_property_law_land_register_plot_of_land\` - law.residential_property_law_land_register_plot_of_land
* \`law.social_law_application_arrival_date\` - law.social_law_application_arrival_date
* \`law.social_law_application_date\` - law.social_law_application_date
* \`law.social_law_notice_date\` - law.social_law_notice_date
* \`law.social_law_notice_of_objection_date\` - law.social_law_notice_of_objection_date
* \`law.social_law_notice_of_objection\` - law.social_law_notice_of_objection
* \`law.social_law_summary_grounds_opposition\` - law.social_law_summary_grounds_opposition
* \`law.tenancy_law_adress_rental_property\` - law.tenancy_law_adress_rental_property
* \`law.tenancy_law_advance_payment_service_charges\` - law.tenancy_law_advance_payment_service_charges
* \`law.tenancy_law_description_of_rental_property\` - law.tenancy_law_description_of_rental_property
* \`law.tenancy_law_duration_of_lease\` - law.tenancy_law_duration_of_lease
* \`law.tenancy_law_fixed_term_tenancy\` - law.tenancy_law_fixed_term_tenancy
* \`law.tenancy_law_gross_rent\` - law.tenancy_law_gross_rent
* \`law.tenancy_law_lease_agreement\` - law.tenancy_law_lease_agreement
* \`law.tenancy_law_location_in_rental_property\` - law.tenancy_law_location_in_rental_property
* \`law.tenancy_law_net_rent\` - law.tenancy_law_net_rent
* \`law.tenancy_law_rental_agreement_date\` - law.tenancy_law_rental_agreement_date
* \`law.tenancy_law_rental_agreement\` - law.tenancy_law_rental_agreement
* \`law.tenancy_law_rental_agreement_validity_end\` - law.tenancy_law_rental_agreement_validity_end
* \`law.tenancy_law_rental_agreement_validity_start\` - law.tenancy_law_rental_agreement_validity_start
* \`law.tenancy_law_staggered_rental_agreement\` - law.tenancy_law_staggered_rental_agreement
* \`law.tenancy_law_start_of_lease\` - law.tenancy_law_start_of_lease
* \`law.tenancy_law_total_rent\` - law.tenancy_law_total_rent
* \`law.tenancy_law_unlimited_term_tenancy\` - law.tenancy_law_unlimited_term_tenancy
* \`law.topic\` - law.topic
* \`law.traffic_law_accident_date\` - law.traffic_law_accident_date
* \`law.traffic_law_accident_report\` - law.traffic_law_accident_report
* \`law.traffic_law_amount_of_fine\` - law.traffic_law_amount_of_fine
* \`law.traffic_law_appeal_instruction\` - law.traffic_law_appeal_instruction
* \`law.traffic_law_at_fault_driver_drivers_license_issued_by\` - law.traffic_law_at_fault_driver_drivers_license_issued_by
* \`law.traffic_law_at_fault_driver_drivers_license_valid_until\` - law.traffic_law_at_fault_driver_drivers_license_valid_until
* \`law.traffic_law_at_fault_driver_green_card_number\` - law.traffic_law_at_fault_driver_green_card_number
* \`law.traffic_law_at_fault_driver_insurance_expiry_date\` - law.traffic_law_at_fault_driver_insurance_expiry_date
* \`law.traffic_law_at_fault_driver_insurance_number\` - law.traffic_law_at_fault_driver_insurance_number
* \`law.traffic_law_at_fault_driver_insurer\` - law.traffic_law_at_fault_driver_insurer
* \`law.traffic_law_blood_alcohol_concentration\` - law.traffic_law_blood_alcohol_concentration
* \`law.traffic_law_calculated_total_damage_costs\` - law.traffic_law_calculated_total_damage_costs
* \`law.traffic_law_calculated_total_days\` - law.traffic_law_calculated_total_days
* \`law.traffic_law_charges\` - law.traffic_law_charges
* \`law.traffic_law_daily_rate\` - law.traffic_law_daily_rate
* \`law.traffic_law_damage_scope\` - law.traffic_law_damage_scope
* \`law.traffic_law_date_of_accident\` - law.traffic_law_date_of_accident
* \`law.traffic_law_date_of_crime\` - law.traffic_law_date_of_crime
* \`law.traffic_law_date_of_fine\` - law.traffic_law_date_of_fine
* \`law.traffic_law_date_of_infraction\` - law.traffic_law_date_of_infraction
* \`law.traffic_law_date_of_inspection\` - law.traffic_law_date_of_inspection
* \`law.traffic_law_date_of_issue\` - law.traffic_law_date_of_issue
* \`law.traffic_law_date_of_offense\` - law.traffic_law_date_of_offense
* \`law.traffic_law_differencial_tax\` - law.traffic_law_differencial_tax
* \`law.traffic_law_driver_logbook_required\` - law.traffic_law_driver_logbook_required
* \`law.traffic_law_driving_ban_duration\` - law.traffic_law_driving_ban_duration
* \`law.traffic_law_driving_ban\` - law.traffic_law_driving_ban
* \`law.traffic_law_evidence_infraction\` - law.traffic_law_evidence_infraction
* \`law.traffic_law_expert_date\` - law.traffic_law_expert_date
* \`law.traffic_law_expert_report\` - law.traffic_law_expert_report
* \`law.traffic_law_expert_report_number\` - law.traffic_law_expert_report_number
* \`law.traffic_law_file_number\` - law.traffic_law_file_number
* \`law.traffic_law_fine\` - law.traffic_law_fine
* \`law.traffic_law_fine_notice\` - law.traffic_law_fine_notice
* \`law.traffic_law_gross_gross_replacement_value\` - law.traffic_law_gross_gross_replacement_value
* \`law.traffic_law_gross_replacement_value\` - law.traffic_law_gross_replacement_value
* \`law.traffic_law_injured\` - law.traffic_law_injured
* \`law.traffic_law_insurance_holder\` - law.traffic_law_insurance_holder
* \`law.traffic_law_insurance\` - law.traffic_law_insurance
* \`law.traffic_law_legal_basis_infraction\` - law.traffic_law_legal_basis_infraction
* \`law.traffic_law_legal_basis\` - law.traffic_law_legal_basis
* \`law.traffic_law_licenseplate_at_fault_driver\` - law.traffic_law_licenseplate_at_fault_driver
* \`law.traffic_law_licenseplate\` - law.traffic_law_licenseplate
* \`law.traffic_law_licenseplate_victim_driver\` - law.traffic_law_licenseplate_victim_driver
* \`law.traffic_law_loss_of_use_per_day\` - law.traffic_law_loss_of_use_per_day
* \`law.traffic_law_mark_and_type_of_at_fault_driver\` - law.traffic_law_mark_and_type_of_at_fault_driver
* \`law.traffic_law_mark_and_type_of_victim_driver\` - law.traffic_law_mark_and_type_of_victim_driver
* \`law.traffic_law_merantile_value_loss\` - law.traffic_law_merantile_value_loss
* \`law.traffic_law_net_gross_replacement_value\` - law.traffic_law_net_gross_replacement_value
* \`law.traffic_law_net_replacement_value\` - law.traffic_law_net_replacement_value
* \`law.traffic_law_number_of_daily_rates\` - law.traffic_law_number_of_daily_rates
* \`law.traffic_law_offense_infraction_description\` - law.traffic_law_offense_infraction_description
* \`law.traffic_law_other_damages\` - law.traffic_law_other_damages
* \`law.traffic_law_payment_deadline\` - law.traffic_law_payment_deadline
* \`law.traffic_law_penalty_order\` - law.traffic_law_penalty_order
* \`law.traffic_law_place_of_accident\` - law.traffic_law_place_of_accident
* \`law.traffic_law_place_of_crime\` - law.traffic_law_place_of_crime
* \`law.traffic_law_place_of_infraction\` - law.traffic_law_place_of_infraction
* \`law.traffic_law_place_of_inspection\` - law.traffic_law_place_of_inspection
* \`law.traffic_law_place_of_issue\` - law.traffic_law_place_of_issue
* \`law.traffic_law_place_of_offense\` - law.traffic_law_place_of_offense
* \`law.traffic_law_points_for_offense\` - law.traffic_law_points_for_offense
* \`law.traffic_law_police_case_number\` - law.traffic_law_police_case_number
* \`law.traffic_law_procedure_costs\` - law.traffic_law_procedure_costs
* \`law.traffic_law_prosecution_number\` - law.traffic_law_prosecution_number
* \`law.traffic_law_regular_tax\` - law.traffic_law_regular_tax
* \`law.traffic_law_repair_costs_with_vat\` - law.traffic_law_repair_costs_with_vat
* \`law.traffic_law_repair_costs_without_vat\` - law.traffic_law_repair_costs_without_vat
* \`law.traffic_law_repair_duration\` - law.traffic_law_repair_duration
* \`law.traffic_law_replacement_value\` - law.traffic_law_replacement_value
* \`law.traffic_law_reregistration_cost\` - law.traffic_law_reregistration_cost
* \`law.traffic_law_residual_value\` - law.traffic_law_residual_value
* \`law.traffic_law_speed_allowed\` - law.traffic_law_speed_allowed
* \`law.traffic_law_speed_driven\` - law.traffic_law_speed_driven
* \`law.traffic_law_speed_too_high\` - law.traffic_law_speed_too_high
* \`law.traffic_law_time_of_accident\` - law.traffic_law_time_of_accident
* \`law.traffic_law_time_of_crime\` - law.traffic_law_time_of_crime
* \`law.traffic_law_time_of_infraction\` - law.traffic_law_time_of_infraction
* \`law.traffic_law_time_of_inspection\` - law.traffic_law_time_of_inspection
* \`law.traffic_law_time_of_issue\` - law.traffic_law_time_of_issue
* \`law.traffic_law_time_of_offense\` - law.traffic_law_time_of_offense
* \`law.traffic_law_vehicle_age_months\` - law.traffic_law_vehicle_age_months
* \`law.traffic_law_vehicle_mileage\` - law.traffic_law_vehicle_mileage
* \`law.traffic_law_vehicle_type_and_brand\` - law.traffic_law_vehicle_type_and_brand
* \`law.traffic_law_victim_driver_drivers_license_issued_by\` - law.traffic_law_victim_driver_drivers_license_issued_by
* \`law.traffic_law_victim_driver_green_card_number\` - law.traffic_law_victim_driver_green_card_number
* \`law.traffic_law_victim_driver_insurance_expiry_date\` - law.traffic_law_victim_driver_insurance_expiry_date
* \`law.traffic_law_victim_driver_insurance_number\` - law.traffic_law_victim_driver_insurance_number
* \`law.traffic_law_victim_driver_insurer\` - law.traffic_law_victim_driver_insurer
* \`law.traffic_law_victim_driver_license_valid_until\` - law.traffic_law_victim_driver_license_valid_until
* \`law.traffic_law_violated_section\` - law.traffic_law_violated_section
* \`law.traffic_law_violation_type\` - law.traffic_law_violation_type
* \`law.traffic_law_warning_fee_infraction\` - law.traffic_law_warning_fee_infraction
* \`law.traffic_law_warning_notice\` - law.traffic_law_warning_notice`
} as const;

export const $AiAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        client: {
            '$ref': '#/components/schemas/EntityAugmentedFieldsRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityAugmentedFieldsRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawAugmentedFieldsRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $AiChatQuestionTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        created_by_user: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        prompt: {
            type: 'string'
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        org: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['created_at', 'created_by_user', 'is_jupus_template', 'org', 'prompt', 'title', 'updated_at', 'uuid']
} as const;

export const $AiChatQuestionTemplateRequest = {
    type: 'object',
    properties: {
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        prompt: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        }
    },
    required: ['prompt', 'title']
} as const;

export const $AppointmentSettings = {
    type: 'object',
    properties: {
        start_of_working_day: {
            type: 'string',
            format: 'time'
        },
        end_of_working_day: {
            type: 'string',
            format: 'time'
        },
        working_days: {
            title: 'Arbeitstage'
        }
    },
    required: ['end_of_working_day', 'start_of_working_day']
} as const;

export const $AugmentationVariantEnum = {
    enum: ['DOCUMENT ANALYSIS', 'EMAIL EXTRACTION', 'CONTEXTUAL ANALYSIS', 'CALL', 'CHATBOT'],
    type: 'string',
    description: `* \`DOCUMENT ANALYSIS\` - Document Analysis
* \`EMAIL EXTRACTION\` - Email Extraction
* \`CONTEXTUAL ANALYSIS\` - Contextual Analysis
* \`CALL\` - Call
* \`CHATBOT\` - Chatbot`
} as const;

export const $BlankEnum = {
    enum: ['']
} as const;

export const $BlockEvaluation = {
    type: 'object',
    title: 'BlockEvaluation',
    properties: {
        block_variable: {
            type: 'string'
        },
        is_true: {
            type: 'boolean'
        }
    },
    required: ['block_variable', 'is_true']
} as const;

export const $BotButtonPositionEnum = {
    enum: ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center', 'middle-left', 'middle-right', 'none'],
    type: 'string',
    description: `* \`top-left\` - Oben links
* \`top-right\` - Oben rechts
* \`top-center\` - Oben zentriert
* \`bottom-left\` - Unten links
* \`bottom-right\` - Unten rechts
* \`bottom-center\` - Unten zentriert
* \`middle-left\` - Links zentriert
* \`middle-right\` - Rechts zentriert
* \`none\` - Nicht anzeigen`
} as const;

export const $BufferMinsEnum = {
    enum: [0, 5, 10, 15, 30, 45, 60, 90, 120],
    type: 'integer',
    description: `* \`0\` - 0 Minuten
* \`5\` - 5 Minuten
* \`10\` - 10 Minuten
* \`15\` - 15 Minuten
* \`30\` - 30 Minuten
* \`45\` - 45 Minuten
* \`60\` - 60 Minuten
* \`90\` - 90 Minuten
* \`120\` - 120 Minuten`
} as const;

export const $CallTranscriptMessage = {
    type: 'object',
    properties: {
        role: {
            type: 'string'
        },
        content: {
            type: 'string'
        }
    },
    required: ['content', 'role']
} as const;

export const $CallTranscriptMessageRequest = {
    type: 'object',
    properties: {
        role: {
            type: 'string',
            minLength: 1
        },
        content: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['content', 'role']
} as const;

export const $CaseAiContext = {
    type: 'object',
    title: 'CaseAiContext',
    properties: {
        created_at: {
            type: 'string',
            nullable: true
        },
        case_created_at: {
            type: 'string'
        },
        updated_document_context_at: {
            type: 'string',
            nullable: true
        },
        inquiry: {
            type: 'string'
        },
        data: {
            '$ref': '#/components/schemas/CaseDataAiContext'
        },
        entities: {
            '$ref': '#/components/schemas/CaseEntityAiContext'
        },
        documents: {
            '$ref': '#/components/schemas/DocumentAiContext'
        }
    },
    required: ['case_created_at', 'inquiry', 'data', 'entities', 'documents']
} as const;

export const $CaseCreateEntityRequest = {
    type: 'object',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CaseCreateLawRequest = {
    type: 'object',
    properties: {
        field: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        topic: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/TopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    },
    required: ['field', 'topic']
} as const;

export const $CaseCreateRequest = {
    type: 'object',
    properties: {
        clerk_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        client: {
            '$ref': '#/components/schemas/CaseCreateEntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/CaseCreateEntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/CaseCreateLawRequest'
        },
        inquiry: {
            type: 'string',
            default: ''
        },
        note: {
            type: 'string',
            default: ''
        },
        document_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        ai_augmented_fields: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AiAugmentedFieldsRequest'
                }
            ],
            nullable: true
        }
    },
    required: ['ai_augmented_fields', 'clerk_uuid', 'client', 'document_uuids', 'law', 'opponent']
} as const;

export const $CaseCreatorTempDocument = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        original_filename: {
            type: 'string',
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'uri'
        },
        extraction_result: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UUIDExtractionResult'
                }
            ],
            readOnly: true
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        }
    },
    required: ['created_at', 'extraction_result', 'file', 'images', 'original_filename', 'uuid']
} as const;

export const $CaseCreatorTempDocumentRequest = {
    type: 'object',
    properties: {
        original_filename: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'binary'
        }
    },
    required: ['file', 'original_filename']
} as const;

export const $CaseDataAiContext = {
    type: 'object',
    title: 'CaseDataAiContext',
    properties: {
        key: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        data: {
            type: 'string',
            nullable: true
        },
        is_default: {
            type: 'boolean'
        },
        uuid: {
            type: 'string'
        }
    },
    required: ['key', 'label', 'is_default', 'uuid']
} as const;

export const $CaseEntityAiContext = {
    type: 'object',
    title: 'CaseEntityAiContext',
    properties: {
        uuid: {
            type: 'string'
        },
        entity_type: {
            '$ref': '#/components/schemas/EntityTypeC7aEnum'
        },
        first_name: {
            type: 'string',
            nullable: true
        },
        last_name: {
            type: 'string',
            nullable: true
        },
        company_name: {
            type: 'string',
            nullable: true
        },
        institution_name: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid', 'entity_type']
} as const;

export const $CaseType = {
    enum: ['API', 'CHAT BOT', 'QUESTIONNAIRE', 'EMAIL', 'MANUAL', 'PHONE', 'APPOINTMENT'],
    type: 'string',
    description: `* \`API\` - API
* \`CHAT BOT\` - Chat
* \`QUESTIONNAIRE\` - Fragebogen
* \`EMAIL\` - E-Mail
* \`MANUAL\` - Manuell
* \`PHONE\` - Telefon
* \`APPOINTMENT\` - Terminbuchung`
} as const;

export const $CategoryEnum = {
    enum: ['Allgemein', 'Rechtsspezifisch'],
    type: 'string',
    description: `* \`Allgemein\` - General
* \`Rechtsspezifisch\` - Law Specific`
} as const;

export const $ChangeSourceEnum = {
    enum: ['USER', 'AI', 'QUESTIONNAIRE', 'APPOINTMENT', 'SYSTEM'],
    type: 'string',
    description: `* \`USER\` - User
* \`AI\` - Ai
* \`QUESTIONNAIRE\` - Questionnaire
* \`APPOINTMENT\` - Appointment
* \`SYSTEM\` - System`
} as const;

export const $ClassificationEnum = {
    enum: ['EXISTING_CLIENT_CALL_BACK', 'NEW_CLIENT_CALL', 'GENERAL_ENQUIRY', 'QUESTION', 'NOT_COMPLETED', 'LAWFIRM_PARTNER'],
    type: 'string',
    description: `* \`EXISTING_CLIENT_CALL_BACK\` - Bestandsmandant
* \`NEW_CLIENT_CALL\` - Neumandant
* \`GENERAL_ENQUIRY\` - Allgemeine Anfrage
* \`QUESTION\` - Frage
* \`NOT_COMPLETED\` - Ohne Nachricht
* \`LAWFIRM_PARTNER\` - Geschäftspartner`
} as const;

export const $ClientAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $ClientAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $ClientAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $ClientAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['document', 'explanation', 'referenced_document_pages', 'value']
} as const;

export const $ClientCase = {
    type: 'object',
    description: 'Case representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ClientQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ClientRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        user_access_token: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['form_requests', 'org', 'questionnaire_submissions', 'user_access_token', 'uuid']
} as const;

export const $ClientEntity = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $ClientEntityRequest = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $ClientForm = {
    type: 'object',
    description: 'Form representation for clients.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'description', 'due_at', 'file', 'id', 'modified_at', 'organisation', 'tag', 'title']
} as const;

export const $ClientOrganisation = {
    type: 'object',
    description: 'Organisation representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true,
            title: 'Name der Kanzlei'
        },
        logo: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        description: {
            type: 'string',
            readOnly: true,
            title: 'Beschreibung'
        }
    },
    required: ['description', 'logo', 'name', 'uuid']
} as const;

export const $ClientQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            format: 'uri',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $ClientQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $ClientRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['form', 'id', 'response_present', 'token']
} as const;

export const $ClientRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['form', 'token']
} as const;

export const $CompanyLegalFormEnum = {
    enum: ['GmbH', 'UG', 'GmbH & Co. KG', 'GBR', 'OHG', 'KG', 'AG', 'SE', 'eG', 'eV', 'AG & Co. KG'],
    type: 'string',
    description: `* \`\` - 
* \`GmbH\` - GmbH
* \`UG\` - UG
* \`GmbH & Co. KG\` - GmbH & Co. KG
* \`GBR\` - GbR
* \`OHG\` - OHG
* \`KG\` - KG
* \`AG\` - AG
* \`SE\` - SE
* \`eG\` - eG
* \`eV\` - eV
* \`AG & Co. KG\` - AG & Co. KG`
} as const;

export const $ContextRequest = {
    type: 'object',
    properties: {
        key: {
            type: 'string',
            minLength: 1
        },
        context: {
            type: 'object',
            additionalProperties: {}
        }
    },
    required: ['context', 'key']
} as const;

export const $CreateCaseFromInboundEmailRequest = {
    type: 'object',
    properties: {
        inquiry: {
            type: 'string',
            minLength: 1
        },
        client_title: {
            type: 'string',
            minLength: 1
        },
        client_first_name: {
            type: 'string'
        },
        client_last_name: {
            type: 'string',
            minLength: 1
        },
        client_email: {
            type: 'string',
            format: 'email',
            minLength: 1
        },
        client_phone: {
            type: 'string'
        }
    },
    required: ['client_email', 'client_last_name', 'client_title', 'inquiry']
} as const;

export const $CreateWordDocumentFromPlaceholderValuesRequestRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1
        },
        placeholder_values: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PlaceholderValueRequest'
            }
        },
        create_pdf: {
            type: 'boolean',
            default: false
        }
    },
    required: ['name', 'placeholder_values', 'word_document_template_uuid']
} as const;

export const $CreateWordDocumentFromPlaceholderValuesResponse = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['document_uuid', 'url']
} as const;

export const $CreateWordDocumentPreviewBlobRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        placeholder_values: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PlaceholderValueRequest'
            }
        },
        use_ai_template: {
            type: 'boolean',
            default: false,
            description: 'If true, use the AI-generated template with placeholders instead of the original template'
        }
    },
    required: ['placeholder_values', 'word_document_template_uuid']
} as const;

export const $CreateWordDocumentRequestRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1
        },
        html: {
            type: 'string',
            minLength: 1
        },
        create_pdf: {
            type: 'boolean'
        }
    },
    required: ['create_pdf', 'html', 'name']
} as const;

export const $CreateWordDocumentResponse = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        document_uuid: {
            type: 'string'
        }
    },
    required: ['document_uuid', 'url']
} as const;

export const $CreateWordDocumentTemplateDocxWithPlaceholdersRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['word_document_template_uuid']
} as const;

export const $CustomerAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAdminAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAdminAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAdminAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $CustomerAdminAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $CustomerAdminAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $CustomerAdminAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['document', 'explanation', 'referenced_document_pages', 'value']
} as const;

export const $CustomerAdminAppointment = {
    type: 'object',
    description: 'Appointment representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['calendar', 'end', 'service', 'start', 'status']
} as const;

export const $CustomerAdminAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true,
            maxLength: 512
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'location_type', 'message', 'service', 'slug', 'start']
} as const;

export const $CustomerAdminAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'message', 'service_uuid', 'start']
} as const;

export const $CustomerAdminAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            minLength: 1,
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['end', 'start', 'status']
} as const;

export const $CustomerAdminCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerAdminCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerAdminCase = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisationUser'
                }
            ],
            readOnly: true
        },
        appointments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminAppointment'
            },
            readOnly: true
        },
        appointment_proposals: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminAppointmentProposal'
            },
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        }
    },
    required: ['appointment_proposals', 'appointments', 'chat_sessions', 'clerk', 'data', 'documents', 'form_requests', 'id', 'modified_at', 'org', 'questionnaire_submissions']
} as const;

export const $CustomerAdminCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $CustomerAdminCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerAdminCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerAdminCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $CustomerAdminCaseRequest = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['data']
} as const;

export const $CustomerAdminDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerAdminDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerAdminEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        }
    },
    required: ['bcc', 'cc', 'from_email', 'subject', 'to', 'uuid']
} as const;

export const $CustomerAdminEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminForm'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $CustomerAdminEntity = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $CustomerAdminEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerAdminEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerAdminEntityRequest = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CustomerAdminEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerAdminEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerAdminEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerAdminEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerAdminForm = {
    type: 'object',
    description: 'Form representation for customer admins.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        md5: {
            type: 'string',
            readOnly: true
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'description', 'due_at', 'file', 'id', 'md5', 'modified_at', 'organisation', 'tag', 'title']
} as const;

export const $CustomerAdminOrganisation = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        law_fields: {
            readOnly: true
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            readOnly: true
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            readOnly: true,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            readOnly: true,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        ai_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'KI Aktiv'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean',
            readOnly: true
        },
        enable_appointments: {
            type: 'boolean',
            readOnly: true,
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            readOnly: true,
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Jur|nodes Integration aktivieren'
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminOrganisationUser'
            },
            readOnly: true
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            readOnly: true,
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            readOnly: true,
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'ai_enabled', 'appointments_seats', 'enable_appointments', 'enable_cases', 'enable_law_specific_data', 'enable_voice', 'inbound_email_address', 'inbound_email_slug', 'is_actaport_export_integration_enabled', 'is_advolux_export_integration_enabled', 'is_advoware_export_integration_enabled', 'is_email_egress_integration_enabled', 'is_haveibeenpwned_integration_enabled', 'is_hubspot_egress_integration_enabled', 'is_iusta_egress_integration_enabled', 'is_jurnodes_export_integration_enabled', 'is_kleos_integration_enabled', 'is_law_firm_software_exportation_enabled', 'is_ra_micro_export_integration_enabled', 'is_webhooks_egress_integration_enabled', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'law_fields', 'oid', 'questionnaire_creation_token', 'receive_monthly_updates_summary', 'seats', 'users', 'uuid']
} as const;

export const $CustomerAdminOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        }
    }
} as const;

export const $CustomerAdminOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $CustomerAdminPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        active: {
            type: 'boolean'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            nullable: true,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    },
    required: ['org', 'uuid']
} as const;

export const $CustomerAdminPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        active: {
            type: 'boolean'
        },
        phone_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $CustomerAdminQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['description', 'schema', 'theme_color', 'title', 'uuid']
} as const;

export const $CustomerAdminQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        }
    },
    required: ['schema']
} as const;

export const $CustomerAdminQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            format: 'uri',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $CustomerAdminQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerAdminRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['form', 'id', 'response_present', 'token']
} as const;

export const $CustomerAdminRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['form', 'token']
} as const;

export const $CustomerAdminService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name', 'org']
} as const;

export const $CustomerAdminServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name', 'org']
} as const;

export const $CustomerAdminUser = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    },
    required: ['email', 'org', 'uid', 'uuid']
} as const;

export const $CustomerAdminUserRequest = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    },
    required: ['email']
} as const;

export const $CustomerAdminWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerAdminWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $CustomerAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $CustomerAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $CustomerAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['document', 'explanation', 'referenced_document_pages', 'value']
} as const;

export const $CustomerAppointment = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['calendar', 'end', 'service', 'start', 'status']
} as const;

export const $CustomerAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true,
            maxLength: 512
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'location_type', 'message', 'service', 'slug', 'start']
} as const;

export const $CustomerAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'message', 'service_uuid', 'start']
} as const;

export const $CustomerAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            minLength: 1,
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['end', 'start', 'status']
} as const;

export const $CustomerCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerCall = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        audio_recording_url: {
            type: 'string',
            nullable: true,
            description: 'Return the URL of the audio recording of the call.',
            readOnly: true
        },
        call_start_time: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        phone_number: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerPhoneNumber'
                }
            ],
            readOnly: true
        },
        result: {
            '$ref': '#/components/schemas/CustomerCallResult'
        },
        lawyer_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerLawyerFeedback'
                }
            ],
            readOnly: true
        },
        duration: {
            type: 'integer',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['audio_recording_url', 'call_end_time', 'call_start_time', 'case_uuid', 'duration', 'lawyer_feedback', 'phone_number', 'result', 'uuid']
} as const;

export const $CustomerCallRequest = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        result: {
            '$ref': '#/components/schemas/CustomerCallResultRequest'
        }
    },
    required: ['result']
} as const;

export const $CustomerCallResult = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        classification: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClassificationEnum'
                }
            ],
            readOnly: true
        },
        inquiry: {
            type: 'string',
            readOnly: true
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseData'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        }
    },
    required: ['classification', 'data', 'email_recording_end_seconds', 'email_recording_start_seconds', 'first_name_recording_end_seconds', 'first_name_recording_start_seconds', 'inquiry', 'last_name_recording_end_seconds', 'last_name_recording_start_seconds', 'phone_number_recording_end_seconds', 'phone_number_recording_start_seconds', 'uuid']
} as const;

export const $CustomerCallResultRequest = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ShallowCaseDataRequest'
        }
    },
    required: ['data']
} as const;

export const $CustomerCase = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisationUser'
                }
            ],
            readOnly: true
        },
        appointments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAppointment'
            },
            readOnly: true
        },
        appointment_proposals: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAppointmentProposal'
            },
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        }
    },
    required: ['appointment_proposals', 'appointments', 'chat_sessions', 'clerk', 'data', 'documents', 'form_requests', 'id', 'modified_at', 'org', 'questionnaire_submissions']
} as const;

export const $CustomerCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $CustomerCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $CustomerCaseRequest = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['data']
} as const;

export const $CustomerDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        }
    },
    required: ['bcc', 'cc', 'from_email', 'subject', 'to', 'uuid']
} as const;

export const $CustomerEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerForm'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $CustomerEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $CustomerEntity = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $CustomerEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerEntityRequest = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CustomerEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerForm = {
    type: 'object',
    description: 'Form representation for customers.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'description', 'due_at', 'file', 'id', 'modified_at', 'organisation', 'tag', 'title']
} as const;

export const $CustomerLawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        }
    },
    required: ['rating', 'uuid']
} as const;

export const $CustomerLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['call_uuid', 'rating']
} as const;

export const $CustomerOrganisation = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        law_fields: {
            readOnly: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            readOnly: true
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            readOnly: true,
            title: 'Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        ai_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'KI Aktiv'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean',
            readOnly: true
        },
        enable_appointments: {
            type: 'boolean',
            readOnly: true,
            title: 'Terminbuchung aktivieren'
        },
        appointments_seats: {
            type: 'integer',
            readOnly: true,
            title: 'Terminbuchungen Sitze'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        enable_voice: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Anrufbeantworter aktivieren'
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Jur|nodes Integration aktivieren'
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerOrganisationUser'
            },
            readOnly: true
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        enable_law_specific_data: {
            type: 'boolean',
            readOnly: true,
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'ai_enabled', 'appointments_seats', 'enable_appointments', 'enable_law_specific_data', 'enable_voice', 'inbound_email_address', 'inbound_email_slug', 'is_actaport_export_integration_enabled', 'is_advolux_export_integration_enabled', 'is_advoware_export_integration_enabled', 'is_email_egress_integration_enabled', 'is_haveibeenpwned_integration_enabled', 'is_hubspot_egress_integration_enabled', 'is_iusta_egress_integration_enabled', 'is_jurnodes_export_integration_enabled', 'is_kleos_integration_enabled', 'is_law_firm_software_exportation_enabled', 'is_ra_micro_export_integration_enabled', 'is_webhooks_egress_integration_enabled', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'law_fields', 'oid', 'questionnaire_creation_token', 'seats', 'users', 'uuid']
} as const;

export const $CustomerOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        }
    }
} as const;

export const $CustomerOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $CustomerPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        active: {
            type: 'boolean',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        law_fields: {
            readOnly: true,
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            readOnly: true,
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.'
        },
        lawfirm_name: {
            type: 'string',
            readOnly: true,
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.'
        },
        address: {
            type: 'string',
            readOnly: true,
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.'
        },
        opening_hours: {
            type: 'string',
            readOnly: true,
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.'
        },
        lawyer_names: {
            type: 'string',
            readOnly: true,
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.'
        },
        has_free_initial_consultation: {
            type: 'boolean',
            readOnly: true,
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            readOnly: true,
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.'
        },
        can_record_calls: {
            type: 'boolean',
            readOnly: true,
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        }
    },
    required: ['active', 'address', 'can_record_calls', 'description', 'has_free_initial_consultation', 'law_fields', 'lawfirm_name', 'lawyer_names', 'opening_hours', 'org', 'original_phone_number', 'phone_number', 'uuid']
} as const;

export const $CustomerQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['description', 'schema', 'theme_color', 'title', 'uuid']
} as const;

export const $CustomerQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        }
    },
    required: ['schema']
} as const;

export const $CustomerQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            format: 'uri',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $CustomerQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['form', 'id', 'response_present', 'token']
} as const;

export const $CustomerRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['form', 'token']
} as const;

export const $CustomerService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name', 'org']
} as const;

export const $CustomerServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name', 'org']
} as const;

export const $CustomerUser = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    },
    required: ['email', 'org', 'role', 'uid', 'uuid']
} as const;

export const $CustomerUserRequest = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    },
    required: ['email']
} as const;

export const $CustomerWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $Document = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_type: {
            '$ref': '#/components/schemas/DocumentTypeEnum'
        },
        title: {
            type: 'string',
            maxLength: 128
        },
        filename: {
            type: 'string',
            maxLength: 128
        },
        is_uploaded: {
            type: 'boolean'
        },
        upload_origin: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        url: {
            type: 'string',
            readOnly: true
        },
        page_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        filesize: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            }
        },
        needs_ocr: {
            type: 'boolean'
        },
        ocr_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_embeddings: {
            type: 'boolean'
        },
        embeddings_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary: {
            type: 'boolean'
        },
        summary_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary_embedding: {
            type: 'boolean'
        },
        summary_embedding_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_raptor_summaries: {
            type: 'boolean'
        },
        raptor_summaries_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_analysis: {
            type: 'boolean'
        },
        analysis_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_metadata_enrichment: {
            type: 'boolean'
        },
        metadata_enrichment_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_is_finished: {
            type: 'boolean',
            nullable: true
        },
        metadata_enrichment_error: {
            type: 'string',
            nullable: true
        },
        embeddings_error: {
            type: 'string',
            nullable: true
        },
        summary_error: {
            type: 'string',
            nullable: true
        },
        summary_embedding_error: {
            type: 'string',
            nullable: true
        },
        raptor_summaries_error: {
            type: 'string',
            nullable: true
        },
        analysis_error: {
            type: 'string',
            nullable: true
        }
    },
    required: ['created_at', 'document_type', 'filename', 'images', 'is_uploaded', 'title', 'url']
} as const;

export const $DocumentAiContext = {
    type: 'object',
    title: 'DocumentAiContext',
    properties: {
        created_at: {
            type: 'string'
        },
        uuid: {
            type: 'string'
        },
        document_type: {
            type: 'string'
        },
        is_uploaded: {
            type: 'boolean'
        },
        upload_origin: {
            type: 'string',
            nullable: true
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        relevant_content: {
            '$ref': '#/components/schemas/DocumentContent'
        }
    },
    required: ['created_at', 'uuid', 'document_type', 'is_uploaded', 'title', 'summary', 'relevant_content']
} as const;

export const $DocumentContent = {
    type: 'object',
    title: 'DocumentContent',
    properties: {
        pages: {
            type: 'integer'
        },
        text: {
            type: 'string'
        }
    },
    required: ['pages', 'text']
} as const;

export const $DocumentGeneratorRelatedData = {
    type: 'object',
    title: 'DocumentGeneratorRelatedData',
    properties: {
        template_uuid: {
            type: 'string',
            nullable: true
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $DocumentRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_type: {
            '$ref': '#/components/schemas/DocumentTypeEnum'
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 128
        },
        filename: {
            type: 'string',
            minLength: 1,
            maxLength: 128
        },
        is_uploaded: {
            type: 'boolean'
        },
        upload_origin: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        page_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        filesize: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePresetRequest'
            }
        },
        needs_ocr: {
            type: 'boolean'
        },
        ocr_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_embeddings: {
            type: 'boolean'
        },
        embeddings_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary: {
            type: 'boolean'
        },
        summary_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary_embedding: {
            type: 'boolean'
        },
        summary_embedding_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_raptor_summaries: {
            type: 'boolean'
        },
        raptor_summaries_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_analysis: {
            type: 'boolean'
        },
        analysis_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_metadata_enrichment: {
            type: 'boolean'
        },
        metadata_enrichment_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_is_finished: {
            type: 'boolean',
            nullable: true
        },
        metadata_enrichment_error: {
            type: 'string',
            nullable: true
        },
        embeddings_error: {
            type: 'string',
            nullable: true
        },
        summary_error: {
            type: 'string',
            nullable: true
        },
        summary_embedding_error: {
            type: 'string',
            nullable: true
        },
        raptor_summaries_error: {
            type: 'string',
            nullable: true
        },
        analysis_error: {
            type: 'string',
            nullable: true
        }
    },
    required: ['document_type', 'filename', 'images', 'is_uploaded', 'title']
} as const;

export const $DocumentTypeEnum = {
    enum: ['Anfrage', 'E-Mail', 'Upload', 'Fragebogen', 'Dokumentenvorlage', 'Transkript', 'KI Dokumentengenerator Vorlage', 'KI generiertes Dokument', 'KI Chat'],
    type: 'string',
    description: `* \`Anfrage\` - Case
* \`E-Mail\` - Email
* \`Upload\` - Upload
* \`Fragebogen\` - Questionnaire
* \`Dokumentenvorlage\` - Pdf Template
* \`Transkript\` - Call Transcript
* \`KI Dokumentengenerator Vorlage\` - Ai Document Generator Template
* \`KI generiertes Dokument\` - Ai Generated Document
* \`KI Chat\` - Ai Case Chat`
} as const;

export const $DocumentUpload = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'uri'
        },
        upload_origin: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                }
            ],
            default: 'Manuell hinzugefügt',
            description: `Origin of the document upload

* \`None\` - Not Set
* \`Chatbot Upload\` - Chatbot
* \`Email Anhang\` - Email
* \`Terminbuchung\` - Appointment
* \`Fragebogen\` - Questionnaire
* \`Manuell hinzugefügt\` - Manual
* \`AI CASE CHAT\` - Ai Case Chat`
        }
    },
    required: ['file']
} as const;

export const $DocumentUploadRequest = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary'
        },
        upload_origin: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                }
            ],
            default: 'Manuell hinzugefügt',
            description: `Origin of the document upload

* \`None\` - Not Set
* \`Chatbot Upload\` - Chatbot
* \`Email Anhang\` - Email
* \`Terminbuchung\` - Appointment
* \`Fragebogen\` - Questionnaire
* \`Manuell hinzugefügt\` - Manual
* \`AI CASE CHAT\` - Ai Case Chat`
        }
    },
    required: ['file']
} as const;

export const $DurationMinsEnum = {
    enum: [5, 10, 15, 30, 45, 60, 90, 120, 180, 240, 300],
    type: 'integer',
    description: `* \`5\` - 5 Minuten
* \`10\` - 10 Minuten
* \`15\` - 15 Minuten
* \`30\` - 30 Minuten
* \`45\` - 45 Minuten
* \`60\` - 60 Minuten
* \`90\` - 90 Minuten
* \`120\` - 120 Minuten
* \`180\` - 180 Minuten
* \`240\` - 240 Minuten
* \`300\` - 300 Minuten`
} as const;

export const $EditorUploadRequest = {
    type: 'object',
    properties: {
        is_private: {
            type: 'boolean'
        }
    },
    required: ['is_private']
} as const;

export const $EditorUploadResponse = {
    type: 'object',
    properties: {
        link: {
            type: 'string',
            format: 'uri'
        }
    },
    required: ['link']
} as const;

export const $EmailAddress = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        name: {
            type: 'string',
            maxLength: 255
        }
    },
    required: ['email', 'name']
} as const;

export const $EmailRenderTemplateRequestRequest = {
    type: 'object',
    properties: {
        template_html: {
            type: 'string',
            minLength: 1
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        subject: {
            type: 'string',
            minLength: 1
        },
        contexts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ContextRequest'
            },
            default: []
        }
    },
    required: ['subject', 'template_html']
} as const;

export const $EmailRenderTemplateResponse = {
    type: 'object',
    properties: {
        subject: {
            type: 'string'
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        }
    },
    required: ['html', 'subject', 'text']
} as const;

export const $EmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $EmailTemplateType = {
    enum: ['create', 'reject'],
    type: 'string',
    description: `* \`create\` - Mandatsaufnahme
* \`reject\` - Mandatsablehnung`
} as const;

export const $EmailTextColorEnum = {
    enum: ['#000000', '#28324E', '#2969B0', '#2C82C9', '#553982', '#E25041', '#475577', '#9365B8', '#A38F84', '#1ABC9C', '#00A885', '#3D8EB9', '#61BD6D', '#41A85F', '#54ACD2', '#EB6B56', '#FBA026', '#F7DA64', '#CCCCCC'],
    type: 'string',
    description: `* \`#000000\` - Black
* \`#28324E\` - Dark Grey
* \`#2969B0\` - Darker Blue
* \`#2C82C9\` - Dark Blue
* \`#553982\` - Dark Purple
* \`#E25041\` - Dark Red
* \`#475577\` - Grey
* \`#9365B8\` - Purple
* \`#A38F84\` - Brown
* \`#1ABC9C\` - Teal
* \`#00A885\` - Aqua
* \`#3D8EB9\` - Light Blue
* \`#61BD6D\` - Green
* \`#41A85F\` - Light Green
* \`#54ACD2\` - Blue
* \`#EB6B56\` - Red
* \`#FBA026\` - Orange
* \`#F7DA64\` - Yellow
* \`#CCCCCC\` - Light Grey`
} as const;

export const $EmailTextFontEnum = {
    enum: ['Arial,Helvetica,sans-serif', 'Georgia,serif', 'Impact,Charcoal,sans-serif', 'Tahoma,Geneva,sans-serif', "'Times New Roman',Times,serif", 'Verdana,Geneva,sans-serif'],
    type: 'string',
    description: `* \`Arial,Helvetica,sans-serif\` - Arial
* \`Georgia,serif\` - Georgia
* \`Impact,Charcoal,sans-serif\` - Impact
* \`Tahoma,Geneva,sans-serif\` - Tahoma
* \`'Times New Roman',Times,serif\` - Times New Roman
* \`Verdana,Geneva,sans-serif\` - Verdana`
} as const;

export const $EmailTextSizeEnum = {
    enum: [8, 9, 10, 11, 12, 14, 18],
    type: 'integer',
    description: `* \`8\` - Size 8
* \`9\` - Size 9
* \`10\` - Size 10
* \`11\` - Size 11
* \`12\` - Size 12
* \`14\` - Size 14
* \`18\` - Size 18`
} as const;

export const $EntitiesMapperKeyEnum = {
    enum: ['entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip'],
    type: 'string',
    description: `* \`entities.field.bank_name\` - entities.field.bank_name
* \`entities.field.bic\` - entities.field.bic
* \`entities.field.city\` - entities.field.city
* \`entities.field.company_legal_form\` - entities.field.company_legal_form
* \`entities.field.company_name\` - entities.field.company_name
* \`entities.field.company_register_court\` - entities.field.company_register_court
* \`entities.field.company_register_number\` - entities.field.company_register_number
* \`entities.field.company_tax_id\` - entities.field.company_tax_id
* \`entities.field.company_vat_id\` - entities.field.company_vat_id
* \`entities.field.date_of_birth\` - entities.field.date_of_birth
* \`entities.field.date_of_death\` - entities.field.date_of_death
* \`entities.field.email\` - entities.field.email
* \`entities.field.entity_type\` - entities.field.entity_type
* \`entities.field.fax\` - entities.field.fax
* \`entities.field.first_name\` - entities.field.first_name
* \`entities.field.iban\` - entities.field.iban
* \`entities.field.institution_name\` - entities.field.institution_name
* \`entities.field.is_entitled_to_deduct_vat\` - entities.field.is_entitled_to_deduct_vat
* \`entities.field.last_name\` - entities.field.last_name
* \`entities.field.legal_insurance_deductible_amount\` - entities.field.legal_insurance_deductible_amount
* \`entities.field.legal_insurance\` - entities.field.legal_insurance
* \`entities.field.legal_insurance_name\` - entities.field.legal_insurance_name
* \`entities.field.legal_insurance_number\` - entities.field.legal_insurance_number
* \`entities.field.marital_status\` - entities.field.marital_status
* \`entities.field.phone\` - entities.field.phone
* \`entities.field.specific_title\` - entities.field.specific_title
* \`entities.field.street\` - entities.field.street
* \`entities.field.street_number\` - entities.field.street_number
* \`entities.field.title\` - entities.field.title
* \`entities.field.website\` - entities.field.website
* \`entities.field.zip\` - entities.field.zip`
} as const;

export const $Entity = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $EntityAddCaseDataRelationshipRequest = {
    type: 'object',
    properties: {
        case_data_uuid: {
            type: 'string',
            minLength: 1
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        number: {
            type: 'integer',
            nullable: true
        }
    },
    required: ['case_data_uuid', 'relationship_type']
} as const;

export const $EntityAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        entity_type: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        title: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        first_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        last_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        company_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        company_legal_form: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        institution_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        phone: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        email: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        date_of_birth: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        street: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        street_number: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        zip: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        city: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance_number: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        }
    },
    required: ['city', 'company_legal_form', 'company_name', 'date_of_birth', 'email', 'entity_type', 'first_name', 'institution_name', 'last_name', 'legal_insurance', 'legal_insurance_name', 'legal_insurance_number', 'phone', 'street', 'street_number', 'title', 'zip']
} as const;

export const $EntityRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        is_unique_per_case: {
            type: 'boolean'
        },
        number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true
        }
    },
    required: ['is_unique_per_case', 'number', 'relationship_type']
} as const;

export const $EntityRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        is_unique_per_case: {
            type: 'boolean'
        },
        number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true
        }
    },
    required: ['is_unique_per_case', 'number', 'relationship_type']
} as const;

export const $EntityRemoveCaseDataRelationshipCustomerResponse = {
    type: 'object',
    properties: {
        relationship: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerEntityWithRelationship'
                }
            ],
            nullable: true
        }
    },
    required: ['relationship']
} as const;

export const $EntityRemoveCaseDataRelationshipRequestRequest = {
    type: 'object',
    properties: {
        case_data_uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        remove_case_data_association_if_no_relationships_exist: {
            type: 'boolean',
            default: false
        }
    },
    required: ['case_data_uuid']
} as const;

export const $EntityRemoveCaseDataRelationshipSuperUserResponse = {
    type: 'object',
    properties: {
        relationship: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
                }
            ],
            nullable: true
        }
    },
    required: ['relationship']
} as const;

export const $EntityRequest = {
    type: 'object',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $EntityTypeC7aEnum = {
    type: 'string',
    enum: ['natural_person', 'legal_person', 'institution']
} as const;

export const $EntityTypeEnum = {
    enum: ['natural_person', 'legal_person', 'institution'],
    type: 'string',
    description: `* \`natural_person\` - Natürliche Person
* \`legal_person\` - Juristische Person
* \`institution\` - Institution`
} as const;

export const $ExternalIntegrationCaseCreationResponse = {
    type: 'object',
    properties: {
        caseId: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['caseId', 'message', 'status']
} as const;

export const $ExternalIntegrationFileDownloadResponse = {
    type: 'object',
    properties: {
        fileName: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        contentType: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['content', 'contentType', 'fileName', 'message']
} as const;

export const $FeatureEnum = {
    enum: ['ai_chat', 'document_generator', 'ai_analysis'],
    type: 'string',
    description: `* \`ai_chat\` - Ai Chat
* \`document_generator\` - Document Generator
* \`ai_analysis\` - Ai Analysis`
} as const;

export const $Feedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        url: {
            type: 'string',
            maxLength: 255
        },
        user: {
            type: 'integer',
            readOnly: true,
            nullable: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['created_at', 'feature', 'rating', 'related_data', 'url', 'user', 'uuid']
} as const;

export const $FeedbackRelatedData = {
    type: 'object',
    title: 'FeedbackRelatedData',
    properties: {
        document_generator: {
            '$ref': '#/components/schemas/DocumentGeneratorRelatedData',
            nullable: true
        },
        ai_chat: {
            '$ref': '#/components/schemas/AIChatRelatedData',
            nullable: true
        },
        ai_analysis: {
            '$ref': '#/components/schemas/AiAnalysisRelatedData',
            nullable: true
        }
    }
} as const;

export const $FeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['feature', 'rating', 'related_data', 'url']
} as const;

export const $FieldEnum = {
    enum: ['Arbeitsrecht', 'Asylrecht', 'Ausländerrecht', 'Bankrecht', 'Baurecht', 'Beamtenrecht', 'Bewertungen löschen', 'Casino', 'Coaching', 'Compliance', 'Corona Überbrückungshilfe', 'Datenleck', 'Erbrecht', 'Familienrecht', 'Gesellschaftsrecht', 'Gewerblicher Rechtsschutz/Urheberrecht', 'Hochschulrecht', 'Immobilienrecht', 'Inkasso', 'IT Recht', 'Insolvenzberatung', 'Markenrecht', 'Medien-und Presserecht', 'Mietrecht', 'Migrationsrecht', 'Musikrecht', 'Notariat', 'Personenschäden', 'Schufa', 'Schulrecht', 'Social Media Recht', 'Sozialrecht', 'Steuerberatung', 'Steuerrecht', 'Strafrecht', 'Tesla_Widerruf', 'Tierrecht', 'Verkehrsrecht', 'Versicherungsrecht', 'Verwaltungsrecht', 'Wegrecht', 'Zivilrecht'],
    type: 'string',
    description: `* \`Arbeitsrecht\` - Arbeitsrecht
* \`Asylrecht\` - Asylrecht
* \`Ausländerrecht\` - Ausländerrecht
* \`Bankrecht\` - Bankrecht
* \`Baurecht\` - Baurecht
* \`Beamtenrecht\` - Beamtenrecht
* \`Bewertungen löschen\` - Bewertungen Löschen
* \`Casino\` - Casino
* \`Coaching\` - Coaching
* \`Compliance\` - Compliance
* \`Corona Überbrückungshilfe\` - Corona Überbrückungshilfe
* \`Datenleck\` - Datenleck
* \`Erbrecht\` - Erbrecht
* \`Familienrecht\` - Familienrecht
* \`Gesellschaftsrecht\` - Gesellschaftsrecht
* \`Gewerblicher Rechtsschutz/Urheberrecht\` - Gewerblicher Rechtsschutz/Urheberrecht
* \`Hochschulrecht\` - Hochschulrecht
* \`Immobilienrecht\` - Immobilienrecht
* \`Inkasso\` - Inkasso
* \`IT Recht\` - It Recht
* \`Insolvenzberatung\` - Insolvenzberatung
* \`Markenrecht\` - Markenrecht
* \`Medien-und Presserecht\` - Medien-Und Presserecht
* \`Mietrecht\` - Mietrecht
* \`Migrationsrecht\` - Migrationsrecht
* \`Musikrecht\` - Musikrecht
* \`Notariat\` - Notariat
* \`Personenschäden\` - Personenschäden
* \`Schufa\` - Schufa
* \`Schulrecht\` - Schulrecht
* \`Social Media Recht\` - Social Media Recht
* \`Sozialrecht\` - Sozialrecht
* \`Steuerberatung\` - Steuerberatung
* \`Steuerrecht\` - Steuerrecht
* \`Strafrecht\` - Strafrecht
* \`Tesla_Widerruf\` - Tesla Widerruf
* \`Tierrecht\` - Tierrecht
* \`Verkehrsrecht\` - Verkehrsrecht
* \`Versicherungsrecht\` - Versicherungsrecht
* \`Verwaltungsrecht\` - Verwaltungsrecht
* \`Wegrecht\` - Wegrecht
* \`Zivilrecht\` - Zivilrecht`
} as const;

export const $FieldTypeEnum = {
    enum: ['multiselect', 'select', 'textarea', 'filefield', 'multifilefield', 'timefield', 'decimalnumberinput', 'datefield', 'textinput', 'numberinput', 'emailinput', 'phoneinput', 'urlinput', 'yesno'],
    type: 'string',
    description: `* \`multiselect\` - multiselect
* \`select\` - select
* \`textarea\` - textarea
* \`filefield\` - filefield
* \`multifilefield\` - multifilefield
* \`timefield\` - timefield
* \`decimalnumberinput\` - decimalnumberinput
* \`datefield\` - datefield
* \`textinput\` - textinput
* \`numberinput\` - numberinput
* \`emailinput\` - emailinput
* \`phoneinput\` - phoneinput
* \`urlinput\` - urlinput
* \`yesno\` - yesno`
} as const;

export const $FileDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        filename: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['filename', 'uuid']
} as const;

export const $FindWordDocumentTemplatePlaceholderValuesRequestRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['word_document_template_uuid']
} as const;

export const $FindWordDocumentTemplatePlaceholderValuesResponse = {
    type: 'object',
    properties: {
        replaceable_variables: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ReplaceableVariables'
                }
            ],
            readOnly: true
        }
    },
    required: ['replaceable_variables']
} as const;

export const $FormTag = {
    enum: ['MASTER', 'PREFILLED', 'SIGNED'],
    type: 'string',
    description: `* \`MASTER\` - Master
* \`PREFILLED\` - Prefilled
* \`SIGNED\` - Signed`
} as const;

export const $GenerateDocumentChatRequest = {
    type: 'object',
    properties: {
        role: {
            '$ref': '#/components/schemas/GenerateDocumentChatRoleEnum'
        },
        content: {
            type: 'string',
            minLength: 1
        },
        is_template: {
            type: 'boolean'
        }
    },
    required: ['content', 'is_template', 'role']
} as const;

export const $GenerateDocumentChatRoleEnum = {
    enum: ['system', 'user', 'assistant'],
    type: 'string',
    description: `* \`system\` - System
* \`user\` - User
* \`assistant\` - Assistant`
} as const;

export const $GenerateDocumentRequestRequest = {
    type: 'object',
    properties: {
        document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        chat: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenerateDocumentChatRequest'
            }
        }
    },
    required: ['chat', 'document_template_uuid']
} as const;

export const $GenericDataMapper = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
        },
        label: {
            type: 'string'
        },
        field_type: {
            '$ref': '#/components/schemas/FieldTypeEnum'
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        is_law_specific_field: {
            type: 'boolean'
        },
        is_entity_field: {
            type: 'boolean'
        },
        law_field: {
            '$ref': '#/components/schemas/LawFieldEnum'
        },
        max_length: {
            type: 'integer',
            nullable: true
        },
        is_nullable: {
            type: 'boolean'
        },
        default: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        starts_ai_analysis: {
            type: 'boolean'
        },
        ai_augments_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        },
        ai_augmented_by_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        }
    },
    required: ['default', 'field_type', 'is_entity_field', 'is_law_specific_field', 'is_nullable', 'key', 'label', 'starts_ai_analysis']
} as const;

export const $GenericDataMapperRequest = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
        },
        label: {
            type: 'string',
            minLength: 1
        },
        field_type: {
            '$ref': '#/components/schemas/FieldTypeEnum'
        },
        choices: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 1
            }
        },
        is_law_specific_field: {
            type: 'boolean'
        },
        is_entity_field: {
            type: 'boolean'
        },
        law_field: {
            '$ref': '#/components/schemas/LawFieldEnum'
        },
        max_length: {
            type: 'integer',
            nullable: true
        },
        is_nullable: {
            type: 'boolean'
        },
        default: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        starts_ai_analysis: {
            type: 'boolean'
        },
        ai_augments_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        },
        ai_augmented_by_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        }
    },
    required: ['default', 'field_type', 'is_entity_field', 'is_law_specific_field', 'is_nullable', 'key', 'label', 'starts_ai_analysis']
} as const;

export const $ImagePresetEnum = {
    enum: ['thumbnail', 'small', 'medium', 'large'],
    type: 'string',
    description: `* \`thumbnail\` - thumbnail
* \`small\` - small
* \`medium\` - medium
* \`large\` - large`
} as const;

export const $ImageproxyImagePreset = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        image_preset: {
            '$ref': '#/components/schemas/ImagePresetEnum'
        }
    },
    required: ['image_preset', 'url']
} as const;

export const $ImageproxyImagePresetRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri',
            minLength: 1
        },
        image_preset: {
            '$ref': '#/components/schemas/ImagePresetEnum'
        }
    },
    required: ['image_preset', 'url']
} as const;

export const $InboundEmailAttachment = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        file_name: {
            type: 'string',
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'uri'
        }
    },
    required: ['file', 'file_name']
} as const;

export const $InboundEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $IntegrationSpecificDataRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ActaportDataRequest'
        },
        {
            '$ref': '#/components/schemas/AdvoluxDataRequest'
        },
        {
            '$ref': '#/components/schemas/AdvowareDataRequest'
        },
        {
            '$ref': '#/components/schemas/LawFirmSoftwareDataRequest'
        },
        {
            '$ref': '#/components/schemas/RaMicroDataRequest'
        },
        {
            '$ref': '#/components/schemas/JurnodesDataRequest'
        },
        {
            '$ref': '#/components/schemas/KleosDataRequest'
        }
    ],
    discriminator: {
        propertyName: 'integrationType',
        mapping: {
            actaport: '#/components/schemas/ActaportDataRequest',
            advolux: '#/components/schemas/AdvoluxDataRequest',
            advoware: '#/components/schemas/AdvowareDataRequest',
            lawfirm: '#/components/schemas/LawFirmSoftwareDataRequest',
            ramicro: '#/components/schemas/RaMicroDataRequest',
            jurnodes: '#/components/schemas/JurnodesDataRequest',
            kleos: '#/components/schemas/KleosDataRequest'
        }
    }
} as const;

export const $IntegrationTypeEnum = {
    enum: ['actaport', 'advolux', 'advoware', 'lawfirm', 'ramicro', 'jurnodes', 'kleos'],
    type: 'string',
    description: `* \`actaport\` - Actaport
* \`advolux\` - Advolux
* \`advoware\` - Advoware
* \`lawfirm\` - LawFirm
* \`ramicro\` - RaMicro
* \`jurnodes\` - Jurnodes
* \`kleos\` - Kleos`
} as const;

export const $JumpTo = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            nullable: true
        },
        value: {
            type: 'string'
        }
    },
    required: ['uuid', 'value']
} as const;

export const $JumpToRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            nullable: true,
            minLength: 1
        },
        value: {
            type: 'string'
        }
    },
    required: ['uuid', 'value']
} as const;

export const $JurnodesDataRequest = {
    type: 'object',
    properties: {
        datapool: {
            type: 'integer'
        },
        rubrum: {
            type: 'string',
            minLength: 1
        },
        lawCategory: {
            type: 'integer'
        },
        recordSchema: {
            type: 'integer'
        },
        lawyers: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['datapool', 'entities_with_relationships', 'lawCategory', 'recordSchema', 'rubrum']
} as const;

export const $JurnodesLawCategory = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        }
    },
    required: ['id', 'name']
} as const;

export const $JurnodesRecordSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        },
        lawCategory: {
            type: 'integer'
        }
    },
    required: ['id', 'lawCategory', 'name']
} as const;

export const $JurnodesUser = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        displayName: {
            type: 'string'
        },
        abbreviation: {
            type: 'string'
        },
        department: {
            type: 'string'
        },
        position: {
            type: 'string'
        },
        privateFileFolder: {
            type: 'string'
        },
        contact: {
            type: 'string'
        }
    },
    required: ['abbreviation', 'contact', 'department', 'displayName', 'id', 'position', 'privateFileFolder']
} as const;

export const $KleosCaseType = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        },
        defaultRegister: {
            type: 'integer',
            nullable: true
        }
    },
    required: ['defaultRegister', 'id', 'name']
} as const;

export const $KleosCaseTypes = {
    type: 'object',
    properties: {
        caseTypes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/KleosCaseType'
            }
        }
    },
    required: ['caseTypes']
} as const;

export const $KleosDataRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1
        },
        description: {
            type: 'string',
            nullable: true
        },
        caseResponsibleId: {
            type: 'integer',
            nullable: true
        },
        typeId: {
            type: 'integer'
        },
        creationDate: {
            type: 'string',
            minLength: 1
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['creationDate', 'description', 'entities_with_relationships', 'name', 'typeId']
} as const;

export const $LawAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        field: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        topic: {
            type: 'string',
            format: 'uuid',
            nullable: true
        }
    },
    required: ['field', 'topic']
} as const;

export const $LawData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_wanring_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Abfindung Höhe'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            title: 'Schadenumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttagen'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag der Tagessatz'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewärung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse Mietobjekt',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung Mietobjekt',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn Pachtvertrag'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Pachtvertrag'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        },
        labor_law_work_contract: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        labor_law_termination: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        labor_law_termination_agreement: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        labor_law_settlement_agreement: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        labor_law_warning_letter: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        labor_law_payslip: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        traffic_law_fine_notice: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        traffic_law_accident_report: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        traffic_law_expert_report: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        traffic_law_warning_notice: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        traffic_law_penalty_order: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        criminal_law_criminal_warrant: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        criminal_law_complaint: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        criminal_law_indictment: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        family_law_divorce_application: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        family_law_marriage_certificate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        family_law_birth_certificate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        family_law_marriage_contract: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        social_law_notice_of_objection: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        debt_collection_law_invoice: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        tenancy_law_rental_agreement: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        tenancy_law_lease_agreement: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        residential_property_law_contract: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_certificate_of_inheritance: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_inheritance_contract: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_death_certificate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_will: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_list_of_estate: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_living_will: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        inheritance_law_lasting_power_of_attorney: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        },
        generic_document: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentUpload'
            },
            readOnly: true
        }
    },
    required: ['created_at', 'criminal_law_complaint', 'criminal_law_criminal_warrant', 'criminal_law_indictment', 'debt_collection_law_invoice', 'family_law_birth_certificate', 'family_law_divorce_application', 'family_law_marriage_certificate', 'family_law_marriage_contract', 'generic_document', 'inheritance_law_certificate_of_inheritance', 'inheritance_law_death_certificate', 'inheritance_law_inheritance_contract', 'inheritance_law_lasting_power_of_attorney', 'inheritance_law_list_of_estate', 'inheritance_law_living_will', 'inheritance_law_will', 'labor_law_payslip', 'labor_law_settlement_agreement', 'labor_law_termination', 'labor_law_termination_agreement', 'labor_law_warning_letter', 'labor_law_work_contract', 'residential_property_law_contract', 'social_law_notice_of_objection', 'tenancy_law_lease_agreement', 'tenancy_law_rental_agreement', 'traffic_law_accident_report', 'traffic_law_expert_report', 'traffic_law_fine_notice', 'traffic_law_penalty_order', 'traffic_law_warning_notice', 'updated_at']
} as const;

export const $LawDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_wanring_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Abfindung Höhe'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            minLength: 1,
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            minLength: 1,
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            minLength: 1,
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            minLength: 1,
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            minLength: 1,
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            minLength: 1,
            title: 'Schadenumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            minLength: 1,
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            minLength: 1,
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            minLength: 1,
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttagen'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag der Tagessatz'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewärung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse Mietobjekt',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung Mietobjekt',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn Pachtvertrag'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Pachtvertrag'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    }
} as const;

export const $LawFieldEnum = {
    enum: ['Arbeitsrecht', 'Asylrecht', 'Ausländerrecht', 'Bankrecht', 'Baurecht', 'Beamtenrecht', 'Bewertungen löschen', 'Casino', 'Coaching', 'Compliance', 'Corona Überbrückungshilfe', 'Datenleck', 'Erbrecht', 'Familienrecht', 'Gesellschaftsrecht', 'Gewerblicher Rechtsschutz/Urheberrecht', 'Hochschulrecht', 'Immobilienrecht', 'Inkasso', 'IT Recht', 'Insolvenzberatung', 'Markenrecht', 'Medien-und Presserecht', 'Mietrecht', 'Migrationsrecht', 'Musikrecht', 'Notariat', 'Personenschäden', 'Schufa', 'Schulrecht', 'Social Media Recht', 'Sozialrecht', 'Steuerberatung', 'Steuerrecht', 'Strafrecht', 'Tesla_Widerruf', 'Tierrecht', 'Verkehrsrecht', 'Versicherungsrecht', 'Verwaltungsrecht', 'Wegrecht', 'Zivilrecht'],
    type: 'string',
    description: `* \`Arbeitsrecht\` - Arbeitsrecht
* \`Asylrecht\` - Asylrecht
* \`Ausländerrecht\` - Ausländerrecht
* \`Bankrecht\` - Bankrecht
* \`Baurecht\` - Baurecht
* \`Beamtenrecht\` - Beamtenrecht
* \`Bewertungen löschen\` - Bewertungen löschen
* \`Casino\` - Casino
* \`Coaching\` - Coaching
* \`Compliance\` - Compliance
* \`Corona Überbrückungshilfe\` - Corona Überbrückungshilfe
* \`Datenleck\` - Datenleck
* \`Erbrecht\` - Erbrecht
* \`Familienrecht\` - Familienrecht
* \`Gesellschaftsrecht\` - Gesellschaftsrecht
* \`Gewerblicher Rechtsschutz/Urheberrecht\` - Gewerblicher Rechtsschutz/Urheberrecht
* \`Hochschulrecht\` - Hochschulrecht
* \`Immobilienrecht\` - Immobilienrecht
* \`Inkasso\` - Inkasso
* \`IT Recht\` - IT Recht
* \`Insolvenzberatung\` - Insolvenzberatung
* \`Markenrecht\` - Markenrecht
* \`Medien-und Presserecht\` - Medien-und Presserecht
* \`Mietrecht\` - Mietrecht
* \`Migrationsrecht\` - Migrationsrecht
* \`Musikrecht\` - Musikrecht
* \`Notariat\` - Notariat
* \`Personenschäden\` - Personenschäden
* \`Schufa\` - Schufa
* \`Schulrecht\` - Schulrecht
* \`Social Media Recht\` - Social Media Recht
* \`Sozialrecht\` - Sozialrecht
* \`Steuerberatung\` - Steuerberatung
* \`Steuerrecht\` - Steuerrecht
* \`Strafrecht\` - Strafrecht
* \`Tesla_Widerruf\` - Tesla_Widerruf
* \`Tierrecht\` - Tierrecht
* \`Verkehrsrecht\` - Verkehrsrecht
* \`Versicherungsrecht\` - Versicherungsrecht
* \`Verwaltungsrecht\` - Verwaltungsrecht
* \`Wegrecht\` - Wegrecht
* \`Zivilrecht\` - Zivilrecht`
} as const;

export const $LawFields = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        }
    },
    required: ['data']
} as const;

export const $LawFirmSoftwareDataRequest = {
    type: 'object',
    properties: {
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $LawTopicEnum = {
    enum: ['AGB', 'Abfindung', 'Abmahnung', 'Abmahnung Wettbewerbsrecht', 'Abschiebungshaft', 'Abschlussarbeit', 'Abstandsregelung nicht eingehalten', 'Account hacking', 'Allgemein', 'Allgemeines Prüfungsrecht', 'Anderes', 'Arbeitsamt/ALG/Sperrzeit', 'Arbeitsunfall', 'Arbeitsvertrag', 'Arbeitszeugnis', 'Aufbau Compliancesystem', 'Aufenthaltserlaubnis', 'Aufhebungsvertrag', 'Auftragsdatenverarbeitung', 'Auseinandersetzung Erbengemeinschaft', 'Auskunft prüfen', 'Ausweisung', 'Autokauf', 'Bankkonto leergeräumt', 'Bankrecht', 'Baumangel', 'Bauvertrag', 'Behandlungsfehler Allgemein', 'Behandlungsfehler Querschnittslähmung', 'Behandlungsfehler Schlaganfall', 'Beißvorfall', 'Beratung zu Erbfall', 'Beschlagnahme Allgemein', 'Beschlagnahme Tierquälerei', 'Betreuungsrecht', 'Betrug Geldanlage', 'Betäubungsmittel', 'Burgschild Inkasso', 'Bußgeldbescheid', 'Bürgergeld', 'Coaching', 'Datenschutz', 'Datenschutz Schadensersatz', 'Datenschutzverstoß', 'Domains', 'Ehevertrag', 'Eigentumsdelikte', 'Einbürgerung', 'Einreisesperre', 'Eintrag löschen', 'Erbauseinandersetzung', 'Erbausschlagung', 'Erben/Schenken', 'Erbengemeinschaft', 'Erbschein', 'Erbscheinsantrag', 'Erbvertrag', 'Exmatrikulation', 'Fahren ohne Führerschein', 'Fahren unter Alkohol - / Drogeneinfluss', 'Fahrer - / Unfallflucht', 'Fahrverbot / Führerscheinentzug', 'Falschaussage/ Meineid', 'Familie Vorsorge', 'Forderung löschen', 'Geburtsfehler', 'Geburtsfehler Mutter', 'Geschwindigkeitsüberschreitung', 'Gesetzliche Erbfolge', 'Gewerblicher Rechtsschutz', 'Grundschuld', 'Gründung', 'Handy am Steuer', 'Hauskauf', 'Härtefallantrag', 'Immobilien', 'Kaufvertragsprüfung', 'Körperverletzung', 'Kündigung', 'Lohnzahlung', 'Markenanmeldung', 'Markenverteidigung', 'Markenüberwachung', 'Mieterhöhung', 'Mietkaution', 'Mietminderung', 'Mietvertrag', 'Nebenkostenabrechnung', 'Niederlassungserlaubnis', 'Nutzerbewertungen Verfasser', 'Patientenverfügung/Vorsorgevollmacht', 'Personenverwechselung', 'Pflege-/Krankenversicherung', 'Pflichtteil', 'Pflichtteil Geltendmachung', 'Pflichtteil abwehren', 'Plagiatsvorwurf', 'Remonstration', 'Rente', 'Rotlichtverstoß', 'Räumungsklage', 'Schadensersatz', 'Scheidung', 'Schenkung', 'Schenkung Immobilie', 'Schulplatz einklagen', 'Schwerbehinderung', 'Sexualdelikt', 'Software Hardware', 'Sonstige Beglaubigung', 'Sorgerecht und Umgangsrecht', 'Testament', 'Testament/Erbvertrag', 'Tierkauf', 'Tierärztliche Behandlungsfehler', 'Trennung', 'Tuning', 'Täuschungsversuch', 'Tötungsdelikte', 'Unfall Querschnittslähmung', 'Unfall mit Personenschaden', 'Unterhalt', 'Unternehmen', 'Unternehmensauflösung', 'Unternehmensgründung', 'Unternehmenskauf', 'Urheberrecht', 'Urlaub', 'Vaterschaftsanerkennung', 'Vererben', 'Verkehrsunfall', 'Vermögensauseinandersetzung', 'Vermögensdelikte', 'Verstoß gegen die Anschnallpflicht', 'Vertragsprüfung', 'Vertragsrecht', 'Visum', 'Vorfälligkeitsentschädigung', 'Vorsorge', 'Vorsorgevollmacht/Patientenverfügung', 'Waffendelikte', 'Wettbewerbsrecht', 'Widerrufsrechte', 'Widerspruch/ Klage', 'Wucherzinsen Darlehen', 'Zugewinnausgleich', 'Zweiradunfall', 'unbezahlte Rechnungen', 'unerlaubtes Glücksspiel', 'Überstunden', 'Übertragung zu Lebzeiten'],
    type: 'string',
    description: `* \`AGB\` - AGB
* \`Abfindung\` - Abfindung
* \`Abmahnung\` - Abmahnung
* \`Abmahnung Wettbewerbsrecht\` - Abmahnung Wettbewerbsrecht
* \`Abschiebungshaft\` - Abschiebungshaft
* \`Abschlussarbeit\` - Abschlussarbeit
* \`Abstandsregelung nicht eingehalten\` - Abstandsregelung nicht eingehalten
* \`Account hacking\` - Account hacking
* \`Allgemein\` - Allgemein
* \`Allgemeines Prüfungsrecht\` - Allgemeines Prüfungsrecht
* \`Anderes\` - Anderes
* \`Arbeitsamt/ALG/Sperrzeit\` - Arbeitsamt/ALG/Sperrzeit
* \`Arbeitsunfall\` - Arbeitsunfall
* \`Arbeitsvertrag\` - Arbeitsvertrag
* \`Arbeitszeugnis\` - Arbeitszeugnis
* \`Aufbau Compliancesystem\` - Aufbau Compliancesystem
* \`Aufenthaltserlaubnis\` - Aufenthaltserlaubnis
* \`Aufhebungsvertrag\` - Aufhebungsvertrag
* \`Auftragsdatenverarbeitung\` - Auftragsdatenverarbeitung
* \`Auseinandersetzung Erbengemeinschaft\` - Auseinandersetzung Erbengemeinschaft
* \`Auskunft prüfen\` - Auskunft prüfen
* \`Ausweisung\` - Ausweisung
* \`Autokauf\` - Autokauf
* \`Bankkonto leergeräumt\` - Bankkonto leergeräumt
* \`Bankrecht\` - Bankrecht
* \`Baumangel\` - Baumangel
* \`Bauvertrag\` - Bauvertrag
* \`Behandlungsfehler Allgemein\` - Behandlungsfehler Allgemein
* \`Behandlungsfehler Querschnittslähmung\` - Behandlungsfehler Querschnittslähmung
* \`Behandlungsfehler Schlaganfall\` - Behandlungsfehler Schlaganfall
* \`Beißvorfall\` - Beißvorfall
* \`Beratung zu Erbfall\` - Beratung zu Erbfall
* \`Beschlagnahme Allgemein\` - Beschlagnahme Allgemein
* \`Beschlagnahme Tierquälerei\` - Beschlagnahme Tierquälerei
* \`Betreuungsrecht\` - Betreuungsrecht
* \`Betrug Geldanlage\` - Betrug Geldanlage
* \`Betäubungsmittel\` - Betäubungsmittel
* \`Burgschild Inkasso\` - Burgschild Inkasso
* \`Bußgeldbescheid\` - Bußgeldbescheid
* \`Bürgergeld\` - Bürgergeld
* \`Coaching\` - Coaching
* \`Datenschutz\` - Datenschutz
* \`Datenschutz Schadensersatz\` - Datenschutz Schadensersatz
* \`Datenschutzverstoß\` - Datenschutzverstoß
* \`Domains\` - Domains
* \`Ehevertrag\` - Ehevertrag
* \`Eigentumsdelikte\` - Eigentumsdelikte
* \`Einbürgerung\` - Einbürgerung
* \`Einreisesperre\` - Einreisesperre
* \`Eintrag löschen\` - Eintrag löschen
* \`Erbauseinandersetzung\` - Erbauseinandersetzung
* \`Erbausschlagung\` - Erbausschlagung
* \`Erben/Schenken\` - Erben/Schenken
* \`Erbengemeinschaft\` - Erbengemeinschaft
* \`Erbschein\` - Erbschein
* \`Erbscheinsantrag\` - Erbscheinsantrag
* \`Erbvertrag\` - Erbvertrag
* \`Exmatrikulation\` - Exmatrikulation
* \`Fahren ohne Führerschein\` - Fahren ohne Führerschein
* \`Fahren unter Alkohol - / Drogeneinfluss\` - Fahren unter Alkohol - / Drogeneinfluss
* \`Fahrer - / Unfallflucht\` - Fahrer - / Unfallflucht
* \`Fahrverbot / Führerscheinentzug\` - Fahrverbot / Führerscheinentzug
* \`Falschaussage/ Meineid\` - Falschaussage/ Meineid
* \`Familie Vorsorge\` - Familie Vorsorge
* \`Forderung löschen\` - Forderung löschen
* \`Geburtsfehler\` - Geburtsfehler
* \`Geburtsfehler Mutter\` - Geburtsfehler Mutter
* \`Geschwindigkeitsüberschreitung\` - Geschwindigkeitsüberschreitung
* \`Gesetzliche Erbfolge\` - Gesetzliche Erbfolge
* \`Gewerblicher Rechtsschutz\` - Gewerblicher Rechtsschutz
* \`Grundschuld\` - Grundschuld
* \`Gründung\` - Gründung
* \`Handy am Steuer\` - Handy am Steuer
* \`Hauskauf\` - Hauskauf
* \`Härtefallantrag\` - Härtefallantrag
* \`Immobilien\` - Immobilien
* \`Kaufvertragsprüfung\` - Kaufvertragsprüfung
* \`Körperverletzung\` - Körperverletzung
* \`Kündigung\` - Kündigung
* \`Lohnzahlung\` - Lohnzahlung
* \`Markenanmeldung\` - Markenanmeldung
* \`Markenverteidigung\` - Markenverteidigung
* \`Markenüberwachung\` - Markenüberwachung
* \`Mieterhöhung\` - Mieterhöhung
* \`Mietkaution\` - Mietkaution
* \`Mietminderung\` - Mietminderung
* \`Mietvertrag\` - Mietvertrag
* \`Nebenkostenabrechnung\` - Nebenkostenabrechnung
* \`Niederlassungserlaubnis\` - Niederlassungserlaubnis
* \`Nutzerbewertungen Verfasser\` - Nutzerbewertungen Verfasser
* \`Patientenverfügung/Vorsorgevollmacht\` - Patientenverfügung/Vorsorgevollmacht
* \`Personenverwechselung\` - Personenverwechselung
* \`Pflege-/Krankenversicherung\` - Pflege-/Krankenversicherung
* \`Pflichtteil\` - Pflichtteil
* \`Pflichtteil Geltendmachung\` - Pflichtteil Geltendmachung
* \`Pflichtteil abwehren\` - Pflichtteil abwehren
* \`Plagiatsvorwurf\` - Plagiatsvorwurf
* \`Remonstration\` - Remonstration
* \`Rente\` - Rente
* \`Rotlichtverstoß\` - Rotlichtverstoß
* \`Räumungsklage\` - Räumungsklage
* \`Schadensersatz\` - Schadensersatz
* \`Scheidung\` - Scheidung
* \`Schenkung\` - Schenkung
* \`Schenkung Immobilie\` - Schenkung Immobilie
* \`Schulplatz einklagen\` - Schulplatz einklagen
* \`Schwerbehinderung\` - Schwerbehinderung
* \`Sexualdelikt\` - Sexualdelikt
* \`Software Hardware\` - Software Hardware
* \`Sonstige Beglaubigung\` - Sonstige Beglaubigung
* \`Sorgerecht und Umgangsrecht\` - Sorgerecht und Umgangsrecht
* \`Testament\` - Testament
* \`Testament/Erbvertrag\` - Testament/Erbvertrag
* \`Tierkauf\` - Tierkauf
* \`Tierärztliche Behandlungsfehler\` - Tierärztliche Behandlungsfehler
* \`Trennung\` - Trennung
* \`Tuning\` - Tuning
* \`Täuschungsversuch\` - Täuschungsversuch
* \`Tötungsdelikte\` - Tötungsdelikte
* \`Unfall Querschnittslähmung\` - Unfall Querschnittslähmung
* \`Unfall mit Personenschaden\` - Unfall mit Personenschaden
* \`Unterhalt\` - Unterhalt
* \`Unternehmen\` - Unternehmen
* \`Unternehmensauflösung\` - Unternehmensauflösung
* \`Unternehmensgründung\` - Unternehmensgründung
* \`Unternehmenskauf\` - Unternehmenskauf
* \`Urheberrecht\` - Urheberrecht
* \`Urlaub\` - Urlaub
* \`Vaterschaftsanerkennung\` - Vaterschaftsanerkennung
* \`Vererben\` - Vererben
* \`Verkehrsunfall\` - Verkehrsunfall
* \`Vermögensauseinandersetzung\` - Vermögensauseinandersetzung
* \`Vermögensdelikte\` - Vermögensdelikte
* \`Verstoß gegen die Anschnallpflicht\` - Verstoß gegen die Anschnallpflicht
* \`Vertragsprüfung\` - Vertragsprüfung
* \`Vertragsrecht\` - Vertragsrecht
* \`Visum\` - Visum
* \`Vorfälligkeitsentschädigung\` - Vorfälligkeitsentschädigung
* \`Vorsorge\` - Vorsorge
* \`Vorsorgevollmacht/Patientenverfügung\` - Vorsorgevollmacht/Patientenverfügung
* \`Waffendelikte\` - Waffendelikte
* \`Wettbewerbsrecht\` - Wettbewerbsrecht
* \`Widerrufsrechte\` - Widerrufsrechte
* \`Widerspruch/ Klage\` - Widerspruch/ Klage
* \`Wucherzinsen Darlehen\` - Wucherzinsen Darlehen
* \`Zugewinnausgleich\` - Zugewinnausgleich
* \`Zweiradunfall\` - Zweiradunfall
* \`unbezahlte Rechnungen\` - unbezahlte Rechnungen
* \`unerlaubtes Glücksspiel\` - unerlaubtes Glücksspiel
* \`Überstunden\` - Überstunden
* \`Übertragung zu Lebzeiten\` - Übertragung zu Lebzeiten`
} as const;

export const $LawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['uuid']
} as const;

export const $LocationTypeEnum = {
    enum: ['ONLINE', 'TELEPHONE', 'IN_PERSON'],
    type: 'string',
    description: `* \`ONLINE\` - Online-Termin
* \`TELEPHONE\` - Telefon-Termin
* \`IN_PERSON\` - Termin vor Ort`
} as const;

export const $LocationTypesEnum = {
    enum: ['ONLINE', 'TELEPHONE', 'IN_PERSON'],
    type: 'string',
    description: `* \`ONLINE\` - Online-Termin
* \`TELEPHONE\` - Telefon-Termin
* \`IN_PERSON\` - Termin vor Ort`
} as const;

export const $NullEnum = {
    enum: [
        null
    ]
} as const;

export const $OrganizationAiContext = {
    type: 'object',
    title: 'OrganizationAiContext',
    properties: {
        uuid: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        customer_number: {
            type: 'string'
        },
        law_firm: {
            type: 'boolean'
        },
        law_fields: {
            type: 'string'
        },
        street: {
            type: 'string',
            nullable: true
        },
        street_number: {
            type: 'string',
            nullable: true
        },
        zip: {
            type: 'string',
            nullable: true
        },
        city: {
            type: 'string',
            nullable: true
        },
        country: {
            type: 'string',
            nullable: true
        },
        phone: {
            type: 'string',
            nullable: true
        },
        email: {
            type: 'string',
            nullable: true
        },
        description: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid', 'name', 'customer_number', 'law_firm', 'law_fields']
} as const;

export const $PaginatedSuperUserHubSpotCompanyList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserHubSpotCompany'
            }
        }
    }
} as const;

export const $PaginatedSuperUserHubSpotContactList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserHubSpotContact'
            }
        }
    }
} as const;

export const $PaginatedTAIChatSessionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAIChatSession'
            }
        }
    }
} as const;

export const $PaginatedTAccountList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAccount'
            }
        }
    }
} as const;

export const $PaginatedTAiAnalysisList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiAnalysis'
            }
        }
    }
} as const;

export const $PaginatedTAiAugmentationList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiAugmentation'
            }
        }
    }
} as const;

export const $PaginatedTAiChatQuestionTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiChatQuestionTemplate'
            }
        }
    }
} as const;

export const $PaginatedTAppointmentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAppointment'
            }
        }
    }
} as const;

export const $PaginatedTAppointmentProposalList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAppointmentProposal'
            }
        }
    }
} as const;

export const $PaginatedTCalendarList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCalendar'
            }
        }
    }
} as const;

export const $PaginatedTCallList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCall'
            }
        }
    }
} as const;

export const $PaginatedTCaseCreatorTempDocumentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCaseCreatorTempDocument'
            }
        }
    }
} as const;

export const $PaginatedTCaseList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCase'
            }
        }
    }
} as const;

export const $PaginatedTDocumentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TDocument'
            }
        }
    }
} as const;

export const $PaginatedTDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TDocumentTemplate'
            }
        }
    }
} as const;

export const $PaginatedTEmailList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEmail'
            }
        }
    }
} as const;

export const $PaginatedTEmailTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEmailTemplate'
            }
        }
    }
} as const;

export const $PaginatedTEntityList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEntity'
            }
        }
    }
} as const;

export const $PaginatedTFeedbackList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TFeedback'
            }
        }
    }
} as const;

export const $PaginatedTFormList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TForm'
            }
        }
    }
} as const;

export const $PaginatedTGenericDataMapperList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TGenericDataMapper'
            }
        }
    }
} as const;

export const $PaginatedTInboundEmailList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TInboundEmail'
            }
        }
    }
} as const;

export const $PaginatedTLawyerFeedbackList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TLawyerFeedback'
            }
        }
    }
} as const;

export const $PaginatedTOrganisationList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TOrganisation'
            }
        }
    }
} as const;

export const $PaginatedTPhoneNumberList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TPhoneNumber'
            }
        }
    }
} as const;

export const $PaginatedTQuestionnaireList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TQuestionnaire'
            }
        }
    }
} as const;

export const $PaginatedTQuestionnaireSubmissionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TQuestionnaireSubmission'
            }
        }
    }
} as const;

export const $PaginatedTRetellAgentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TRetellAgent'
            }
        }
    }
} as const;

export const $PaginatedTServiceList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TService'
            }
        }
    }
} as const;

export const $PaginatedTStripeCustomerList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TStripeCustomer'
            }
        }
    }
} as const;

export const $PaginatedTStripeInvoiceList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TStripeInvoice'
            }
        }
    }
} as const;

export const $PaginatedTUserList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TUser'
            }
        }
    }
} as const;

export const $PaginatedTWordDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TWordDocumentTemplate'
            }
        }
    }
} as const;

export const $PatchedAIChatSessionRequest = {
    type: 'object',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        }
    }
} as const;

export const $PatchedAiChatQuestionTemplateRequest = {
    type: 'object',
    properties: {
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        prompt: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        }
    }
} as const;

export const $PatchedCaseCreatorTempDocumentRequest = {
    type: 'object',
    properties: {
        original_filename: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'binary'
        }
    }
} as const;

export const $PatchedClientAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedClientAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedClientEntityRequest = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedClientQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedCustomerAdminAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedCustomerAdminAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedCustomerAdminAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedCustomerAdminAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAdminCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedCustomerAdminCaseRequest = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $PatchedCustomerAdminDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAdminEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAdminEntityRequest = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedCustomerAdminOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        }
    }
} as const;

export const $PatchedCustomerAdminPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        active: {
            type: 'boolean'
        },
        phone_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $PatchedCustomerAdminQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        }
    }
} as const;

export const $PatchedCustomerAdminQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAdminServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    }
} as const;

export const $PatchedCustomerAdminUserRequest = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    }
} as const;

export const $PatchedCustomerAdminWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    }
} as const;

export const $PatchedCustomerAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedCustomerAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedCustomerAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            minLength: 1,
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    }
} as const;

export const $PatchedCustomerCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedCustomerCallRequest = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        result: {
            '$ref': '#/components/schemas/CustomerCallResultRequest'
        }
    }
} as const;

export const $PatchedCustomerCaseRequest = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $PatchedCustomerDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerEntityRequest = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedCustomerLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        }
    }
} as const;

export const $PatchedCustomerQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        }
    }
} as const;

export const $PatchedCustomerQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    }
} as const;

export const $PatchedCustomerUserRequest = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        }
    }
} as const;

export const $PatchedCustomerWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    }
} as const;

export const $PatchedDocumentRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_type: {
            '$ref': '#/components/schemas/DocumentTypeEnum'
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 128
        },
        filename: {
            type: 'string',
            minLength: 1,
            maxLength: 128
        },
        is_uploaded: {
            type: 'boolean'
        },
        upload_origin: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        page_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        filesize: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePresetRequest'
            }
        },
        needs_ocr: {
            type: 'boolean'
        },
        ocr_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        ocr_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_embeddings: {
            type: 'boolean'
        },
        embeddings_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        embeddings_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary: {
            type: 'boolean'
        },
        summary_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_summary_embedding: {
            type: 'boolean'
        },
        summary_embedding_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        summary_embedding_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_raptor_summaries: {
            type: 'boolean'
        },
        raptor_summaries_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        raptor_summaries_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_analysis: {
            type: 'boolean'
        },
        analysis_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        analysis_is_finished: {
            type: 'boolean',
            nullable: true
        },
        needs_metadata_enrichment: {
            type: 'boolean'
        },
        metadata_enrichment_started_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_finished_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        metadata_enrichment_is_finished: {
            type: 'boolean',
            nullable: true
        },
        metadata_enrichment_error: {
            type: 'string',
            nullable: true
        },
        embeddings_error: {
            type: 'string',
            nullable: true
        },
        summary_error: {
            type: 'string',
            nullable: true
        },
        summary_embedding_error: {
            type: 'string',
            nullable: true
        },
        raptor_summaries_error: {
            type: 'string',
            nullable: true
        },
        analysis_error: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $PatchedEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    }
} as const;

export const $PatchedInboundEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedSuperUserAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedSuperUserAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedSuperUserAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedSuperUserAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedSuperUserCallRequest = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        user_phone_number: {
            type: 'string',
            minLength: 1,
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResultRequest'
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        }
    }
} as const;

export const $PatchedSuperUserCaseRequest = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            minLength: 1,
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    }
} as const;

export const $PatchedSuperUserDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserEntityRequest = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedSuperUserFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        user: {
            '$ref': '#/components/schemas/SuperUserUserRequest'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    }
} as const;

export const $PatchedSuperUserFormRequest = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        }
    }
} as const;

export const $PatchedSuperUserLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            minLength: 1,
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            minLength: 1,
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        }
    }
} as const;

export const $PatchedSuperUserPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean'
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        agent_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        org_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $PatchedSuperUserQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string',
            maxLength: 128
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        enabled_all_orgs: {
            type: 'boolean',
            title: 'Für alle Kanzleien freischalten'
        },
        enabled_custom_orgs: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $PatchedSuperUserQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    }
} as const;

export const $PatchedSuperUserUserRequest = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        ai_docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'AI-generated template with placeholders'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    }
} as const;

export const $PatchedTAIChatSessionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedAIChatSessionRequest'
        }
    ]
} as const;

export const $PatchedTAccountRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAccountRequest'
        }
    ]
} as const;

export const $PatchedTAiAnalysisRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAiAnalysisRequest'
        }
    ]
} as const;

export const $PatchedTAiAugmentationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAiAugmentationRequest'
        }
    ]
} as const;

export const $PatchedTAiChatQuestionTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedAiChatQuestionTemplateRequest'
        }
    ]
} as const;

export const $PatchedTAppointmentProposalRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAppointmentProposalRequest'
        }
    ]
} as const;

export const $PatchedTAppointmentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAppointmentRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAccountRequest'
        }
    ]
} as const;

export const $PatchedTCalendarRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCalendarRequest'
        }
    ]
} as const;

export const $PatchedTCallRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCallRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCallRequest'
        }
    ]
} as const;

export const $PatchedTCaseCreatorTempDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCaseCreatorTempDocumentRequest'
        }
    ]
} as const;

export const $PatchedTCaseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCaseRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCaseRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCaseRequest'
        }
    ]
} as const;

export const $PatchedTDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedDocumentRequest'
        }
    ]
} as const;

export const $PatchedTDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserDocumentTemplateRequest'
        }
    ]
} as const;

export const $PatchedTEmailTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserEmailTemplateRequest'
        }
    ]
} as const;

export const $PatchedTEntityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserEntityRequest'
        }
    ]
} as const;

export const $PatchedTFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserFeedbackRequest'
        }
    ]
} as const;

export const $PatchedTFormRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedSuperUserFormRequest'
        }
    ]
} as const;

export const $PatchedTLawyerFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerLawyerFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserLawyerFeedbackRequest'
        }
    ]
} as const;

export const $PatchedTOrganisationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserOrganisationRequest'
        }
    ]
} as const;

export const $PatchedTPhoneNumberRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminPhoneNumberRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserPhoneNumberRequest'
        }
    ]
} as const;

export const $PatchedTQuestionnaireRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserQuestionnaireRequest'
        }
    ]
} as const;

export const $PatchedTQuestionnaireSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserQuestionnaireSubmissionRequest'
        }
    ]
} as const;

export const $PatchedTRetellAgentRequest = {
    oneOf: []
} as const;

export const $PatchedTServiceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerServiceRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminServiceRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserServiceRequest'
        }
    ]
} as const;

export const $PatchedTStripeCustomerRequest = {
    oneOf: []
} as const;

export const $PatchedTStripeInvoiceRequest = {
    oneOf: []
} as const;

export const $PatchedTUserRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerUserRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminUserRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserUserRequest'
        }
    ]
} as const;

export const $PatchedTWordDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserWordDocumentTemplateRequest'
        }
    ]
} as const;

export const $Placeholder = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/PlaceholderKeyEnum'
        },
        placeholder: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        is_context_aware: {
            type: 'boolean'
        },
        demo_context_dict: {
            nullable: true
        },
        rendered_demo_context_html: {
            type: 'string',
            nullable: true
        },
        variant: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: ['description', 'html', 'is_context_aware', 'key', 'label', 'placeholder', 'variant']
} as const;

export const $PlaceholderKeyEnum = {
    enum: ['clerk_first_name', 'clerk_last_name', 'lawfirm_name', 'client_first_name', 'client_formal_greeting', 'client_last_name', 'client_title', 'clerk_signature', 'full_signature', 'lawfirm_signature', 'appointment_key_facts', 'appointment_proposal_message', 'appointment_proposal_url', 'appointment_url', 'questionnaires_and_documents'],
    type: 'string',
    description: `* \`clerk_first_name\` - clerk_first_name
* \`clerk_last_name\` - clerk_last_name
* \`lawfirm_name\` - lawfirm_name
* \`client_first_name\` - client_first_name
* \`client_formal_greeting\` - client_formal_greeting
* \`client_last_name\` - client_last_name
* \`client_title\` - client_title
* \`clerk_signature\` - clerk_signature
* \`full_signature\` - full_signature
* \`lawfirm_signature\` - lawfirm_signature
* \`appointment_key_facts\` - appointment_key_facts
* \`appointment_proposal_message\` - appointment_proposal_message
* \`appointment_proposal_url\` - appointment_proposal_url
* \`appointment_url\` - appointment_url
* \`questionnaires_and_documents\` - questionnaires_and_documents`
} as const;

export const $PlaceholderSuggestion = {
    type: 'object',
    title: 'PlaceholderSuggestion',
    properties: {
        suggested_value: {
            type: 'string'
        },
        score: {
            type: 'number'
        }
    },
    required: ['suggested_value', 'score']
} as const;

export const $PlaceholderValueRequest = {
    type: 'object',
    properties: {
        placeholder: {
            type: 'string',
            minLength: 1
        },
        value: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['placeholder', 'value']
} as const;

export const $PlaceholderValueSuggestions = {
    type: 'object',
    title: 'PlaceholderValueSuggestions',
    properties: {
        placeholder_variable: {
            type: 'string'
        },
        suggestions: {
            '$ref': '#/components/schemas/PlaceholderSuggestion'
        }
    },
    required: ['placeholder_variable', 'suggestions']
} as const;

export const $QuestionnaireGenerateRequest = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        prompt: {
            type: 'string',
            nullable: true,
            minLength: 1
        }
    }
} as const;

export const $QuestionnaireQuestion = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string'
        },
        help: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/QuestionnaireQuestionTypeEnum'
        },
        tag: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireQuestionTagEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_number: {
            type: 'integer',
            maximum: 10,
            minimum: 1,
            nullable: true
        },
        label: {
            type: 'string'
        },
        value: {
            type: 'string',
            nullable: true
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        jump_to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JumpTo'
            },
            nullable: true
        },
        optional: {
            type: 'boolean'
        },
        starts_ai_analysis: {
            type: 'boolean'
        }
    },
    required: ['help', 'jump_to', 'label', 'optional', 'starts_ai_analysis', 'tag', 'tag_number', 'tag_relationship', 'type', 'uuid', 'value']
} as const;

export const $QuestionnaireQuestionRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        help: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/QuestionnaireQuestionTypeEnum'
        },
        tag: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireQuestionTagEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_number: {
            type: 'integer',
            maximum: 10,
            minimum: 1,
            nullable: true
        },
        label: {
            type: 'string',
            minLength: 1
        },
        value: {
            type: 'string',
            nullable: true
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        jump_to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JumpToRequest'
            },
            nullable: true
        },
        optional: {
            type: 'boolean'
        },
        starts_ai_analysis: {
            type: 'boolean'
        }
    },
    required: ['help', 'jump_to', 'label', 'optional', 'starts_ai_analysis', 'tag', 'tag_number', 'tag_relationship', 'type', 'uuid', 'value']
} as const;

export const $QuestionnaireQuestionTagEnum = {
    enum: ['entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip', 'law.criminal_law_amount_of_daily_rates', 'law.criminal_law_applicable_laws', 'law.criminal_law_charge_description', 'law.criminal_law_complaint', 'law.criminal_law_criminal_warrant', 'law.criminal_law_damage_description', 'law.criminal_law_damage_value', 'law.criminal_law_date_of_offense', 'law.criminal_law_duration_of_prison_sentence', 'law.criminal_law_evidence_location', 'law.criminal_law_evidence', 'law.criminal_law_incident_description', 'law.criminal_law_indictment_date', 'law.criminal_law_indictment_delivery_date', 'law.criminal_law_indictment', 'law.criminal_law_legal_classification_of_offense', 'law.criminal_law_means_of_evidence', 'law.criminal_law_number_of_daily_rates', 'law.criminal_law_offense_type', 'law.criminal_law_penalty_infromation', 'law.criminal_law_physical_evidence', 'law.criminal_law_place_of_offense', 'law.criminal_law_police_file_number', 'law.criminal_law_preliminary_proceedings_date', 'law.criminal_law_prison_sentence', 'law.criminal_law_probation', 'law.criminal_law_prosecution_file_number', 'law.criminal_law_report_date', 'law.criminal_law_report_time', 'law.criminal_law_time_of_offense', 'law.debt_collection_law_invoice_amount', 'law.debt_collection_law_invoice_date', 'law.debt_collection_law_invoice_ground', 'law.debt_collection_law_invoice', 'law.debt_collection_law_invoice_number', 'law.debt_collection_law_invoice_recipient', 'law.debt_collection_law_invoice_tax_number', 'law.external_case_id', 'law.family_law_average_net_income', 'law.family_law_birth_certificate', 'law.family_law_birth_register_number', 'law.family_law_birth_register_office_location', 'law.family_law_children', 'law.family_law_date_of_marriage', 'law.family_law_divorce_application', 'law.family_law_divorce_settlement_agreement', 'law.family_law_marriage_certificate', 'law.family_law_marriage_contract_date', 'law.family_law_marriage_contract', 'law.family_law_marriage_register_number', 'law.family_law_registry_office_location', 'law.family_law_separation_date', 'law.field', 'law.generic_document', 'law.inheritance_law_certificate_of_inheritance_applicable_law', 'law.inheritance_law_certificate_of_inheritance_date_death', 'law.inheritance_law_certificate_of_inheritance_date', 'law.inheritance_law_certificate_of_inheritance', 'law.inheritance_law_certificate_of_inheritance_number', 'law.inheritance_law_certificate_of_inheritance_place_of_death', 'law.inheritance_law_death_certificate_date_death', 'law.inheritance_law_death_certificate_date', 'law.inheritance_law_death_certificate', 'law.inheritance_law_death_certificate_number', 'law.inheritance_law_death_certificate_place_death', 'law.inheritance_law_death_certificate_place', 'law.inheritance_law_death_certificate_time_death', 'law.inheritance_law_estate_inventory_amount', 'law.inheritance_law_estate_inventory_date', 'law.inheritance_law_estate_inventory_status', 'law.inheritance_law_inheritance_contract_date', 'law.inheritance_law_inheritance_contract', 'law.inheritance_law_lasting_power_of_attorney_date', 'law.inheritance_law_lasting_power_of_attorney', 'law.inheritance_law_list_of_estate', 'law.inheritance_law_living_will', 'law.inheritance_law_patient_enrollment_date', 'law.inheritance_law_testament_date', 'law.inheritance_law_will', 'law.labor_law_beginning_of_employment', 'law.labor_law_child_allowances', 'law.labor_law_collective_agreement', 'law.labor_law_company_agreement', 'law.labor_law_different_place_of_work', 'law.labor_law_employee_probation_period_end_date', 'law.labor_law_fixed_term_contract_duration', 'law.labor_law_fixed_term_contract', 'law.labor_law_is_employee_in_probation_period', 'law.labor_law_job_title', 'law.labor_law_married', 'law.labor_law_monthly_gross_salary', 'law.labor_law_monthly_working_days', 'law.labor_law_notice_period', 'law.labor_law_payslip', 'law.labor_law_place_of_work', 'law.labor_law_settlement_agreement_date', 'law.labor_law_settlement_agreement', 'law.labor_law_signature_of_employer', 'law.labor_law_special_payments_amount', 'law.labor_law_special_payments', 'law.labor_law_special_protection_against_dismissal', 'law.labor_law_termination_access_to_termination_to_employee', 'law.labor_law_termination_agreement_date', 'law.labor_law_termination_agreement', 'law.labor_law_termination_agreement_severance_pay_amount', 'law.labor_law_termination_agreement_termination_date', 'law.labor_law_termination_date_effective', 'law.labor_law_termination_date', 'law.labor_law_termination_employer_more_than_10_employees', 'law.labor_law_termination_is_agreement_severance_pay', 'law.labor_law_termination', 'law.labor_law_vacation_days', 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee', 'law.labor_law_warning_letter_date', 'law.labor_law_warning_letter_incident_date', 'law.labor_law_warning_letter_incident_location', 'law.labor_law_warning_letter_incident_time', 'law.labor_law_warning_letter', 'law.labor_law_warning_letter_reason', 'law.labor_law_work_contract', 'law.labor_law_work_council', 'law.labor_law_work_hours_per_week', 'law.labor_law_yearly_gross_salary', 'law.residential_property_law_co_ownership_shares', 'law.residential_property_law_contract_date', 'law.residential_property_law_contract', 'law.residential_property_law_inventory', 'law.residential_property_law_land_register_address', 'law.residential_property_law_land_register_city', 'law.residential_property_law_land_register_number', 'law.residential_property_law_land_register_plot_of_land', 'law.social_law_application_arrival_date', 'law.social_law_application_date', 'law.social_law_notice_date', 'law.social_law_notice_of_objection_date', 'law.social_law_notice_of_objection', 'law.social_law_summary_grounds_opposition', 'law.tenancy_law_adress_rental_property', 'law.tenancy_law_advance_payment_service_charges', 'law.tenancy_law_description_of_rental_property', 'law.tenancy_law_duration_of_lease', 'law.tenancy_law_fixed_term_tenancy', 'law.tenancy_law_gross_rent', 'law.tenancy_law_lease_agreement', 'law.tenancy_law_location_in_rental_property', 'law.tenancy_law_net_rent', 'law.tenancy_law_rental_agreement_date', 'law.tenancy_law_rental_agreement', 'law.tenancy_law_rental_agreement_validity_end', 'law.tenancy_law_rental_agreement_validity_start', 'law.tenancy_law_staggered_rental_agreement', 'law.tenancy_law_start_of_lease', 'law.tenancy_law_total_rent', 'law.tenancy_law_unlimited_term_tenancy', 'law.topic', 'law.traffic_law_accident_date', 'law.traffic_law_accident_report', 'law.traffic_law_amount_of_fine', 'law.traffic_law_appeal_instruction', 'law.traffic_law_at_fault_driver_drivers_license_issued_by', 'law.traffic_law_at_fault_driver_drivers_license_valid_until', 'law.traffic_law_at_fault_driver_green_card_number', 'law.traffic_law_at_fault_driver_insurance_expiry_date', 'law.traffic_law_at_fault_driver_insurance_number', 'law.traffic_law_at_fault_driver_insurer', 'law.traffic_law_blood_alcohol_concentration', 'law.traffic_law_calculated_total_damage_costs', 'law.traffic_law_calculated_total_days', 'law.traffic_law_charges', 'law.traffic_law_daily_rate', 'law.traffic_law_damage_scope', 'law.traffic_law_date_of_accident', 'law.traffic_law_date_of_crime', 'law.traffic_law_date_of_fine', 'law.traffic_law_date_of_infraction', 'law.traffic_law_date_of_inspection', 'law.traffic_law_date_of_issue', 'law.traffic_law_date_of_offense', 'law.traffic_law_differencial_tax', 'law.traffic_law_driver_logbook_required', 'law.traffic_law_driving_ban_duration', 'law.traffic_law_driving_ban', 'law.traffic_law_evidence_infraction', 'law.traffic_law_expert_date', 'law.traffic_law_expert_report', 'law.traffic_law_expert_report_number', 'law.traffic_law_file_number', 'law.traffic_law_fine', 'law.traffic_law_fine_notice', 'law.traffic_law_gross_gross_replacement_value', 'law.traffic_law_gross_replacement_value', 'law.traffic_law_injured', 'law.traffic_law_insurance_holder', 'law.traffic_law_insurance', 'law.traffic_law_legal_basis_infraction', 'law.traffic_law_legal_basis', 'law.traffic_law_licenseplate_at_fault_driver', 'law.traffic_law_licenseplate', 'law.traffic_law_licenseplate_victim_driver', 'law.traffic_law_loss_of_use_per_day', 'law.traffic_law_mark_and_type_of_at_fault_driver', 'law.traffic_law_mark_and_type_of_victim_driver', 'law.traffic_law_merantile_value_loss', 'law.traffic_law_net_gross_replacement_value', 'law.traffic_law_net_replacement_value', 'law.traffic_law_number_of_daily_rates', 'law.traffic_law_offense_infraction_description', 'law.traffic_law_other_damages', 'law.traffic_law_payment_deadline', 'law.traffic_law_penalty_order', 'law.traffic_law_place_of_accident', 'law.traffic_law_place_of_crime', 'law.traffic_law_place_of_infraction', 'law.traffic_law_place_of_inspection', 'law.traffic_law_place_of_issue', 'law.traffic_law_place_of_offense', 'law.traffic_law_points_for_offense', 'law.traffic_law_police_case_number', 'law.traffic_law_procedure_costs', 'law.traffic_law_prosecution_number', 'law.traffic_law_regular_tax', 'law.traffic_law_repair_costs_with_vat', 'law.traffic_law_repair_costs_without_vat', 'law.traffic_law_repair_duration', 'law.traffic_law_replacement_value', 'law.traffic_law_reregistration_cost', 'law.traffic_law_residual_value', 'law.traffic_law_speed_allowed', 'law.traffic_law_speed_driven', 'law.traffic_law_speed_too_high', 'law.traffic_law_time_of_accident', 'law.traffic_law_time_of_crime', 'law.traffic_law_time_of_infraction', 'law.traffic_law_time_of_inspection', 'law.traffic_law_time_of_issue', 'law.traffic_law_time_of_offense', 'law.traffic_law_vehicle_age_months', 'law.traffic_law_vehicle_mileage', 'law.traffic_law_vehicle_type_and_brand', 'law.traffic_law_victim_driver_drivers_license_issued_by', 'law.traffic_law_victim_driver_green_card_number', 'law.traffic_law_victim_driver_insurance_expiry_date', 'law.traffic_law_victim_driver_insurance_number', 'law.traffic_law_victim_driver_insurer', 'law.traffic_law_victim_driver_license_valid_until', 'law.traffic_law_violated_section', 'law.traffic_law_violation_type', 'law.traffic_law_warning_fee_infraction', 'law.traffic_law_warning_notice'],
    type: 'string',
    description: `* \`entities.field.bank_name\` - Bankname
* \`entities.field.bic\` - BIC
* \`entities.field.city\` - Ort
* \`entities.field.company_legal_form\` - Rechtsform
* \`entities.field.company_name\` - Firmenname
* \`entities.field.company_register_court\` - Amtsgericht
* \`entities.field.company_register_number\` - Handelsregisternummer
* \`entities.field.company_tax_id\` - Steuernummer
* \`entities.field.company_vat_id\` - USt. ID
* \`entities.field.date_of_birth\` - Geburtsdatum
* \`entities.field.date_of_death\` - Sterbedatum
* \`entities.field.email\` - E-Mail
* \`entities.field.entity_type\` - Personentyp
* \`entities.field.fax\` - Fax
* \`entities.field.first_name\` - Vorname
* \`entities.field.iban\` - IBAN
* \`entities.field.institution_name\` - Name der Institution
* \`entities.field.is_entitled_to_deduct_vat\` - Vorsteuerabzugsberechtigt
* \`entities.field.last_name\` - Nachname
* \`entities.field.legal_insurance_deductible_amount\` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
* \`entities.field.legal_insurance\` - Rechtsschutzversicherung
* \`entities.field.legal_insurance_name\` - Name der Rechtsschutzversicherung
* \`entities.field.legal_insurance_number\` - Nummer der Rechtsschutzversicherung
* \`entities.field.marital_status\` - Familienstand
* \`entities.field.phone\` - Telefon
* \`entities.field.specific_title\` - Titel
* \`entities.field.street\` - Straße
* \`entities.field.street_number\` - Hausnummer
* \`entities.field.title\` - Anrede
* \`entities.field.website\` - Website
* \`entities.field.zip\` - PLZ
* \`law.criminal_law_amount_of_daily_rates\` - Betrag der Tagessatz
* \`law.criminal_law_applicable_laws\` - Anwendbare Vorschriften
* \`law.criminal_law_charge_description\` - Anklagesatz
* \`law.criminal_law_complaint\` - Anzeige
* \`law.criminal_law_criminal_warrant\` - Strafbefehl
* \`law.criminal_law_damage_description\` - Beschreibung des Schadens
* \`law.criminal_law_damage_value\` - Schadenshöhe in EUR
* \`law.criminal_law_date_of_offense\` - Datum der Tat
* \`law.criminal_law_duration_of_prison_sentence\` - Dauer der Freiheitsstrafe
* \`law.criminal_law_evidence_location\` - Standort der Beweismittel
* \`law.criminal_law_evidence\` - Beweis
* \`law.criminal_law_incident_description\` - Sachverhalt
* \`law.criminal_law_indictment_date\` - Datum der Anklageschrift
* \`law.criminal_law_indictment_delivery_date\` - Datum der Zustellung der Anklageschrift
* \`law.criminal_law_indictment\` - Anklageschrift
* \`law.criminal_law_legal_classification_of_offense\` - Vergehen auf der Grundlage von
* \`law.criminal_law_means_of_evidence\` - Beweismittel
* \`law.criminal_law_number_of_daily_rates\` - Tagessatz
* \`law.criminal_law_offense_type\` - Art des Delikts
* \`law.criminal_law_penalty_infromation\` - Strafe
* \`law.criminal_law_physical_evidence\` - Beschreibung der Beweismittel
* \`law.criminal_law_place_of_offense\` - Ort der Tat
* \`law.criminal_law_police_file_number\` - Vorgangsnummer
* \`law.criminal_law_preliminary_proceedings_date\` - Datum der Einleitung des Ermittlungsverfahrens
* \`law.criminal_law_prison_sentence\` - Freiheitsstrafe
* \`law.criminal_law_probation\` - Bewärung
* \`law.criminal_law_prosecution_file_number\` - Aktenzeichen der Staatsanwaltschaft
* \`law.criminal_law_report_date\` - Datum der Anzeigenerstattung
* \`law.criminal_law_report_time\` - Uhrzeit der Anzeigenerstattung
* \`law.criminal_law_time_of_offense\` - Uhrzeit der Tat
* \`law.debt_collection_law_invoice_amount\` - Rechnungsbetrag
* \`law.debt_collection_law_invoice_date\` - Rechnungsdatum
* \`law.debt_collection_law_invoice_ground\` - Rechnungsgrund
* \`law.debt_collection_law_invoice\` - Rechnung
* \`law.debt_collection_law_invoice_number\` - Rechnungsnummer
* \`law.debt_collection_law_invoice_recipient\` - Rechnungsadressat
* \`law.debt_collection_law_invoice_tax_number\` - Steuernummer
* \`law.external_case_id\` - external case id
* \`law.family_law_average_net_income\` - Durchschnittliches Nettoeinkommen
* \`law.family_law_birth_certificate\` - Geburtsurkunden
* \`law.family_law_birth_register_number\` - Geburtsurkundennummer
* \`law.family_law_birth_register_office_location\` - Standesamt Geburtsurkunde
* \`law.family_law_children\` - Kinder vorhanden
* \`law.family_law_date_of_marriage\` - Eheschließungsdatum
* \`law.family_law_divorce_application\` - Ehescheidungsantrag
* \`law.family_law_divorce_settlement_agreement\` - Scheidungsfolgenvereinbarung
* \`law.family_law_marriage_certificate\` - Eheurkunde
* \`law.family_law_marriage_contract_date\` - Ehevertragsdatum
* \`law.family_law_marriage_contract\` - Ehevertrag
* \`law.family_law_marriage_register_number\` - Eheregisternummer
* \`law.family_law_registry_office_location\` - Standesamt Ort
* \`law.family_law_separation_date\` - Trennungsdatumdatum
* \`law.field\` - Rechtsgebiet
* \`law.generic_document\` - Anderes Dokument
* \`law.inheritance_law_certificate_of_inheritance_applicable_law\` - Anwendbares Recht
* \`law.inheritance_law_certificate_of_inheritance_date_death\` - Todesdatum
* \`law.inheritance_law_certificate_of_inheritance_date\` - Datum Erbscheins
* \`law.inheritance_law_certificate_of_inheritance\` - Erbschein
* \`law.inheritance_law_certificate_of_inheritance_number\` - Nummer des Erbscheins
* \`law.inheritance_law_certificate_of_inheritance_place_of_death\` - Todesort
* \`law.inheritance_law_death_certificate_date_death\` - Todesdatum
* \`law.inheritance_law_death_certificate_date\` - Datum Sterbeurkunde
* \`law.inheritance_law_death_certificate\` - Sterbeurkunde
* \`law.inheritance_law_death_certificate_number\` - Nummer Sterbeurkunde
* \`law.inheritance_law_death_certificate_place_death\` - Ort des Todes
* \`law.inheritance_law_death_certificate_place\` - Ort Sterbeurkunde
* \`law.inheritance_law_death_certificate_time_death\` - Uhrzeit des Todes
* \`law.inheritance_law_estate_inventory_amount\` - Nettonachlass
* \`law.inheritance_law_estate_inventory_date\` - Datum Nachlassverzeichnis
* \`law.inheritance_law_estate_inventory_status\` - Güterstand
* \`law.inheritance_law_inheritance_contract_date\` - Datum des Erbvertrags
* \`law.inheritance_law_inheritance_contract\` - Erbvertrag
* \`law.inheritance_law_lasting_power_of_attorney_date\` - Datum Vorsorgevollmacht
* \`law.inheritance_law_lasting_power_of_attorney\` - Vorsorgevollmacht
* \`law.inheritance_law_list_of_estate\` - Nachlassverzeichnis
* \`law.inheritance_law_living_will\` - Patientenverfügung
* \`law.inheritance_law_patient_enrollment_date\` - Datum Patientenverfügung
* \`law.inheritance_law_testament_date\` - Datum des Testaments
* \`law.inheritance_law_will\` - Testament
* \`law.labor_law_beginning_of_employment\` - Datum Beginn des Arbeitsverhältnisses
* \`law.labor_law_child_allowances\` - Kinderfreibeträge
* \`law.labor_law_collective_agreement\` - Tarifvertrag
* \`law.labor_law_company_agreement\` - Betriebsvereinbarung
* \`law.labor_law_different_place_of_work\` - Abweichender Arbeitsort
* \`law.labor_law_employee_probation_period_end_date\` - Datum Ende der Probezeit
* \`law.labor_law_fixed_term_contract_duration\` - Ende befristetes Arbeitsverhältnis
* \`law.labor_law_fixed_term_contract\` - Befristetes Arbeitsverhältnis
* \`law.labor_law_is_employee_in_probation_period\` - Arbeitnehmer in Probezeit
* \`law.labor_law_job_title\` - Berufsbezeichnung
* \`law.labor_law_married\` - Verheiratet
* \`law.labor_law_monthly_gross_salary\` - Gehalt, monatlich, brutto
* \`law.labor_law_monthly_working_days\` - Arbeitsstunden pro Monat
* \`law.labor_law_notice_period\` - Kündigungsfrist in Monaten
* \`law.labor_law_payslip\` - Lohnabrechnung
* \`law.labor_law_place_of_work\` - Arbeitsort
* \`law.labor_law_settlement_agreement_date\` - Datum Abwicklungsvertrag
* \`law.labor_law_settlement_agreement\` - Abwicklungsvertrag
* \`law.labor_law_signature_of_employer\` - Unterschrift Arbeitgeber
* \`law.labor_law_special_payments_amount\` - Höhe Sonderzahlungen
* \`law.labor_law_special_payments\` - Sonderzahlungen
* \`law.labor_law_special_protection_against_dismissal\` - Sonderkündigungsschutz
* \`law.labor_law_termination_access_to_termination_to_employee\` - Datum Zugang Kündigung beim Arbeitnehmer
* \`law.labor_law_termination_agreement_date\` - Datum Aufhebungsvertrag
* \`law.labor_law_termination_agreement\` - Aufhebungsvertrag
* \`law.labor_law_termination_agreement_severance_pay_amount\` - Abfindung Höhe
* \`law.labor_law_termination_agreement_termination_date\` - Datum Beendigung Arbeitsverhältnis
* \`law.labor_law_termination_date_effective\` - Kündigung erfolgt zu welchem Datum
* \`law.labor_law_termination_date\` - Datum Kündigung durch Arbeitgeber
* \`law.labor_law_termination_employer_more_than_10_employees\` - Arbeitgeber hat mehr als 10 Mitarbeiter
* \`law.labor_law_termination_is_agreement_severance_pay\` - Abfindung vereinbart
* \`law.labor_law_termination\` - Kündigung
* \`law.labor_law_vacation_days\` - Urlaubstage
* \`law.labor_law_wanring_letter_access_to_warning_letter_to_employee\` - Datum Zugang Abmahnung beim Arbeitnehmer
* \`law.labor_law_warning_letter_date\` - Datum Abmahnung
* \`law.labor_law_warning_letter_incident_date\` - Datum des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter_incident_location\` - Ort des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter_incident_time\` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter\` - Abmahnung
* \`law.labor_law_warning_letter_reason\` - Grund der Abmahnung
* \`law.labor_law_work_contract\` - Arbeitsvertrag
* \`law.labor_law_work_council\` - Betriebsrat
* \`law.labor_law_work_hours_per_week\` - Arbeitsstunden pro Woche
* \`law.labor_law_yearly_gross_salary\` - Gehalt, jährlich, brutto
* \`law.residential_property_law_co_ownership_shares\` - Miteigentumsanteile
* \`law.residential_property_law_contract_date\` - Wegvertragsdatum
* \`law.residential_property_law_contract\` - Wegvertrag
* \`law.residential_property_law_inventory\` - Bestandsverzeichnis
* \`law.residential_property_law_land_register_address\` - Grundbuch Lage
* \`law.residential_property_law_land_register_city\` - Grundbuch Stadt
* \`law.residential_property_law_land_register_number\` - Grundbuch Nr.
* \`law.residential_property_law_land_register_plot_of_land\` - Grundbuch Flurstück
* \`law.social_law_application_arrival_date\` - Eingang Antrag Datum
* \`law.social_law_application_date\` - Antrag Datum
* \`law.social_law_notice_date\` - Bescheid Datum
* \`law.social_law_notice_of_objection_date\` - Widerspruchbescheid Datum
* \`law.social_law_notice_of_objection\` - Widerspruchbescheid
* \`law.social_law_summary_grounds_opposition\` - Begründung des Widerspruchs
* \`law.tenancy_law_adress_rental_property\` - Adresse Mietobjekt
* \`law.tenancy_law_advance_payment_service_charges\` - Nebenkostenvorauszahlungshöhe
* \`law.tenancy_law_description_of_rental_property\` - Beschreibung Mietobjekt
* \`law.tenancy_law_duration_of_lease\` - Dauer Pachtvertrag
* \`law.tenancy_law_fixed_term_tenancy\` - befristeter Mietvertrag
* \`law.tenancy_law_gross_rent\` - Bruttomiete
* \`law.tenancy_law_lease_agreement\` - Pachtvertrag
* \`law.tenancy_law_location_in_rental_property\` - Lage im Mietobjekt
* \`law.tenancy_law_net_rent\` - Nettomiete
* \`law.tenancy_law_rental_agreement_date\` - Mietvertragsdatum
* \`law.tenancy_law_rental_agreement\` - Mietvertrag
* \`law.tenancy_law_rental_agreement_validity_end\` - Mietvertragsende
* \`law.tenancy_law_rental_agreement_validity_start\` - Mietvertragsbeginn
* \`law.tenancy_law_staggered_rental_agreement\` - Staffelmietvereinbarung
* \`law.tenancy_law_start_of_lease\` - Beginn Pachtvertrag
* \`law.tenancy_law_total_rent\` - Gesamtmiete
* \`law.tenancy_law_unlimited_term_tenancy\` - unbefristeter Mietvertrag
* \`law.topic\` - Rechtsthema
* \`law.traffic_law_accident_date\` - Unfallverursacher - Vers.-Schein gültig bis
* \`law.traffic_law_accident_report\` - Unfallbericht
* \`law.traffic_law_amount_of_fine\` - Bußgeldhöhe
* \`law.traffic_law_appeal_instruction\` - Rechtsbehelfsbelehrung
* \`law.traffic_law_at_fault_driver_drivers_license_issued_by\` - Unfallverursacher - Führerschein ausgestellt durch
* \`law.traffic_law_at_fault_driver_drivers_license_valid_until\` - Unfallverursacher - Führerschein gültig bis
* \`law.traffic_law_at_fault_driver_green_card_number\` - Unfallverursacher - Nr. der Grünen Karte
* \`law.traffic_law_at_fault_driver_insurance_expiry_date\` - Unfallverursacher - Vers.-Schein gültig bis
* \`law.traffic_law_at_fault_driver_insurance_number\` - Unfallverursacher - Vers.-Nr.
* \`law.traffic_law_at_fault_driver_insurer\` - Unfallverursacher - Versicherer
* \`law.traffic_law_blood_alcohol_concentration\` - Blutalkoholkonzentration
* \`law.traffic_law_calculated_total_damage_costs\` - Gesamtschadenshöhe
* \`law.traffic_law_calculated_total_days\` - Gesamttagen
* \`law.traffic_law_charges\` - Tatvorwurf
* \`law.traffic_law_daily_rate\` - Höhe des Tagessatzes
* \`law.traffic_law_damage_scope\` - Schadenumfang
* \`law.traffic_law_date_of_accident\` - Unfalltag
* \`law.traffic_law_date_of_crime\` - Datum der Tat
* \`law.traffic_law_date_of_fine\` - Datum Bußgeldbescheid
* \`law.traffic_law_date_of_infraction\` - Datum der Ordnungswidrigkeit
* \`law.traffic_law_date_of_inspection\` - Besichtigungsdatum
* \`law.traffic_law_date_of_issue\` - Datum der Ausstellung
* \`law.traffic_law_date_of_offense\` - Datum der Tat
* \`law.traffic_law_differencial_tax\` - Differenzsteuer
* \`law.traffic_law_driver_logbook_required\` - Fahrtenbuch erforderlich
* \`law.traffic_law_driving_ban_duration\` - Fahrverbot Dauer
* \`law.traffic_law_driving_ban\` - Fahrverbot verhängt
* \`law.traffic_law_evidence_infraction\` - Beweismittel
* \`law.traffic_law_expert_date\` - Unfallverursacher - Sachverständigengutachten
* \`law.traffic_law_expert_report\` - Sachverständigengutachten
* \`law.traffic_law_expert_report_number\` - Gutachten Nummer
* \`law.traffic_law_file_number\` - Aktenzeichen
* \`law.traffic_law_fine\` - Geldstrafe
* \`law.traffic_law_fine_notice\` - Bußgeldbescheid
* \`law.traffic_law_gross_gross_replacement_value\` - Brutto-Brutto-Wiederbeschaffungswert
* \`law.traffic_law_gross_replacement_value\` - Bruttowiederbeschaffungswert
* \`law.traffic_law_injured\` - Verletzte
* \`law.traffic_law_insurance_holder\` - Versicherungsnehmer
* \`law.traffic_law_insurance\` - Versicherung
* \`law.traffic_law_legal_basis_infraction\` - Gesetzliche Grundlage
* \`law.traffic_law_legal_basis\` - Gesetzliche Grundlage
* \`law.traffic_law_licenseplate_at_fault_driver\` - KFZ-Kennzeichen des Unfallverursachers
* \`law.traffic_law_licenseplate\` - KFZ-Kennzeichen
* \`law.traffic_law_licenseplate_victim_driver\` - KFZ-Kennzeichen des Unfallgeschädigten
* \`law.traffic_law_loss_of_use_per_day\` - Nutzungsausfallentschädigung pro Tag
* \`law.traffic_law_mark_and_type_of_at_fault_driver\` - Unfallverursacher - Marke, Typ des Fahrzeugs
* \`law.traffic_law_mark_and_type_of_victim_driver\` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
* \`law.traffic_law_merantile_value_loss\` - Merkantile Wertminderung
* \`law.traffic_law_net_gross_replacement_value\` - Netto-Brutto-Wiederbeschaffungswert
* \`law.traffic_law_net_replacement_value\` - Nettowiederbeschaffungswert
* \`law.traffic_law_number_of_daily_rates\` - Anzahl der Tagessätze
* \`law.traffic_law_offense_infraction_description\` - Tatbestand
* \`law.traffic_law_other_damages\` - Andere Sachschäden
* \`law.traffic_law_payment_deadline\` - Zahlungsfrist
* \`law.traffic_law_penalty_order\` - Strafbefehl
* \`law.traffic_law_place_of_accident\` - Unfallort
* \`law.traffic_law_place_of_crime\` - Ort der Tat
* \`law.traffic_law_place_of_infraction\` - Ort der Ordnungswidrigkeit
* \`law.traffic_law_place_of_inspection\` - Besichtigungsort
* \`law.traffic_law_place_of_issue\` - Ort der Ausstellung
* \`law.traffic_law_place_of_offense\` - Ort der Tat
* \`law.traffic_law_points_for_offense\` - Punkte
* \`law.traffic_law_police_case_number\` - Polizeiliches Aktenzeichen
* \`law.traffic_law_procedure_costs\` - Verfahrenskosten
* \`law.traffic_law_prosecution_number\` - Geschäftsnummer
* \`law.traffic_law_regular_tax\` - Regelsteuer
* \`law.traffic_law_repair_costs_with_vat\` - Reparaturkosten Brutto
* \`law.traffic_law_repair_costs_without_vat\` - Reparaturkosten Netto
* \`law.traffic_law_repair_duration\` - Reparaturdauer Tage
* \`law.traffic_law_replacement_value\` - Wiederbeschaffungswert
* \`law.traffic_law_reregistration_cost\` - Ummeldekosten
* \`law.traffic_law_residual_value\` - Restwert Brutto
* \`law.traffic_law_speed_allowed\` - Erlaubte Geschwindigkeit
* \`law.traffic_law_speed_driven\` - Gefahrene Geschwindigkeit
* \`law.traffic_law_speed_too_high\` - Überschreitung Geschwindigkeit
* \`law.traffic_law_time_of_accident\` - Uhrzeit Unfall
* \`law.traffic_law_time_of_crime\` - Uhrzeit der Tat
* \`law.traffic_law_time_of_infraction\` - Uhrzeit der Ordnungswidrigkeit
* \`law.traffic_law_time_of_inspection\` - Besichtigungszeit
* \`law.traffic_law_time_of_issue\` - Tag der Ausstellung
* \`law.traffic_law_time_of_offense\` - Uhrzeit der Tat
* \`law.traffic_law_vehicle_age_months\` - Fahrzeugalter in Monaten
* \`law.traffic_law_vehicle_mileage\` - Fahrzeugleistung in km
* \`law.traffic_law_vehicle_type_and_brand\` - Fahrzeugtyp und Marke
* \`law.traffic_law_victim_driver_drivers_license_issued_by\` - Unfallgeschädigter - Führerschein ausgestellt durch
* \`law.traffic_law_victim_driver_green_card_number\` - Unfallgeschädigter - Nr. der Grünen Karte
* \`law.traffic_law_victim_driver_insurance_expiry_date\` - Unfallgeschädigter - Vers.-Schein gültig bis
* \`law.traffic_law_victim_driver_insurance_number\` - Unfallgeschädigter - Vers.-Nr.
* \`law.traffic_law_victim_driver_insurer\` - Unfallgeschädigter - Versicherer
* \`law.traffic_law_victim_driver_license_valid_until\` - Unfallgeschädigter - Führerschein gültig bis
* \`law.traffic_law_violated_section\` - Verletzte Vorschrift
* \`law.traffic_law_violation_type\` - Tatvorwurf
* \`law.traffic_law_warning_fee_infraction\` - Verwarnungsgeldbetrag
* \`law.traffic_law_warning_notice\` - Verwarnungsgeldbescheid`
} as const;

export const $QuestionnaireQuestionTypeEnum = {
    enum: ['multiselect', 'select', 'textarea', 'filefield', 'multifilefield', 'timefield', 'decimalnumberinput', 'datefield', 'textinput', 'numberinput', 'emailinput', 'phoneinput', 'urlinput', 'yesno'],
    type: 'string',
    description: `* \`multiselect\` - Multiple choice
* \`select\` - Single choice
* \`textarea\` - Long text
* \`filefield\` - File input
* \`multifilefield\` - Multi file input
* \`timefield\` - Time field
* \`decimalnumberinput\` - Decimal number
* \`datefield\` - Date
* \`textinput\` - Short text
* \`numberinput\` - Number
* \`emailinput\` - Email
* \`phoneinput\` - Phone
* \`urlinput\` - URL
* \`yesno\` - Yes/No`
} as const;

export const $QuestionnaireSection = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string'
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireQuestion'
            }
        },
        title: {
            type: 'string'
        }
    },
    required: ['items', 'title', 'uuid']
} as const;

export const $QuestionnaireSectionRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireQuestionRequest'
            }
        },
        title: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['items', 'title', 'uuid']
} as const;

export const $RaMicroDataRequest = {
    type: 'object',
    properties: {
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $RelationshipTypeEnum = {
    enum: ['entities.opponent', 'entities.client', 'entities.other', 'entities.labor_law_employee', 'entities.labor_law_employer', 'entities.witness', 'entities.at_fault_driver', 'entities.victim_driver', 'entities.accused', 'entities.defendant', 'entities.plaintiff', 'entities.complaint', 'entities.victim', 'entities.vehicle_expert', 'entities.agency', 'entities.vehicle_owner', 'entities.insurance', 'entities.driver', 'entities.police_officer', 'entities.police_station', 'entities.judge', 'entities.court', 'entities.prosecutor', 'entities.prosecuting_office', 'entities.opposing_counsel', 'entities.expert_witness', 'entities.co_plaintiff', 'entities.probation_officer', 'entities.tenant', 'entities.landlord', 'entities.subtenant', 'entities.owner', 'entities.property_management', 'entities.real_estate_agent', 'entities.guarantor', 'entities.co_owner', 'entities.co_tenant', 'entities.tenants_association', 'entities.property_owners_association', 'entities.complainant', 'entities.applicant', 'entities.respondent', 'entities.child', 'entities.officiant', 'entities.wife', 'entities.husband', 'entities.legal_representative', 'entities.korrespondence_lawyer', 'entities.opposing_lawyer', 'entities.legal_expenses_insurance', 'entities.liability_insurance', 'entities.first_instance_court', 'entities.second_instance_court', 'entities.third_instance_court', 'entities.contact_person', 'entities.public_prosecutor', 'entities.third_party_debtor', 'entities.road_traffic_office', 'entities.debt_collection_agency', 'entities.expert', 'entities.tax_office', 'entities.land_registry', 'entities.bank', 'entities.buyer', 'entities.dunning_court', 'entities.enforcement_court', 'entities.general_prosecutor', 'entities.seller', 'entities.expert_committee', 'entities.municipality', 'entities.administrator', 'entities.register_court', 'entities.probate_court', 'entities.registry_office', 'entities.hereditary_leaseholder', 'entities.legal_aid_court', 'entities.secondary_client', 'entities.secondary_opponent', 'entities.court_complaint', 'entities.fine_authority', 'entities.resident_registration_office', 'entities.investigator', 'entities.bailiff', 'entities.insolvency_court', 'entities.integration_office', 'entities.mahn_court', 'entities.execution_court', 'entities.execution_organ', 'entities.debtor', 'entities.creditor', 'entities.lessee', 'entities.lessor', 'entities.principal', 'entities.authorized_representative', 'entities.testator', 'entities.heir', 'entities.preliminary_heir', 'entities.subsequent_heir', 'entities.curator_of_the_estate', 'entities.executor_of_the_will', 'entities.estate_administrator', 'entities.compulsory_portion_beneficiary'],
    type: 'string',
    description: `* \`entities.opponent\` - Opponent
* \`entities.client\` - Client
* \`entities.other\` - Other
* \`entities.labor_law_employee\` - Labor Law Employee
* \`entities.labor_law_employer\` - Labor Law Employer
* \`entities.witness\` - Witness
* \`entities.at_fault_driver\` - At Fault Driver
* \`entities.victim_driver\` - Victim Driver
* \`entities.accused\` - Accused
* \`entities.defendant\` - Defendant
* \`entities.plaintiff\` - Plaintiff
* \`entities.complaint\` - Complaint
* \`entities.victim\` - Victim
* \`entities.vehicle_expert\` - Vehicle Expert
* \`entities.agency\` - Agency
* \`entities.vehicle_owner\` - Vehicle Owner
* \`entities.insurance\` - Insurance
* \`entities.driver\` - Driver
* \`entities.police_officer\` - Police Officer
* \`entities.police_station\` - Police Station
* \`entities.judge\` - Judge
* \`entities.court\` - Court
* \`entities.prosecutor\` - Prosecutor
* \`entities.prosecuting_office\` - Prosecuting Office
* \`entities.opposing_counsel\` - Opposing Counsel
* \`entities.expert_witness\` - Expert Witness
* \`entities.co_plaintiff\` - Co Plaintiff
* \`entities.probation_officer\` - Probation Officer
* \`entities.tenant\` - Tenant
* \`entities.landlord\` - Landlord
* \`entities.subtenant\` - Subtenant
* \`entities.owner\` - Owner
* \`entities.property_management\` - Property Management
* \`entities.real_estate_agent\` - Real Estate Agent
* \`entities.guarantor\` - Guarantor
* \`entities.co_owner\` - Co Owner
* \`entities.co_tenant\` - Co Tenant
* \`entities.tenants_association\` - Tenants Association
* \`entities.property_owners_association\` - Property Owners Association
* \`entities.complainant\` - Complainant
* \`entities.applicant\` - Applicant
* \`entities.respondent\` - Respondent
* \`entities.child\` - Child
* \`entities.officiant\` - Officiant
* \`entities.wife\` - Wife
* \`entities.husband\` - Husband
* \`entities.legal_representative\` - Legal Representative
* \`entities.korrespondence_lawyer\` - Korrespondence Lawyer
* \`entities.opposing_lawyer\` - Opposing Lawyer
* \`entities.legal_expenses_insurance\` - Legal Expenses Insurance
* \`entities.liability_insurance\` - Liability Insurance
* \`entities.first_instance_court\` - First Instance Court
* \`entities.second_instance_court\` - Second Instance Court
* \`entities.third_instance_court\` - Third Instance Court
* \`entities.contact_person\` - Contact Person
* \`entities.public_prosecutor\` - Public Prosecutor
* \`entities.third_party_debtor\` - Third Party Debtor
* \`entities.road_traffic_office\` - Road Traffic Office
* \`entities.debt_collection_agency\` - Debt Collection Agency
* \`entities.expert\` - Expert
* \`entities.tax_office\` - Tax Office
* \`entities.land_registry\` - Land Registry
* \`entities.bank\` - Bank
* \`entities.buyer\` - Buyer
* \`entities.dunning_court\` - Dunning Court
* \`entities.enforcement_court\` - Enforcement Court
* \`entities.general_prosecutor\` - General Prosecutor
* \`entities.seller\` - Seller
* \`entities.expert_committee\` - Expert Committee
* \`entities.municipality\` - Municipality
* \`entities.administrator\` - Administrator
* \`entities.register_court\` - Register Court
* \`entities.probate_court\` - Probate Court
* \`entities.registry_office\` - Registry Office
* \`entities.hereditary_leaseholder\` - Hereditary Leaseholder
* \`entities.legal_aid_court\` - Legal Aid Court
* \`entities.secondary_client\` - Secondary Client
* \`entities.secondary_opponent\` - Secondary Opponent
* \`entities.court_complaint\` - Court Complaint
* \`entities.fine_authority\` - Fine Authority
* \`entities.resident_registration_office\` - Resident Registration Office
* \`entities.investigator\` - Investigator
* \`entities.bailiff\` - Bailiff
* \`entities.insolvency_court\` - Insolvency Court
* \`entities.integration_office\` - Integration Office
* \`entities.mahn_court\` - Mahn Court
* \`entities.execution_court\` - Execution Court
* \`entities.execution_organ\` - Execution Organ
* \`entities.debtor\` - Debtor
* \`entities.creditor\` - Creditor
* \`entities.lessee\` - Lessee
* \`entities.lessor\` - Lessor
* \`entities.principal\` - Principal
* \`entities.authorized_representative\` - Authorized Representative
* \`entities.testator\` - Testator
* \`entities.heir\` - Heir
* \`entities.preliminary_heir\` - Preliminary Heir
* \`entities.subsequent_heir\` - Subsequent Heir
* \`entities.curator_of_the_estate\` - Curator Of The Estate
* \`entities.executor_of_the_will\` - Executor Of The Will
* \`entities.estate_administrator\` - Estate Administrator
* \`entities.compulsory_portion_beneficiary\` - Compulsory Portion Beneficiary`
} as const;

export const $ReplaceableVariables = {
    type: 'object',
    title: 'ReplaceableVariables',
    properties: {
        placeholders: {
            '$ref': '#/components/schemas/PlaceholderValueSuggestions',
            nullable: true
        },
        blocks: {
            '$ref': '#/components/schemas/BlockEvaluation',
            nullable: true
        }
    }
} as const;

export const $Role5ccEnum = {
    enum: ['LAWYER', 'ADMIN', 'CLERK', 'CLIENT'],
    type: 'string',
    description: `* \`LAWYER\` - Anwalt
* \`ADMIN\` - Kanzlei-Administrator
* \`CLERK\` - Sachbearbeiter
* \`CLIENT\` - Mandant`
} as const;

export const $SchemaExternalIntegrationCaseCreationRequest = {
    type: 'object',
    properties: {
        integrationType: {
            '$ref': '#/components/schemas/IntegrationTypeEnum'
        },
        mandateId: {
            type: 'integer'
        },
        integrationSpecificData: {
            '$ref': '#/components/schemas/IntegrationSpecificDataRequest'
        }
    },
    required: ['integrationSpecificData', 'integrationType', 'mandateId']
} as const;

export const $SessionStateEnum = {
    enum: ['READY', 'UPDATING_CONTEXT', 'SEARCHING_DOCUMENTS', 'REASONING'],
    type: 'string',
    description: `* \`READY\` - Ready
* \`UPDATING_CONTEXT\` - Updating Context
* \`SEARCHING_DOCUMENTS\` - Searching Documents
* \`REASONING\` - Reasoning`
} as const;

export const $ShallowCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/ShallowEntity'
        },
        opponent: {
            '$ref': '#/components/schemas/ShallowEntity'
        },
        law: {
            '$ref': '#/components/schemas/ShallowLawData'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $ShallowCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/ShallowEntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/ShallowEntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/ShallowLawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $ShallowEntity = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            }
        }
    },
    required: ['changes', 'entity_type', 'is_company']
} as const;

export const $ShallowEntityRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            }
        }
    },
    required: ['changes', 'entity_type']
} as const;

export const $ShallowLawData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_wanring_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Abfindung Höhe'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            title: 'Schadenumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttagen'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag der Tagessatz'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewärung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse Mietobjekt',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung Mietobjekt',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn Pachtvertrag'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Pachtvertrag'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    },
    required: ['created_at', 'updated_at']
} as const;

export const $ShallowLawDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_wanring_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Abfindung Höhe'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            minLength: 1,
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            minLength: 1,
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            minLength: 1,
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            minLength: 1,
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            minLength: 1,
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            minLength: 1,
            title: 'Schadenumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            minLength: 1,
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            minLength: 1,
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            minLength: 1,
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttagen'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag der Tagessatz'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewärung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse Mietobjekt',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung Mietobjekt',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn Pachtvertrag'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Pachtvertrag'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    }
} as const;

export const $StateEnum = {
    enum: ['NEW', 'IN_PROGRESS', 'COMPLETED', 'REJECTED'],
    type: 'string',
    description: `* \`NEW\` - neu
* \`IN_PROGRESS\` - in Bearbeitung
* \`COMPLETED\` - abgeschlossen
* \`REJECTED\` - abgelehnt`
} as const;

export const $Status6d9Enum = {
    enum: ['CONFIRMED', 'TENTATIVE', 'CANCELLED', 'UNKNOWN'],
    type: 'string',
    description: `* \`CONFIRMED\` - Bestätigt
* \`TENTATIVE\` - Unbestätigt
* \`CANCELLED\` - Abgesagt
* \`UNKNOWN\` - Unbekannt`
} as const;

export const $StripeInvoiceExportRequestRequest = {
    type: 'object',
    properties: {
        month: {
            type: 'integer',
            maximum: 12,
            minimum: 1
        },
        year: {
            type: 'integer',
            maximum: 2025,
            minimum: 2000
        }
    },
    required: ['month', 'year']
} as const;

export const $StripeInvoiceExportResponse = {
    type: 'object',
    properties: {
        success: {
            type: 'boolean'
        },
        error: {
            type: 'string',
            default: ''
        },
        url: {
            type: 'string',
            format: 'uri',
            default: ''
        }
    },
    required: ['success']
} as const;

export const $SuperUserAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $SuperUserAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $SuperUserAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $SuperUserAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $SuperUserAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $SuperUserAiAugmentationRequest = {
    type: 'object',
    properties: {
        document: {
            '$ref': '#/components/schemas/DocumentRequest'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['document', 'explanation', 'referenced_document_pages', 'value']
} as const;

export const $SuperUserAppointment = {
    type: 'object',
    description: 'Appointment representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['calendar', 'end', 'service', 'start', 'status']
} as const;

export const $SuperUserAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true,
            maxLength: 512
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'location_type', 'message', 'service', 'slug', 'start']
} as const;

export const $SuperUserAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 512
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'message', 'service_uuid', 'start']
} as const;

export const $SuperUserAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            minLength: 1,
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/Status6d9Enum'
        }
    },
    required: ['end', 'start', 'status']
} as const;

export const $SuperUserCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $SuperUserCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $SuperUserCall = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        user_phone_number: {
            type: 'string',
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        phone_number: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserPhoneNumber'
                }
            ],
            readOnly: true
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        audio_recording_url: {
            type: 'string',
            nullable: true,
            description: 'Return the URL of the audio recording of the call.',
            readOnly: true
        },
        langfuse_traces_url: {
            type: 'string',
            description: 'Return the URL of the langfuse traces of the call.',
            readOnly: true
        },
        retell_dashboard_url: {
            type: 'string',
            description: 'Return the URL of the retell dashboard of the call.',
            readOnly: true
        },
        twilio_console_url: {
            type: 'string',
            description: 'Return the URL of the twilio console of the call.',
            readOnly: true
        },
        transcript: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CallTranscriptMessage'
            },
            readOnly: true
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResult'
        },
        user_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCallUserFeedback'
                }
            ],
            readOnly: true,
            nullable: true
        },
        lawyer_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserLawyerFeedback'
                }
            ],
            readOnly: true
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        is_rated: {
            type: 'boolean',
            readOnly: true
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        }
    },
    required: ['audio_recording_url', 'case_uuid', 'is_rated', 'langfuse_traces_url', 'lawyer_feedback', 'phone_number', 'phone_number_uuid', 'retell_dashboard_url', 'transcript', 'twilio_console_url', 'user_feedback', 'user_phone_number', 'uuid']
} as const;

export const $SuperUserCallRequest = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        user_phone_number: {
            type: 'string',
            minLength: 1,
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResultRequest'
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        }
    },
    required: ['phone_number_uuid', 'user_phone_number']
} as const;

export const $SuperUserCallResult = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        classification: {
            '$ref': '#/components/schemas/ClassificationEnum'
        },
        inquiry: {
            type: 'string'
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseData'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        }
    },
    required: ['classification', 'data', 'uuid']
} as const;

export const $SuperUserCallResultRequest = {
    type: 'object',
    properties: {
        classification: {
            '$ref': '#/components/schemas/ClassificationEnum'
        },
        inquiry: {
            type: 'string'
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseDataRequest'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        }
    },
    required: ['classification', 'data']
} as const;

export const $SuperUserCallUserFeedback = {
    type: 'object',
    description: 'Call user feedback representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        would_call_again: {
            type: 'boolean'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 255
        },
        phone: {
            type: 'string',
            maxLength: 255
        },
        first_name: {
            type: 'string',
            maxLength: 255
        },
        last_name: {
            type: 'string',
            maxLength: 255
        },
        is_submitted: {
            type: 'boolean'
        }
    },
    required: ['uuid']
} as const;

export const $SuperUserCallUserFeedbackRequest = {
    type: 'object',
    description: 'Call user feedback representation for super users.',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        would_call_again: {
            type: 'boolean'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 255
        },
        phone: {
            type: 'string',
            maxLength: 255
        },
        first_name: {
            type: 'string',
            maxLength: 255
        },
        last_name: {
            type: 'string',
            maxLength: 255
        },
        is_submitted: {
            type: 'boolean'
        }
    }
} as const;

export const $SuperUserCase = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisationUser'
                }
            ],
            readOnly: true
        },
        appointments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserAppointment'
            },
            readOnly: true
        },
        appointment_proposals: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserAppointmentProposal'
            },
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        }
    },
    required: ['appointment_proposals', 'appointments', 'chat_sessions', 'clerk', 'data', 'documents', 'form_requests', 'id', 'modified_at', 'org', 'questionnaire_submissions', 'uuid']
} as const;

export const $SuperUserCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $SuperUserCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/SuperUserOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $SuperUserCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $SuperUserCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $SuperUserCaseRequest = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            minLength: 1,
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    },
    required: ['data']
} as const;

export const $SuperUserDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $SuperUserDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $SuperUserEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        }
    },
    required: ['bcc', 'cc', 'from_email', 'subject', 'to', 'uuid']
} as const;

export const $SuperUserEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserForm'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $SuperUserEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $SuperUserEntity = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $SuperUserEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/SuperUserOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $SuperUserEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $SuperUserEntityRequest = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $SuperUserEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/SuperUserEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $SuperUserEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/SuperUserEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $SuperUserFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        url: {
            type: 'string',
            maxLength: 255
        },
        user: {
            '$ref': '#/components/schemas/SuperUserUser'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['created_at', 'feature', 'rating', 'related_data', 'url', 'user', 'uuid']
} as const;

export const $SuperUserFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        user: {
            '$ref': '#/components/schemas/SuperUserUserRequest'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['feature', 'rating', 'related_data', 'url', 'user']
} as const;

export const $SuperUserForm = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'due_at', 'id', 'modified_at', 'organisation', 'organisation_uuid']
} as const;

export const $SuperUserFormRequest = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        }
    },
    required: ['organisation_uuid']
} as const;

export const $SuperUserHubSpotCompany = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        hubspot_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_archived: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        hubspot_archived_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        create_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        domain: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hs_last_modified_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hs_object_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_url: {
            type: 'string',
            readOnly: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['create_date', 'domain', 'hs_last_modified_date', 'hs_object_id', 'hubspot_archived', 'hubspot_archived_at', 'hubspot_created_at', 'hubspot_id', 'hubspot_updated_at', 'hubspot_url', 'name', 'uuid']
} as const;

export const $SuperUserHubSpotContact = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        hubspot_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_archived: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        hubspot_archived_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        create_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hs_object_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        last_modified_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        last_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['create_date', 'email', 'first_name', 'hs_object_id', 'hubspot_archived', 'hubspot_archived_at', 'hubspot_created_at', 'hubspot_id', 'hubspot_updated_at', 'last_modified_date', 'last_name', 'uuid']
} as const;

export const $SuperUserInboundEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserEmail'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        is_failed: {
            type: 'boolean'
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        reply_to: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        text: {
            type: 'string'
        },
        attachments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/InboundEmailAttachment'
            },
            readOnly: true
        }
    },
    required: ['attachments', 'cc', 'created_at', 'email', 'from_email', 'html', 'org', 'reply_to', 'subject', 'text', 'to']
} as const;

export const $SuperUserLawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        }
    },
    required: ['rating', 'uuid']
} as const;

export const $SuperUserLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['call_uuid', 'rating']
} as const;

export const $SuperUserOrganisation = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            maxLength: 64
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserStripeCustomer'
                }
            ],
            readOnly: true
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        customer_number: {
            type: 'string',
            readOnly: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserHubSpotCompany'
                }
            ],
            readOnly: true
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserOrganisationUser'
            },
            readOnly: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        },
        vitally_id: {
            type: 'string',
            readOnly: true
        },
        vitally_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        vitally_health_score: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'customer_number', 'hubspot_company', 'hubspot_company_uuid', 'inbound_email_address', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'oid', 'stripe_customer', 'stripe_customer_uuid', 'users', 'uuid', 'vitally_health_score', 'vitally_id', 'vitally_updated_at']
} as const;

export const $SuperUserOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            minLength: 1,
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            minLength: 1,
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        }
    },
    required: ['hubspot_company_uuid', 'stripe_customer_uuid']
} as const;

export const $SuperUserOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $SuperUserPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        active: {
            type: 'boolean'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        free_initial_consultation: {
            type: 'boolean',
            description: 'COMPATIBILITY: Return the old field name for the free initial consultation.',
            readOnly: true
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        phone_number_sid: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        agent: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserRetellAgent'
                }
            ],
            readOnly: true
        },
        voice_url: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        voice_method: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        status_callback: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        status_callback_method: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    },
    required: ['agent', 'created_at', 'free_initial_consultation', 'org', 'phone_number', 'phone_number_sid', 'status_callback', 'status_callback_method', 'voice_method', 'voice_url']
} as const;

export const $SuperUserPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean'
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        agent_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        org_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    },
    required: ['agent_uuid', 'org_uuid']
} as const;

export const $SuperUserQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 64
        },
        description: {
            type: 'string',
            maxLength: 128
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        },
        enabled_all_orgs: {
            type: 'boolean',
            title: 'Für alle Kanzleien freischalten'
        },
        enabled_custom_orgs: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['enabled_custom_orgs', 'schema', 'theme_color', 'title', 'uuid']
} as const;

export const $SuperUserQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string',
            maxLength: 128
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        enabled_all_orgs: {
            type: 'boolean',
            title: 'Für alle Kanzleien freischalten'
        },
        enabled_custom_orgs: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['enabled_custom_orgs', 'schema', 'title']
} as const;

export const $SuperUserQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            format: 'uri',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $SuperUserQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $SuperUserRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['form', 'id', 'response_present', 'token']
} as const;

export const $SuperUserRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['form', 'token']
} as const;

export const $SuperUserRetellAgent = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        retell_agent_id: {
            type: 'string',
            readOnly: true
        },
        agent_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        voice_id: {
            type: 'string',
            readOnly: true
        },
        llm_websocket_url: {
            type: 'string',
            readOnly: true
        },
        opt_out_sensitive_data_storage: {
            type: 'boolean',
            readOnly: true
        }
    },
    required: ['agent_name', 'llm_websocket_url', 'opt_out_sensitive_data_storage', 'retell_agent_id', 'uuid', 'voice_id']
} as const;

export const $SuperUserService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name']
} as const;

export const $SuperUserServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DurationMinsEnum'
                }
            ],
            title: 'Dauer in Minuten',
            minimum: -2147483648,
            maximum: 2147483647
        },
        buffer_mins: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BufferMinsEnum'
                }
            ],
            title: 'Puffer zwischen Terminen',
            minimum: -2147483648,
            maximum: 2147483647
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['description', 'name']
} as const;

export const $SuperUserStripeCustomer = {
    type: 'object',
    description: 'StripeCustomer representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        stripe_id: {
            type: 'string',
            readOnly: true
        },
        stripe_url: {
            type: 'string',
            readOnly: true
        },
        created: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        description: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['created', 'description', 'email', 'name', 'stripe_id', 'stripe_url', 'uuid']
} as const;

export const $SuperUserStripeInvoice = {
    type: 'object',
    description: 'StripeInvoice representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        stripe_id: {
            type: 'string',
            readOnly: true
        },
        created: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        customer: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserStripeCustomer'
                }
            ],
            readOnly: true
        },
        amount_due: {
            type: 'integer',
            readOnly: true
        },
        currency: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        invoice_pdf: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['amount_due', 'created', 'currency', 'customer', 'description', 'invoice_pdf', 'stripe_id', 'uuid']
} as const;

export const $SuperUserUser = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        }
    },
    required: ['email', 'org', 'uid']
} as const;

export const $SuperUserUserRequest = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        }
    },
    required: ['email']
} as const;

export const $SuperUserWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        ai_docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true,
            description: 'AI-generated template with placeholders'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'org', 'system_prompt', 'updated_at']
} as const;

export const $SuperUserWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        ai_docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'AI-generated template with placeholders'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $SwitchUniqueCaseDataRelationshipRequestRequest = {
    type: 'object',
    properties: {
        new_entity_relationship_which_should_hold_the_designated_relationship_uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_data_uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        }
    },
    required: ['case_data_uuid', 'new_entity_relationship_which_should_hold_the_designated_relationship_uuid', 'relationship_type']
} as const;

export const $SwitchUniqueCaseDataRelationshipResponse = {
    type: 'object',
    properties: {
        new_entity_relationship_which_should_hold_the_designated_relationship: {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        },
        entity_relationship_currently_holding_the_designated_relationship: {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        }
    },
    required: ['entity_relationship_currently_holding_the_designated_relationship', 'new_entity_relationship_which_should_hold_the_designated_relationship']
} as const;

export const $TAIChatSession = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AIChatSession'
        }
    ]
} as const;

export const $TAIChatSessionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AIChatSessionRequest'
        }
    ]
} as const;

export const $TAccount = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAccount'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccount'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccount'
        }
    ]
} as const;

export const $TAccountRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAccountRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccountRequest'
        }
    ]
} as const;

export const $TAiAnalysis = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAnalysis'
        }
    ]
} as const;

export const $TAiAnalysisRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAnalysisRequest'
        }
    ]
} as const;

export const $TAiAugmentation = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    ]
} as const;

export const $TAiAugmentationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    ]
} as const;

export const $TAiChatQuestionTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AiChatQuestionTemplate'
        }
    ]
} as const;

export const $TAiChatQuestionTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AiChatQuestionTemplateRequest'
        }
    ]
} as const;

export const $TAppointment = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointment'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccount'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccount'
        }
    ]
} as const;

export const $TAppointmentProposal = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentProposal'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAppointmentProposal'
        },
        {
            '$ref': '#/components/schemas/SuperUserAppointmentProposal'
        }
    ]
} as const;

export const $TAppointmentProposalRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAppointmentProposalRequest'
        }
    ]
} as const;

export const $TAppointmentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccountRequest'
        }
    ]
} as const;

export const $TCalendar = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCalendar'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCalendar'
        },
        {
            '$ref': '#/components/schemas/SuperUserCalendar'
        }
    ]
} as const;

export const $TCalendarRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCalendarRequest'
        }
    ]
} as const;

export const $TCall = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCall'
        },
        {
            '$ref': '#/components/schemas/SuperUserCall'
        }
    ]
} as const;

export const $TCallRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCallRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCallRequest'
        }
    ]
} as const;

export const $TCase = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientCase'
        },
        {
            '$ref': '#/components/schemas/CustomerCase'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCase'
        },
        {
            '$ref': '#/components/schemas/SuperUserCase'
        }
    ]
} as const;

export const $TCaseCreatorTempDocument = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CaseCreatorTempDocument'
        }
    ]
} as const;

export const $TCaseCreatorTempDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CaseCreatorTempDocumentRequest'
        }
    ]
} as const;

export const $TCaseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseRequest'
        }
    ]
} as const;

export const $TDocument = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Document'
        }
    ]
} as const;

export const $TDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/DocumentRequest'
        }
    ]
} as const;

export const $TDocumentTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserDocumentTemplate'
        }
    ]
} as const;

export const $TDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserDocumentTemplateRequest'
        }
    ]
} as const;

export const $TEmail = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmail'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmail'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmail'
        }
    ]
} as const;

export const $TEmailTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmailTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmailTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmailTemplate'
        }
    ]
} as const;

export const $TEmailTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmailTemplateRequest'
        }
    ]
} as const;

export const $TEntity = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientEntity'
        },
        {
            '$ref': '#/components/schemas/CustomerEntity'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntity'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntity'
        }
    ]
} as const;

export const $TEntityRemoveCaseDataRelationshipResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/EntityRemoveCaseDataRelationshipCustomerResponse'
        },
        {
            '$ref': '#/components/schemas/EntityRemoveCaseDataRelationshipSuperUserResponse'
        }
    ]
} as const;

export const $TEntityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientEntityRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerEntityRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntityRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntityRequest'
        }
    ]
} as const;

export const $TEntityWithRelationship = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntityWithRelationship'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
        }
    ]
} as const;

export const $TFeedback = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Feedback'
        },
        {
            '$ref': '#/components/schemas/SuperUserFeedback'
        }
    ]
} as const;

export const $TFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/FeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserFeedbackRequest'
        }
    ]
} as const;

export const $TForm = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientForm'
        },
        {
            '$ref': '#/components/schemas/CustomerForm'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminForm'
        },
        {
            '$ref': '#/components/schemas/SuperUserForm'
        }
    ]
} as const;

export const $TFormRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserFormRequest'
        }
    ]
} as const;

export const $TGenericDataMapper = {
    oneOf: [
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        }
    ]
} as const;

export const $TInboundEmail = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserInboundEmail'
        }
    ]
} as const;

export const $TLawyerFeedback = {
    oneOf: [
        {
            '$ref': '#/components/schemas/LawyerFeedback'
        },
        {
            '$ref': '#/components/schemas/CustomerLawyerFeedback'
        },
        {
            '$ref': '#/components/schemas/SuperUserLawyerFeedback'
        }
    ]
} as const;

export const $TLawyerFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerLawyerFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserLawyerFeedbackRequest'
        }
    ]
} as const;

export const $TOrganisation = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientOrganisation'
        },
        {
            '$ref': '#/components/schemas/CustomerOrganisation'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminOrganisation'
        },
        {
            '$ref': '#/components/schemas/SuperUserOrganisation'
        }
    ]
} as const;

export const $TOrganisationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserOrganisationRequest'
        }
    ]
} as const;

export const $TPhoneNumber = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerPhoneNumber'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminPhoneNumber'
        },
        {
            '$ref': '#/components/schemas/SuperUserPhoneNumber'
        }
    ]
} as const;

export const $TPhoneNumberRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAdminPhoneNumberRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserPhoneNumberRequest'
        }
    ]
} as const;

export const $TQuestionnaire = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerQuestionnaire'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaire'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaire'
        }
    ]
} as const;

export const $TQuestionnaireRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireRequest'
        }
    ]
} as const;

export const $TQuestionnaireSubmission = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireSubmission'
        }
    ]
} as const;

export const $TQuestionnaireSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireSubmissionRequest'
        }
    ]
} as const;

export const $TRetellAgent = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserRetellAgent'
        }
    ]
} as const;

export const $TRetellAgentRequest = {
    oneOf: []
} as const;

export const $TService = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerService'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminService'
        },
        {
            '$ref': '#/components/schemas/SuperUserService'
        }
    ]
} as const;

export const $TServiceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerServiceRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminServiceRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserServiceRequest'
        }
    ]
} as const;

export const $TStripeCustomer = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserStripeCustomer'
        }
    ]
} as const;

export const $TStripeCustomerRequest = {
    oneOf: []
} as const;

export const $TStripeInvoice = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserStripeInvoice'
        }
    ]
} as const;

export const $TStripeInvoiceRequest = {
    oneOf: []
} as const;

export const $TSwitchUniqueCaseDataRelationshipResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SwitchUniqueCaseDataRelationshipResponse'
        }
    ]
} as const;

export const $TUser = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerUser'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminUser'
        },
        {
            '$ref': '#/components/schemas/SuperUserUser'
        }
    ]
} as const;

export const $TUserRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerUserRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminUserRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserUserRequest'
        }
    ]
} as const;

export const $TWordDocumentTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerWordDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminWordDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserWordDocumentTemplate'
        }
    ]
} as const;

export const $TWordDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserWordDocumentTemplateRequest'
        }
    ]
} as const;

export const $TagRelationshipEnum = {
    enum: ['entities.opponent', 'entities.client', 'entities.other', 'entities.labor_law_employee', 'entities.labor_law_employer', 'entities.witness', 'entities.at_fault_driver', 'entities.victim_driver', 'entities.accused', 'entities.defendant', 'entities.plaintiff', 'entities.complaint', 'entities.victim', 'entities.vehicle_expert', 'entities.agency', 'entities.vehicle_owner', 'entities.insurance', 'entities.driver', 'entities.police_officer', 'entities.police_station', 'entities.judge', 'entities.court', 'entities.prosecutor', 'entities.prosecuting_office', 'entities.opposing_counsel', 'entities.expert_witness', 'entities.co_plaintiff', 'entities.probation_officer', 'entities.tenant', 'entities.landlord', 'entities.subtenant', 'entities.owner', 'entities.property_management', 'entities.real_estate_agent', 'entities.guarantor', 'entities.co_owner', 'entities.co_tenant', 'entities.tenants_association', 'entities.property_owners_association', 'entities.complainant', 'entities.applicant', 'entities.respondent', 'entities.child', 'entities.officiant', 'entities.wife', 'entities.husband', 'entities.legal_representative', 'entities.korrespondence_lawyer', 'entities.opposing_lawyer', 'entities.legal_expenses_insurance', 'entities.liability_insurance', 'entities.first_instance_court', 'entities.second_instance_court', 'entities.third_instance_court', 'entities.contact_person', 'entities.public_prosecutor', 'entities.third_party_debtor', 'entities.road_traffic_office', 'entities.debt_collection_agency', 'entities.expert', 'entities.tax_office', 'entities.land_registry', 'entities.bank', 'entities.buyer', 'entities.dunning_court', 'entities.enforcement_court', 'entities.general_prosecutor', 'entities.seller', 'entities.expert_committee', 'entities.municipality', 'entities.administrator', 'entities.register_court', 'entities.probate_court', 'entities.registry_office', 'entities.hereditary_leaseholder', 'entities.legal_aid_court', 'entities.secondary_client', 'entities.secondary_opponent', 'entities.court_complaint', 'entities.fine_authority', 'entities.resident_registration_office', 'entities.investigator', 'entities.bailiff', 'entities.insolvency_court', 'entities.integration_office', 'entities.mahn_court', 'entities.execution_court', 'entities.execution_organ', 'entities.debtor', 'entities.creditor', 'entities.lessee', 'entities.lessor', 'entities.principal', 'entities.authorized_representative', 'entities.testator', 'entities.heir', 'entities.preliminary_heir', 'entities.subsequent_heir', 'entities.curator_of_the_estate', 'entities.executor_of_the_will', 'entities.estate_administrator', 'entities.compulsory_portion_beneficiary'],
    type: 'string',
    description: `* \`entities.opponent\` - Opponent
* \`entities.client\` - Client
* \`entities.other\` - Other
* \`entities.labor_law_employee\` - Labor Law Employee
* \`entities.labor_law_employer\` - Labor Law Employer
* \`entities.witness\` - Witness
* \`entities.at_fault_driver\` - At Fault Driver
* \`entities.victim_driver\` - Victim Driver
* \`entities.accused\` - Accused
* \`entities.defendant\` - Defendant
* \`entities.plaintiff\` - Plaintiff
* \`entities.complaint\` - Complaint
* \`entities.victim\` - Victim
* \`entities.vehicle_expert\` - Vehicle Expert
* \`entities.agency\` - Agency
* \`entities.vehicle_owner\` - Vehicle Owner
* \`entities.insurance\` - Insurance
* \`entities.driver\` - Driver
* \`entities.police_officer\` - Police Officer
* \`entities.police_station\` - Police Station
* \`entities.judge\` - Judge
* \`entities.court\` - Court
* \`entities.prosecutor\` - Prosecutor
* \`entities.prosecuting_office\` - Prosecuting Office
* \`entities.opposing_counsel\` - Opposing Counsel
* \`entities.expert_witness\` - Expert Witness
* \`entities.co_plaintiff\` - Co Plaintiff
* \`entities.probation_officer\` - Probation Officer
* \`entities.tenant\` - Tenant
* \`entities.landlord\` - Landlord
* \`entities.subtenant\` - Subtenant
* \`entities.owner\` - Owner
* \`entities.property_management\` - Property Management
* \`entities.real_estate_agent\` - Real Estate Agent
* \`entities.guarantor\` - Guarantor
* \`entities.co_owner\` - Co Owner
* \`entities.co_tenant\` - Co Tenant
* \`entities.tenants_association\` - Tenants Association
* \`entities.property_owners_association\` - Property Owners Association
* \`entities.complainant\` - Complainant
* \`entities.applicant\` - Applicant
* \`entities.respondent\` - Respondent
* \`entities.child\` - Child
* \`entities.officiant\` - Officiant
* \`entities.wife\` - Wife
* \`entities.husband\` - Husband
* \`entities.legal_representative\` - Legal Representative
* \`entities.korrespondence_lawyer\` - Korrespondence Lawyer
* \`entities.opposing_lawyer\` - Opposing Lawyer
* \`entities.legal_expenses_insurance\` - Legal Expenses Insurance
* \`entities.liability_insurance\` - Liability Insurance
* \`entities.first_instance_court\` - First Instance Court
* \`entities.second_instance_court\` - Second Instance Court
* \`entities.third_instance_court\` - Third Instance Court
* \`entities.contact_person\` - Contact Person
* \`entities.public_prosecutor\` - Public Prosecutor
* \`entities.third_party_debtor\` - Third Party Debtor
* \`entities.road_traffic_office\` - Road Traffic Office
* \`entities.debt_collection_agency\` - Debt Collection Agency
* \`entities.expert\` - Expert
* \`entities.tax_office\` - Tax Office
* \`entities.land_registry\` - Land Registry
* \`entities.bank\` - Bank
* \`entities.buyer\` - Buyer
* \`entities.dunning_court\` - Dunning Court
* \`entities.enforcement_court\` - Enforcement Court
* \`entities.general_prosecutor\` - General Prosecutor
* \`entities.seller\` - Seller
* \`entities.expert_committee\` - Expert Committee
* \`entities.municipality\` - Municipality
* \`entities.administrator\` - Administrator
* \`entities.register_court\` - Register Court
* \`entities.probate_court\` - Probate Court
* \`entities.registry_office\` - Registry Office
* \`entities.hereditary_leaseholder\` - Hereditary Leaseholder
* \`entities.legal_aid_court\` - Legal Aid Court
* \`entities.secondary_client\` - Secondary Client
* \`entities.secondary_opponent\` - Secondary Opponent
* \`entities.court_complaint\` - Court Complaint
* \`entities.fine_authority\` - Fine Authority
* \`entities.resident_registration_office\` - Resident Registration Office
* \`entities.investigator\` - Investigator
* \`entities.bailiff\` - Bailiff
* \`entities.insolvency_court\` - Insolvency Court
* \`entities.integration_office\` - Integration Office
* \`entities.mahn_court\` - Mahn Court
* \`entities.execution_court\` - Execution Court
* \`entities.execution_organ\` - Execution Organ
* \`entities.debtor\` - Debtor
* \`entities.creditor\` - Creditor
* \`entities.lessee\` - Lessee
* \`entities.lessor\` - Lessor
* \`entities.principal\` - Principal
* \`entities.authorized_representative\` - Authorized Representative
* \`entities.testator\` - Testator
* \`entities.heir\` - Heir
* \`entities.preliminary_heir\` - Preliminary Heir
* \`entities.subsequent_heir\` - Subsequent Heir
* \`entities.curator_of_the_estate\` - Curator Of The Estate
* \`entities.executor_of_the_will\` - Executor Of The Will
* \`entities.estate_administrator\` - Estate Administrator
* \`entities.compulsory_portion_beneficiary\` - Compulsory Portion Beneficiary`
} as const;

export const $TitleEnum = {
    enum: ['Herr', 'Frau', 'Divers'],
    type: 'string',
    description: `* \`\` - 
* \`Herr\` - Herr
* \`Frau\` - Frau
* \`Divers\` - Divers`
} as const;

export const $TopicEnum = {
    enum: ['AGB', 'Abfindung', 'Abmahnung', 'Abmahnung Wettbewerbsrecht', 'Abschiebungshaft', 'Abschlussarbeit', 'Abstandsregelung nicht eingehalten', 'Account hacking', 'Allgemein', 'Allgemeines Prüfungsrecht', 'Anderes', 'Arbeitsamt/ALG/Sperrzeit', 'Arbeitsunfall', 'Arbeitsvertrag', 'Arbeitszeugnis', 'Aufbau Compliancesystem', 'Aufenthaltserlaubnis', 'Aufhebungsvertrag', 'Auftragsdatenverarbeitung', 'Auseinandersetzung Erbengemeinschaft', 'Auskunft prüfen', 'Ausweisung', 'Autokauf', 'Bankkonto leergeräumt', 'Bankrecht', 'Baumangel', 'Bauvertrag', 'Behandlungsfehler Allgemein', 'Behandlungsfehler Querschnittslähmung', 'Behandlungsfehler Schlaganfall', 'Beißvorfall', 'Beratung zu Erbfall', 'Beschlagnahme Allgemein', 'Beschlagnahme Tierquälerei', 'Betreuungsrecht', 'Betrug Geldanlage', 'Betäubungsmittel', 'Burgschild Inkasso', 'Bußgeldbescheid', 'Bürgergeld', 'Coaching', 'Datenschutz', 'Datenschutz Schadensersatz', 'Datenschutzverstoß', 'Domains', 'Ehevertrag', 'Eigentumsdelikte', 'Einbürgerung', 'Einreisesperre', 'Eintrag löschen', 'Erbauseinandersetzung', 'Erbausschlagung', 'Erben/Schenken', 'Erbengemeinschaft', 'Erbschein', 'Erbscheinsantrag', 'Erbvertrag', 'Exmatrikulation', 'Fahren ohne Führerschein', 'Fahren unter Alkohol - / Drogeneinfluss', 'Fahrer - / Unfallflucht', 'Fahrverbot / Führerscheinentzug', 'Falschaussage/ Meineid', 'Familie Vorsorge', 'Forderung löschen', 'Geburtsfehler', 'Geburtsfehler Mutter', 'Geschwindigkeitsüberschreitung', 'Gesetzliche Erbfolge', 'Gewerblicher Rechtsschutz', 'Grundschuld', 'Gründung', 'Handy am Steuer', 'Hauskauf', 'Härtefallantrag', 'Immobilien', 'Kaufvertragsprüfung', 'Körperverletzung', 'Kündigung', 'Lohnzahlung', 'Markenanmeldung', 'Markenverteidigung', 'Markenüberwachung', 'Mieterhöhung', 'Mietkaution', 'Mietminderung', 'Mietvertrag', 'Nebenkostenabrechnung', 'Niederlassungserlaubnis', 'Nutzerbewertungen Verfasser', 'Patientenverfügung/Vorsorgevollmacht', 'Personenverwechselung', 'Pflege-/Krankenversicherung', 'Pflichtteil', 'Pflichtteil Geltendmachung', 'Pflichtteil abwehren', 'Plagiatsvorwurf', 'Remonstration', 'Rente', 'Rotlichtverstoß', 'Räumungsklage', 'Schadensersatz', 'Scheidung', 'Schenkung', 'Schenkung Immobilie', 'Schulplatz einklagen', 'Schwerbehinderung', 'Sexualdelikt', 'Software Hardware', 'Sonstige Beglaubigung', 'Sorgerecht und Umgangsrecht', 'Testament', 'Testament/Erbvertrag', 'Tierkauf', 'Tierärztliche Behandlungsfehler', 'Trennung', 'Tuning', 'Täuschungsversuch', 'Tötungsdelikte', 'Unfall Querschnittslähmung', 'Unfall mit Personenschaden', 'Unterhalt', 'Unternehmen', 'Unternehmensauflösung', 'Unternehmensgründung', 'Unternehmenskauf', 'Urheberrecht', 'Urlaub', 'Vaterschaftsanerkennung', 'Vererben', 'Verkehrsunfall', 'Vermögensauseinandersetzung', 'Vermögensdelikte', 'Verstoß gegen die Anschnallpflicht', 'Vertragsprüfung', 'Vertragsrecht', 'Visum', 'Vorfälligkeitsentschädigung', 'Vorsorge', 'Vorsorgevollmacht/Patientenverfügung', 'Waffendelikte', 'Wettbewerbsrecht', 'Widerrufsrechte', 'Widerspruch/ Klage', 'Wucherzinsen Darlehen', 'Zugewinnausgleich', 'Zweiradunfall', 'unbezahlte Rechnungen', 'unerlaubtes Glücksspiel', 'Überstunden', 'Übertragung zu Lebzeiten'],
    type: 'string',
    description: `* \`AGB\` - Agb
* \`Abfindung\` - Abfindung
* \`Abmahnung\` - Abmahnung
* \`Abmahnung Wettbewerbsrecht\` - Abmahnung Wettbewerbsrecht
* \`Abschiebungshaft\` - Abschiebungshaft
* \`Abschlussarbeit\` - Abschlussarbeit
* \`Abstandsregelung nicht eingehalten\` - Abstandsregelung Nicht Eingehalten
* \`Account hacking\` - Account Hacking
* \`Allgemein\` - Allgemein
* \`Allgemeines Prüfungsrecht\` - Allgemeines Prüfungsrecht
* \`Anderes\` - Anderes
* \`Arbeitsamt/ALG/Sperrzeit\` - Arbeitsamt/Alg/Sperrzeit
* \`Arbeitsunfall\` - Arbeitsunfall
* \`Arbeitsvertrag\` - Arbeitsvertrag
* \`Arbeitszeugnis\` - Arbeitszeugnis
* \`Aufbau Compliancesystem\` - Aufbau Compliancesystem
* \`Aufenthaltserlaubnis\` - Aufenthaltserlaubnis
* \`Aufhebungsvertrag\` - Aufhebungsvertrag
* \`Auftragsdatenverarbeitung\` - Auftragsdatenverarbeitung
* \`Auseinandersetzung Erbengemeinschaft\` - Auseinandersetzung Erbengemeinschaft
* \`Auskunft prüfen\` - Auskunft Prüfen
* \`Ausweisung\` - Ausweisung
* \`Autokauf\` - Autokauf
* \`Bankkonto leergeräumt\` - Bankkonto Leergeräumt
* \`Bankrecht\` - Bankrecht
* \`Baumangel\` - Baumangel
* \`Bauvertrag\` - Bauvertrag
* \`Behandlungsfehler Allgemein\` - Behandlungsfehler Allgemein
* \`Behandlungsfehler Querschnittslähmung\` - Behandlungsfehler Querschnittslähmung
* \`Behandlungsfehler Schlaganfall\` - Behandlungsfehler Schlaganfall
* \`Beißvorfall\` - Beißvorfall
* \`Beratung zu Erbfall\` - Beratung Zu Erbfall
* \`Beschlagnahme Allgemein\` - Beschlagnahme Allgemein
* \`Beschlagnahme Tierquälerei\` - Beschlagnahme Tierquälerei
* \`Betreuungsrecht\` - Betreuungsrecht
* \`Betrug Geldanlage\` - Betrug Geldanlage
* \`Betäubungsmittel\` - Betäubungsmittel
* \`Burgschild Inkasso\` - Burgschild Inkasso
* \`Bußgeldbescheid\` - Bußgeldbescheid
* \`Bürgergeld\` - Bürgergeld
* \`Coaching\` - Coaching
* \`Datenschutz\` - Datenschutz
* \`Datenschutz Schadensersatz\` - Datenschutz Schadensersatz
* \`Datenschutzverstoß\` - Datenschutzverstoß
* \`Domains\` - Domains
* \`Ehevertrag\` - Ehevertrag
* \`Eigentumsdelikte\` - Eigentumsdelikte
* \`Einbürgerung\` - Einbürgerung
* \`Einreisesperre\` - Einreisesperre
* \`Eintrag löschen\` - Eintrag Löschen
* \`Erbauseinandersetzung\` - Erbauseinandersetzung
* \`Erbausschlagung\` - Erbausschlagung
* \`Erben/Schenken\` - Erben/Schenken
* \`Erbengemeinschaft\` - Erbengemeinschaft
* \`Erbschein\` - Erbschein
* \`Erbscheinsantrag\` - Erbscheinsantrag
* \`Erbvertrag\` - Erbvertrag
* \`Exmatrikulation\` - Exmatrikulation
* \`Fahren ohne Führerschein\` - Fahren Ohne Führerschein
* \`Fahren unter Alkohol - / Drogeneinfluss\` - Fahren Unter Alkohol - / Drogeneinfluss
* \`Fahrer - / Unfallflucht\` - Fahrer - / Unfallflucht
* \`Fahrverbot / Führerscheinentzug\` - Fahrverbot / Führerscheinentzug
* \`Falschaussage/ Meineid\` - Falschaussage/ Meineid
* \`Familie Vorsorge\` - Familie Vorsorge
* \`Forderung löschen\` - Forderung Löschen
* \`Geburtsfehler\` - Geburtsfehler
* \`Geburtsfehler Mutter\` - Geburtsfehler Mutter
* \`Geschwindigkeitsüberschreitung\` - Geschwindigkeitsüberschreitung
* \`Gesetzliche Erbfolge\` - Gesetzliche Erbfolge
* \`Gewerblicher Rechtsschutz\` - Gewerblicher Rechtsschutz
* \`Grundschuld\` - Grundschuld
* \`Gründung\` - Gründung
* \`Handy am Steuer\` - Handy Am Steuer
* \`Hauskauf\` - Hauskauf
* \`Härtefallantrag\` - Härtefallantrag
* \`Immobilien\` - Immobilien
* \`Kaufvertragsprüfung\` - Kaufvertragsprüfung
* \`Körperverletzung\` - Körperverletzung
* \`Kündigung\` - Kündigung
* \`Lohnzahlung\` - Lohnzahlung
* \`Markenanmeldung\` - Markenanmeldung
* \`Markenverteidigung\` - Markenverteidigung
* \`Markenüberwachung\` - Markenüberwachung
* \`Mieterhöhung\` - Mieterhöhung
* \`Mietkaution\` - Mietkaution
* \`Mietminderung\` - Mietminderung
* \`Mietvertrag\` - Mietvertrag
* \`Nebenkostenabrechnung\` - Nebenkostenabrechnung
* \`Niederlassungserlaubnis\` - Niederlassungserlaubnis
* \`Nutzerbewertungen Verfasser\` - Nutzerbewertungen Verfasser
* \`Patientenverfügung/Vorsorgevollmacht\` - Patientenverfügung/Vorsorgevollmacht
* \`Personenverwechselung\` - Personenverwechselung
* \`Pflege-/Krankenversicherung\` - Pflege-/Krankenversicherung
* \`Pflichtteil\` - Pflichtteil
* \`Pflichtteil Geltendmachung\` - Pflichtteil Geltendmachung
* \`Pflichtteil abwehren\` - Pflichtteil Abwehren
* \`Plagiatsvorwurf\` - Plagiatsvorwurf
* \`Remonstration\` - Remonstration
* \`Rente\` - Rente
* \`Rotlichtverstoß\` - Rotlichtverstoß
* \`Räumungsklage\` - Räumungsklage
* \`Schadensersatz\` - Schadensersatz
* \`Scheidung\` - Scheidung
* \`Schenkung\` - Schenkung
* \`Schenkung Immobilie\` - Schenkung Immobilie
* \`Schulplatz einklagen\` - Schulplatz Einklagen
* \`Schwerbehinderung\` - Schwerbehinderung
* \`Sexualdelikt\` - Sexualdelikt
* \`Software Hardware\` - Software Hardware
* \`Sonstige Beglaubigung\` - Sonstige Beglaubigung
* \`Sorgerecht und Umgangsrecht\` - Sorgerecht Und Umgangsrecht
* \`Testament\` - Testament
* \`Testament/Erbvertrag\` - Testament/Erbvertrag
* \`Tierkauf\` - Tierkauf
* \`Tierärztliche Behandlungsfehler\` - Tierärztliche Behandlungsfehler
* \`Trennung\` - Trennung
* \`Tuning\` - Tuning
* \`Täuschungsversuch\` - Täuschungsversuch
* \`Tötungsdelikte\` - Tötungsdelikte
* \`Unfall Querschnittslähmung\` - Unfall Querschnittslähmung
* \`Unfall mit Personenschaden\` - Unfall Mit Personenschaden
* \`Unterhalt\` - Unterhalt
* \`Unternehmen\` - Unternehmen
* \`Unternehmensauflösung\` - Unternehmensauflösung
* \`Unternehmensgründung\` - Unternehmensgründung
* \`Unternehmenskauf\` - Unternehmenskauf
* \`Urheberrecht\` - Urheberrecht
* \`Urlaub\` - Urlaub
* \`Vaterschaftsanerkennung\` - Vaterschaftsanerkennung
* \`Vererben\` - Vererben
* \`Verkehrsunfall\` - Verkehrsunfall
* \`Vermögensauseinandersetzung\` - Vermögensauseinandersetzung
* \`Vermögensdelikte\` - Vermögensdelikte
* \`Verstoß gegen die Anschnallpflicht\` - Verstoß Gegen Die Anschnallpflicht
* \`Vertragsprüfung\` - Vertragsprüfung
* \`Vertragsrecht\` - Vertragsrecht
* \`Visum\` - Visum
* \`Vorfälligkeitsentschädigung\` - Vorfälligkeitsentschädigung
* \`Vorsorge\` - Vorsorge
* \`Vorsorgevollmacht/Patientenverfügung\` - Vorsorgevollmacht/Patientenverfügung
* \`Waffendelikte\` - Waffendelikte
* \`Wettbewerbsrecht\` - Wettbewerbsrecht
* \`Widerrufsrechte\` - Widerrufsrechte
* \`Widerspruch/ Klage\` - Widerspruch/ Klage
* \`Wucherzinsen Darlehen\` - Wucherzinsen Darlehen
* \`Zugewinnausgleich\` - Zugewinnausgleich
* \`Zweiradunfall\` - Zweiradunfall
* \`unbezahlte Rechnungen\` - Unbezahlte Rechnungen
* \`unerlaubtes Glücksspiel\` - Unerlaubtes Glücksspiel
* \`Überstunden\` - Überstunden
* \`Übertragung zu Lebzeiten\` - Übertragung Zu Lebzeiten`
} as const;

export const $TrackingEventRequest = {
    type: 'object',
    properties: {
        user: {
            type: 'string',
            minLength: 1
        },
        name: {
            type: 'string',
            minLength: 1
        },
        organization_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['name', 'organization_uuid', 'user']
} as const;

export const $UUIDCaseCreatorEntity = {
    type: 'object',
    title: 'UUIDCaseCreatorEntity',
    properties: {
        entity_type: {
            '$ref': '#/components/schemas/EntityTypeC7aEnum'
        },
        company_legal_form: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UUIDCaseCreatorEntityCompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_name: {
            type: 'string',
            nullable: true
        },
        institution_name: {
            type: 'string',
            nullable: true
        },
        title: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            nullable: true
        },
        last_name: {
            type: 'string',
            nullable: true
        },
        phone: {
            type: 'string',
            nullable: true
        },
        email: {
            type: 'string',
            nullable: true
        },
        date_of_birth: {
            type: 'string',
            nullable: true
        },
        street: {
            type: 'string',
            nullable: true
        },
        street_number: {
            type: 'string',
            nullable: true
        },
        zip: {
            type: 'string',
            nullable: true
        },
        city: {
            type: 'string',
            nullable: true
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true
        },
        legal_insurance_number: {
            type: 'string',
            nullable: true
        },
        legal_insurance_name: {
            type: 'string',
            nullable: true
        },
        uuid: {
            type: 'string'
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    },
    required: ['entity_type', 'uuid']
} as const;

export const $UUIDCaseCreatorEntityCompanyLegalFormEnum = {
    type: 'string',
    enum: ['GmbH', 'UG', 'GmbH & Co. KG', 'GBR', 'OHG', 'KG', 'AG', 'SE', 'eG', 'eV', 'AG & Co. KG']
} as const;

export const $UUIDExtractedLawData = {
    type: 'object',
    title: 'UUIDExtractedLawData',
    properties: {
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            nullable: true
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            nullable: true
        },
        uuid: {
            type: 'string'
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid']
} as const;

export const $UUIDExtractionResult = {
    type: 'object',
    title: 'UUIDExtractionResult',
    properties: {
        extracted_entities: {
            '$ref': '#/components/schemas/UUIDCaseCreatorEntity'
        },
        extracted_law_data: {
            '$ref': '#/components/schemas/UUIDExtractedLawData',
            nullable: true
        }
    },
    required: ['extracted_entities']
} as const;

export const $UploadOriginEnum = {
    enum: ['None', 'Chatbot Upload', 'Email Anhang', 'Terminbuchung', 'Fragebogen', 'Manuell hinzugefügt', 'AI CASE CHAT'],
    type: 'string',
    description: `* \`None\` - Not Set
* \`Chatbot Upload\` - Chatbot
* \`Email Anhang\` - Email
* \`Terminbuchung\` - Appointment
* \`Fragebogen\` - Questionnaire
* \`Manuell hinzugefügt\` - Manual
* \`AI CASE CHAT\` - Ai Case Chat`
} as const;

export const $WordTemplateStatus = {
    enum: ['draft', 'in_review', 'approved'],
    type: 'string',
    description: `* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
} as const;